/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable @typescript-eslint/no-empty-interface */
/**
 * 云药房 API 接口版本：0.0.1
 * 本文件代码是由脚本能自动生成，请不要手动修改
 */

import { AxiosCancelablePromise, ApiData } from '../services/utils/axiosWrapper'
import service from '../services/index'

import baseUrl from '../services/config/baseUrl'

export interface EmptyDto {}
export interface BackendCategoryDto {
  /**
   * 后台类目id
   */
  id: number
  /**
   * 后台类目父id
   */
  pid: number
  /**
   * 分类级别
   */
  type: number
  /**
   * 后台类目名称
   */
  title: string
  /**
   * 后台类目父名称
   */
  ptitle: string
  /**
   * 后台类目下子类目数量
   */
  childCategoryCount: number
  /**
   * 后台类目下spu数量
   */
  spuCount: number
}

export interface PackFormatInfoDto {
  DoseNum: number | undefined
  Dose: number | undefined
  RowID: number | undefined
  DoseNumStr?: string
  OperSymbolId: number
}
export interface PackDto {
  /**
   * 包装规格id
   */
  id: number
  /**
   * 包装规格名称
   */
  pack: string
  /**
   * 包装规格图片
   */
  images: Array<string>
  /**
   * 用药频率
   */
  medFrequency: number
  /**
   * 单次剂量
   */
  dose: number
  /**
   * 单次剂量单位
   */
  doseUnit: number
  /**
   * 默认价格
   */
  price: number
  /**
   * 默认优惠价格
   */
  salePrice: number
  /**
   * 单盒药量
   */
  quantity: number
  /**
   * 条形码
   */
  barCode: string

  /**
   * 结构化数据
   */
  packFormatUnit: number
  packFormatNum: number
  packRemark?: string
  version: number
  infos: PackFormatInfoDto[]
}
export interface SpuCnMedEntityDto {
  /**
   * Spu Id
   */
  spuId: number
  /**
   * 药品名称
   */
  genericName: string
  /**
   * 生产单位
   */
  produceCompany: string
  /**
   * 生产许可证
   */
  productionLicenseCode: string
  /**
   * 包装类型
   */
  packType: number
  /**
   * 药品规格
   */
  specification: string
  /**
   * 首字母缩写
   */
  letterName: string
  /**
   * 别名
   */
   aliasName: string
  /**
   * 性味归经
   */
  medType: string
  /**
   * 适应症/主治功能
   */
  indication: string
  /**
   * 用法用量
   */
  usage: string
  /**
   * 注意事项
   */
  consideration: string
  /**
   * 中药类型：1 成药，2 汤药，3 颗粒
   */
  cnMedType: number
  /**
   * 是否处方药：-1 未知，0 处方药，1 OTC药
   */
  otcType: number
  /**
   * 包装单位
   */
  saleUnit: string
  /**
   * 产地
   */
  producingArea: string
  /**
   * 包装规格
   */
  packs: Array<PackDto>
  /**
   * 基础 Spu 信息
   */
  baseSpuEntity: void
  /**
   * 妊娠禁忌 0 无 1 慎用药 2 禁用药
   */
  pregnancyContraindication: number
  /**
   * 是否毒麻类 0 否 1 是
   */
  isToxic: number
  /**
   * 推荐剂量
   */
  recommendDose: string
  /**
   * 用药方法 0 无 1 先煎 2 后下 3 包煎 4 烊化 5 另煎 6 另包 7 冲服
   */
  drugUsage: Array<number>
}
export interface SpuMachineEntityDto {
  /**
   * Spu Id
   */
  spuId: number
  /**
   * 商品名称
   */
  tradeName: string
  /**
   * 通用名称
   */
  genericName: string
  /**
   * 批准文号/注册证号
   */
  approvalNumber: string
  /**
   * 生产单位
   */
  manufacturerTitle: string
  /**
   * 器械类别
   */
  genre: number
  /**
   * 结构及组成
   */
  indication: string
  /**
   * 使用范围
   */
  usage: string
  /**
   * 生产企业许可证号
   */
  manufactureLicenseNu: string
  /**
   * 产品技术要求编号
   */
  trNu: string
  /**
   * 药械注册证
   */
  machineRegistration: string
  /**
   * 禁忌
   */
  taboo: string
  /**
   * 生产单位地址
   */
  manufacturerAddress: string
  /**
   * 有效期
   */
  shelfLife: string
  /**
   * 相关标签
   */
  tags: string
  /**
   * 批准日期
   */
  approvalDate: number
  /**
   * 包装规格
   */
  packs: Array<PackDto>
  /**
   * 条形码
   */
  barCode: string
  /**
   * 基础 Spu
   */
  baseSpuEntity: void
}
export interface SpuNutritionEntiryDto {
  /**
   * Spu Id
   */
  spuId: number
  /**
   * 商品名称
   */
  tradeName: string
  /**
   * 通用名称
   */
  genericName: string
  /**
   * 批准文号/注册证号
   */
  approvalNumber: string
  /**
   * 生产单位
   */
  manufacturerTitle: string
  /**
   * 生产单位地址
   */
  manufacturerAddress: string
  /**
   * 有效期
   */
  shelfLife: string
  /**
   * 适用人群：0 全部适用，1 儿童，2 成年人，3 老人
   */
  applicablePeople: number
  /**
   * 适应症/功能主治
   */
  indication: string
  /**
   * 成分
   */
  ingredient: string
  /**
   * 用法用量
   */
  usage: string
  /**
   * 注意事项
   */
  consideration: string
  /**
   * 包装规格
   */
  packs: Array<PackDto>
  /**
   * 条形码
   */
  barCode: string
  /**
   * 基本 Spu
   */
  baseSpuEntity: void
}
export interface SpuCosmeticEntityDto {
  /**
   * Spu Id
   */
  spuId: number
  /**
   * 商品名称
   */
  tradeName: string
  /**
   * 通用名称
   */
  genericName: string
  /**
   * 批准文号/注册证号
   */
  approvalNumber: string
  /**
   * 生产单位
   */
  manufacturerTitle: string
  /**
   * 生产单位地址
   */
  manufacturerAddress: string
  /**
   * 成分
   */
  ingredient: string
  /**
   * 适应症/主治功能
   */
  indication: string
  /**
   * 用法用量
   */
  usage: string
  /**
   * 适用人群：0 全部适用，1 儿童，2 成年人，3 老人
   */
  applicablePeople: number
  /**
   * 注意事项
   */
  consideration: string
  /**
   * 有效期
   */
  shelfLife: string
  /**
   * 包装规格
   */
  packs: Array<PackDto>
  /**
   * 条形码
   */
  barCode: string
  /**
   * 基本 Spu
   */
  baseSpuEntity: void
}
export interface SpuSimpleDo {
  /**
   * spu id
   */
  id: number
  backgroundCategory: BackendCategoryDto
  backgroundCategoryPInfo: BackendCategoryDto
  backgroundCategoryPpInfo: BackendCategoryDto
  /**
   * 药品名
   */
  tradeName: string
  /**
   * 商品名
   */
  genericName: string
  /**
   * 药学分类
   */
  genre: number
  /**
   * 限制类别
   */
  restrainType: number
  /**
   * 医保类别
   */
  medicareCategoryId?: number
  /**
   * 规格
   */
  specification: string
  /**
   * 生产企业
   */
  manufacturerTitle: string
  /**
   * 批准文号/注册称号
   */
  approvalNumber: string
  /**
   * 药品本位码
   */
  standardCode: string
  /**
   * 处方类型： 0-处方；1-非处方
   */
  otcType: number
  /**
   * 给药途径
   */
  instructionsCategory: number
  /**
   * 是否自营：0 否 1 是
   */
  storeRule: number
  /**
   * 上下架：-1 下架 0 未知 1 上架
   */
  status: number
  /**
   * 是否自营
   */
  isSelf: boolean
  /**
   * 是否统一定价
   */
  isUnifiedPrice: boolean
  /**
   * 合作药企
   */
  cooperative: number
  /**
   * 售卖区域
   */
  saleZone: number
  spuCnMed: SpuCnMedEntityDto
  spuMachine: SpuMachineEntityDto
  spuNutrition: SpuNutritionEntiryDto
  spuCosmetic: SpuCosmeticEntityDto
}
export interface PriceZoneDto {
  /**
   * SPU ID
   */
  spuId: number
  /**
   * SPU 包装规格 ID
   */
  spuPackId: number
  /**
   * 区域 ID
   */
  zoneId: number
  /**
   * 区域名
   */
  zone: string
  /**
   * 省 ID
   */
  provinceId: number
  /**
   * 省
   */
  province: string
  /**
   * 零售价
   */
  price: number
  /**
   * 优惠价
   */
  salePrice: number
  spuCnMed: SpuCnMedEntityDto
}
export interface SpuChannelDto {
  /**
   * 业务渠道id
   */
  channelId: number
  spu: SpuSimpleDo
  /**
   * 是否协议药品
   */
  isAgreementMed: number
  /**
   * 服务费比例（万分之），使用百分数表示需除以100
   */
  serviceFeePercent: number
}
export interface BusinessChannelDto {
  /**
   * 业务渠道id
   */
  id: number
  /**
   * 业务渠道名称
   */
  title: string
  /**
   * sku添加业务渠道时，是否默认选中：0 否，1 是
   */
  option: number
}
export interface StockInfoDto {
  /**
   * 医联库存
   */
  medStock: number
  /**
   * 其他库存
   */
  otherStock: number
}
export interface SkuSimpleDto {
  /**
   * sku id
   */
  id: number
  /**
   * 供应商渠道名称
   */
  channelText: string
  // 药店名称
  storeText: string
  // 药店id
  storeId: number
  /**
   * 包装规格名称
   */
  packText: string
  /**
   * 零售价（分）
   */
  originPrice: number
  /**
   * 区域价格
   */
  priceZone: Array<PriceZoneDto>
  /**
   * 优惠价（分）
   */
  salePrice: number
  /**
   * 线下零售价
   */
  marketPrice: number
  /**
   * 库存
   */
  stock: number
  /**
   * 热度
   */
  hot: number
  /**
   * 上架状态：-1 未上架；1-上架
   */
  status: number
  spu: SpuSimpleDo
  /**
   * 创建人
   */
  createName: string
  /**
   * 创建人ID
   */
  creatorId: number
  spuPack: PackDto
  /**
   * ERP货品ID
   */
  erpGoodsId: number
  channelSpu: SpuChannelDto
  batchNu: string
  /**
   * 业务渠道
   */
  businessChannel: Array<BusinessChannelDto>
  /**
   * 运费模板
   */
  relatedFreights: boolean
  /**
   * 下架原因
   */
  offReason: number
  /**
   * 失效原因
   */
  invalidReason: number
  /**
   * 是否赠品：0：非赠品 1：赠品 -1：不限制筛选
   */
  isGiveaway?: number
  /**
   * 底价 (售价=底价*(1+加成比例))
   */
  basePrice?: number
  /**
   * 加成比例 加成比例的数值*100;例:70(加成比例70%)
   */
  additionPercentage?: number
  /**
   * 是否单独加成 枚举值: 1:不单独加成 2:单独加成 默认:1
   */
  aloneStatus?: number
  stockInfo: StockInfoDto
}
export interface RetrieveResDto {
  spu: SpuSimpleDo
  pack: PackDto
  sku: SkuSimpleDto
  /**
   * 审核状态
   */
  status: number
  /**
   * 申请人 Id
   */
  userId: number
  /**
   * 申请人
   */
  userName: string
  /**
   * 药店ID
   */
  storeId: number
  /**
   * 运费模版ID
   */
  freightId: number
}
export interface ChronicDiseaseDto {
  /**
   * 慢病id
   */
  id: number
  /**
   * 慢病类型
   */
  illType: number
  /**
   * 名称
   */
  title: string
  /**
   * 重定向路由
   */
  redirectRoutes: string
  /**
   * SPUID
   */
  spuId: number
}

export interface SpuTaxEntity {
  tax: number;
  taxCategoryId: number;
  taxTypeName: string;
  taxTypeNo: string;
}
export interface SpuDto {
  /**
   * spu id
   */
  id: number
  backgroundCategory: BackendCategoryDto
  backgroundCategoryPInfo: BackendCategoryDto
  backgroundCategoryPpInfo: BackendCategoryDto
  /**
   * 药品名
   */
  tradeName: string
  /**
   * 商品名
   */
  genericName: string
  /**
   * 药学分类
   */
  genre: number
  /**
   * 限制类别
   */
  restrainType: number
  /**
   * 医保类别：0-非医保；1-甲；2-乙；3-丙；4-民族药
   */
  medicareCategoryId?: number
  /**
   * 规格
   */
  specification: string
  /**
   * 生产企业
   */
  manufacturerTitle: string
  /**
   * 批准文号/注册称号
   */
  approvalNumber: string
  /**
   * 药品本位码
   */
  standardCode: string
  /**
   * 处方类型： 0-处方；1-非处方
   */
  otcType: number
  /**
   * 给药途径
   */
  instructionsCategory: number
  /**
   * 是否自营：0 否 1 是
   */
  storeRule: number
  /**
   * 上下架：-1 下架 0 未知 1 上架
   */
  status: number
  /**
   * 是否自营
   */
  isSelf: boolean
  /**
   * 是否统一定价
   */
  isUnifiedPrice: boolean
  /**
   * 合作药企
   */
  cooperative: number
  /**
   * 售卖区域
   */
  saleZone: number
  spuCnMed: SpuCnMedEntityDto
  spuMachine: SpuMachineEntityDto
  spuNutrition: SpuNutritionEntiryDto
  spuCosmetic: SpuCosmeticEntityDto
  /**
   * 相关标签
   */
  tags: string
  /**
   * 英文名称
   */
  enName?: string
  /**
   * 剂型
   */
  formulation?: string
  /**
   * 生产地址
   */
  manufacturerAddress?: string
  /**
   * 联系人
   */
  manufacturerPhone?: string
  /**
   * 批准日期
   */
  approvalDate?: number
  /**
   * 所属慢病
   */
  chronicDiseases: Array<ChronicDiseaseDto>
  /**
   * 适应症分类
   */
  indicationCategory: number
  /**
   * 有效期
   */
  shelfLife?: string
  /**
   * 功能主治
   */
  indication?: string
  /**
   * 成分
   */
  ingredient?: string
  /**
   * 用法用量
   */
  usage?: string
  /**
   * 药理作用
   */
  pharmacological?: string
  /**
   * 药动学
   */
  pharmacokinetics?: string
  /**
   * 药物相互作用
   */
  drugInteraction?: string
  /**
   * 不良反应
   */
  adverseReaction?: string
  /**
   * 禁忌
   */
  contraindication?: string
  /**
   * 特殊人群用药
   */
  specialCrowdNotice?: string
  /**
   * 注意事项
   */
  consideration?: string
  /**
   * 贮藏
   */
  storage?: string
  /**
   * 起售数量
   */
  minimumSale?: number
  /**
   * 销售单位/包装单位
   */
  saleUnit?: string
  coldChain?: number
  rushDelivery?: number
  /**
   * 包装规格
   */
  packs: Array<PackDto>
  spuTaxEntity?: SpuTaxEntity
}
export interface SpuPackRulesDto {
  /**
   * SPU PACK RULES ID
   */
  id: number
  /**
   * 包装规格名称
   */
  pack: string
  /**
   * 零售价
   */
  salePrice: number
  /**
   * 默认价
   */
  price: number
  /**
   * 区域价格
   */
  priceZoneEntity: Array<string>
}
export interface SpuSpecificStoreDto {
  /**
   * SPU ID
   */
  spuId: number
  /**
   * STORE ID
   */
  storeId: number
  /**
   * Store
   */
  store: string
}
export interface SpuSaleZoneDto {
  /**
   * SPU ID
   */
  spuId: number
  /**
   * 地区 ID
   */
  zoneId: number
  /**
   * 地区
   */
  zone: string
  /**
   * 省 ID
   */
  provinceId: number
  /**
   * 省
   */
  province: string
}
export interface RulesDto {
  /**
   * spuId
   */
  spuId: number
  /**
   * 是否自营
   */
  isSelf: boolean
  /**
   * 是否统一定价
   */
  isUnifiedPrice: boolean
  /**
   * 规则信息
   */
  spuPacks: Array<SpuPackRulesDto>
  /**
   * 合作药企
   */
  cooperative: number
  /**
   * 当药店规格为指定药店
   */
  spuSpecificStoreEntity: Array<SpuSpecificStoreDto>
  /**
   * 销售地区
   */
  spuSaleZoneEntity: Array<SpuSaleZoneDto>
  /**
   * 售卖区域 0 全国 1 部分区域
   */
  saleZone: number
  /**
   * 药店规则 仅限自营药房 0 否 1 是
   */
  storeRule: number
}
export interface ExContentDto {
  /**
   * 草稿 ID
   */
  objectId: string
  /**
   * 申请类型 0 spu 1 pack 2 sku
   */
  applyType: number
  /**
   * 药店ID
   */
  storeId: number
  /**
   * 渠道ID
   */
  channelId: number
  /**
   * 申请人ID
   */
  userId: number
  /**
   * 申请状态 0 待审核 1 通过 2 驳回
   */
  auditStatus: number
  /**
   * 审核时间
   */
  AuditTime: object
  /**
   * 审核人 ID
   */
  operatorId: object
  spuEntity: SpuDto
  skuEntity: SkuSimpleDto
  /**
   * Pack Entity
   */
  packEntitys: Array<PackDto>
  /**
   * 创建人
   */
  userName: string
  /**
   * 创建时间
   */
  createdAt: number
  /**
   * 运费模版ID
   */
  freightId: number
  /**
   * 驳回原因
   */
  remark: string
  /**
   * 渠道名称
   */
  channelName: string
  rulesEntity: RulesDto
}
export interface PaginateExContentRespDto {
  total: number
  data: Array<ExContentDto>
}
export interface BackendCategorySearchResponseDto {
  total: number
  data: Array<BackendCategoryDto>
}
export interface SkuSearchResponseDto {
  list: Array<SkuSimpleDto>
  total: number
}
export interface SupplierChannelDto {
  /**
   * 供应商渠道id
   */
  id: number
  /**
   * 供应商名称
   */
  title: string
  /**
   * 供应商渠道药店数量
   */
  pharmacyCount: number
  /**
   * 供应商渠道spu数量
   */
  spuCount: number
  /**
   * 是否是自营：0 非自营，1 自营
   */
  isSelf: number
}
export interface StoreDto {
  /**
   * 药店id
   */
  id: number
  /**
   * 供应商渠道id
   */
  channelId: number
  /**
   * 药店名称
   */
  title: string
  /**
   * 是否支持代煎
   */
  canMake: number
  /**
   * 代煎费
   */
  makePrice: number
  /**
   * 药店类型 1 西药 2 中药
   */
  storeType: number
  /**
   * 中药店类型 1 引片 2 颗粒
   */
  cnMedStoreType: number
  /**
   * 定价模式 1 高开模式 2 加成模式
   */
  pricingMode: number
  /**
   * 线下药店模式 是否有线下药店?是:1;否:2;默认2
   */
  toC: number
  /**
   * 药店开铺时间
   */
  startTime: number
  /**
   * 药店打烊时间
   */
  endTime: number
  /**
   * 是否穿行药店 0 否 1 是
   */
  isTrajection: number
  /**
   * 购买方式：1 快递配送; 2 货到付款; 4 自提&线上支付; 8 自提&线下支付
   */
  buyMethods: Array<number>
}
export interface SubFreightTplArea {
  /**
   * ID 自增主键
   */
  id: number
  /**
   * 运费模板ID
   */
  freightTplId: number
  /**
   * 运费子模板ID
   */
  freightSecondTplId: number
  /**
   * 运费模板名称
   */
  freightTplTitle: string
  /**
   * 区域: 如果area为0代表是全国
   */
  areaId: number
  /**
   * 药店ID
   */
  storeId: number
}
export interface SubFreightTpl {
  /**
   * 区域：是否是全国(不含港澳台)
   */
  isAnyArea: boolean
  /**
   * 区域：是否是全国(不含港澳台)
   */
  areas: Array<SubFreightTplArea>
  /**
   * 包邮条件
   */
  freeShippingThreshold: number
  /**
   * id
   */
  id: number
  /**
   * 运费模板ID
   */
  freightTplId: number
  /**
   * 满足费用(包邮)
   */
  shippingMoney: number
  /**
   * 药店ID
   */
  storeId: number
  /**
   * 物流公司对应ID
   */
  logisticsCoCode: string
}
export interface FreightTplDetailDto {
  /**
   * 模板id
   */
  id: number
  /**
   * 模板名称
   */
  title: string
  /**
   * 模版类型: 1 统一运费, 2 指定包邮
   */
  type: number
  /**
   * 统一运费(统一模板或者达不到包邮条件)
   */
  normalShippingPrice: number
  /**
   * 关联的SKU数量
   */
  skuCount: number
  /**
   * 药店id
   */
  storeId: number
  /**
   * 二级模板：如果是统一模板则为空数组
   */
  freightSecondTpls: Array<SubFreightTpl>
  /**
   * 包邮条件：-1为未设置
   */
  freeShippingThreshold: number
  /**
   * 运费配送区域ID
   */
  deliveryId: string
  /**
   * 物流公司对应ID
   */
  logisticsCoCode: string
  /**
   * 是否支持货到付款 0 不支持 1 支持
   */
  cashOnDelivery: number
}
export interface SkuDto {
  /**
   * sku id
   */
  id: number
  /**
   * 供应商渠道名称
   */
  channelText: string
  /**
   * 包装规格名称
   */
  packText: string
  /**
   * 零售价（分）
   */
  originPrice: number
  /**
   * 区域价格
   */
  priceZone: Array<PriceZoneDto>
  /**
   * 优惠价（分）
   */
  salePrice: number
  /**
   * 线下零售价
   */
  marketPrice: number
  /**
   * 库存
   */
  stock: number
  /**
   * 热度
   */
  hot: number
  /**
   * 上架状态：-1 未上架；1-上架
   */
  status: number
  spu: SpuDto
  /**
   * 创建人
   */
  createName: string
  /**
   * 创建人ID
   */
  creatorId: number
  spuPack: PackDto
  /**
   * ERP货品ID
   */
  erpGoodsId: number
  channelSpu: SpuChannelDto
  batchNu: string
  /**
   * 业务渠道
   */
  businessChannel: Array<BusinessChannelDto>
  /**
   * 是否关联运费模板
   */
  relatedFreights: boolean
  /**
   * 下架原因
   */
  offReason: number
  /**
   * 失效原因
   */
  invalidReason: number
  /**
   * 是否赠品：0：非赠品 1：赠品 -1：不限制筛选
   */
  isGiveaway?: number
  /**
   * 底价 (售价=底价*(1+加成比例))
   */
  basePrice?: number
  /**
   * 加成比例 加成比例的数值*100;例:70(加成比例70%)
   */
  additionPercentage?: number
  /**
   * 是否单独加成 枚举值: 1:不单独加成 2:单独加成 默认:1
   */
  aloneStatus?: number
  stockInfo: StockInfoDto
  channel: SupplierChannelDto
  store: StoreDto
  /**
   * 运费模板
   */
  freights: Array<FreightTplDetailDto>
}
export interface BatchImportFailedListDto {
  /**
   * 中药名称
   */
  genericName?: string
  /**
   * 底价
   */
  basePrice?: number
  /**
   * 底价
   */
  salePrice?: number
  /**
   * 底价
   */
  stock?: number
  /**
   * 底价
   */
  tplName?: string
  /**
   * 失败原因
   */
  failedReason?: string
}
export interface BatchImportRespDto {
  /**
   * 成功条数
   */
  SuccessNum: number
  /**
   * 失败条数
   */
  FailedNum: number
  /**
   * 失败内容
   */
  FailedList: Array<BatchImportFailedListDto>
}
export interface SkuDownloadFailDataResponseDto {
  path: string
}
export interface BatchAddResData {
  /**
   * 中药名称
   */
  genericName: string
  /**
   * 零售价（元/克）
   */
  salePrice: number
  /**
   * 库存（克）
   */
  stock: number
  /**
   * 运费模板名称
   */
  freightTplTitle: string
  /**
   * 失败原因
   */
  failedReason: string
}
export interface BatchAddRespDto {
  /**
   * 成功条数
   */
  TotalNumber: number
  /**
   * 成功条数
   */
  SuccessNumber: number
  /**
   * 失败条数
   */
  FailedNumber: number
  /**
   * 成功内容
   */
  SuccessList: Array<BatchAddResData>
  /**
   * 失败内容
   */
  FailedList: Array<BatchAddResData>
}
export interface BatchPutAwayResDto {
  /**
   * 成功条数
   */
  TotalNumber: number
  /**
   * 成功条数
   */
  SuccessNumber: number
  /**
   * 失败条数
   */
  FailedNumber: number
  /**
   * 成功内容
   */
  SuccessList: Array<number>
  /**
   * 失败内容
   */
  FailedList: Array<number>
}
export interface SkuYhDto {
  /**
   * 药品编码
   */
  medNumber: string
  /**
   * 批准文号
   */
  approvalNumber: string
  /**
   * 药品名称
   */
  genericName: string
  /**
   * 产地
   */
  manufacturerAddress: string
  /**
   * 规格
   */
  pack: string
  /**
   * 售卖单元
   */
  saleUnit: string
  /**
   * 卖价
   */
  salePrice: number
  /**
   * 库存
   */
  stock: number
  /**
   * 创建时间
   */
  createTime: number
}
export interface SkuYhSearchResDto {
  total: number
  data: Array<SkuYhDto>
}
export interface BcPriceListDto {
  /**
   * Sku Id
   */
  skuId: number
  /**
   * 渠道价格
   */
  bcPrice: number
  /**
   * 失败原因
   */
  failedReason: string
}
export interface BatchImportBCPriceRespDto {
  /**
   * 批量导入列表
   */
  bcPriceList: Array<BcPriceListDto>
  /**
   * 成功数量
   */
  successNum: number
  /**
   * 失败数量
   */
  failedNum: number
}
export interface BusinessPriceDownloadFailDataResponseDto {
  path: string
}
export interface ErrorSearchResDo {
  list: Array<string>
  total: number
}
export interface StoreSearchResponseDto {
  list: Array<StoreDto>
  total: number
}
export interface ProcessingChargeEntityDto {
  /**
   * ID
   */
  id: number
  /**
   * 剂型加工方式 ID
   */
  processingId: number
  /**
   * 收费标准区间上限
   */
  upperLimit: number
  /**
   * 收费标准区间下限
   */
  lowerLimit: number
  /**
   * 收费标准
   */
  chargeType: number
  /**
   * 收费价格
   */
  price: number
  /**
   * 是否disabled掉
   */
  isDisabledChargeType: boolean
}
export interface ProcessingEntityDto {
  /**
   * id
   */
  id: number
  /**
   * 中药药店类型
   */
  cnMedStoreType: number
  /**
   * 剂型加工方式
   */
  method: number
  /**
   * 起订量
   */
  minQuantity: number
  /**
   * 出方率上限
   */
  upperOutRate: number
  /**
   * 出方率下限
   */
  lowerOutRate: number
  /**
   * 是否支持待煎：-1 否 1 是
   */
  canMake: number
  /**
   * 收费标准
   */
  processingCharges: Array<ProcessingChargeEntityDto>
  /**
   * 药店 ID
   */
  storeId: number
}
export interface GetStoreProcessingResDto {
  /**
   * 实体类
   */
  data: Array<ProcessingEntityDto>
}
export interface ProcessingChargeReqDto {
  /**
   * 收费标准区间上限
   */
  upperLimit: number
  /**
   * 收费标准区间下限
   */
  lowerLimit: number
  /**
   * 收费标准
   */
  chargeType: number
  /**
   * 收费价格
   */
  price: number
}
export interface SpuBaseEntityDto {
  /**
   * Spu Id
   */
  id: number
  backgroundCategory: BackendCategoryDto
  /**
   * 包装规格
   */
  packs: Array<PackDto>
  /**
   * 是否统一定价
   */
  isUnifiedPrice: boolean
  /**
   * 售卖区域
   */
  saleZone: number
  /**
   * 是否自营：0 非自营，1 自营
   */
  storeRule: number
  /**
   * Spu 类型：1 西药，2 医疗器械，3 中药，4 营养保健，5 化妆品
   */
  spuType: number
  /**
   * 状态：-1 无效/下架，0 未知（默认），1 有效/上架
   */
  status: number
  /**
   * 产品类型：1 中成药，2 化学药品，3 生物制品，4 体外化学诊断试剂，5 药用辅料，6 进口分包装药
   */
  productType: number
}
export interface SpuMedDto {
  /**
   * Spu Id
   */
  spuId: number
  /**
   * 商品名称
   */
  tradeName: string
  /**
   * 药品名称
   */
  genericName: string
  /**
   * 生产单位
   */
  manufacturerTitle: string
  /**
   * 是否处方药：-1 未知，0 处方药，1 非处方药
   */
  otcType: number
  /**
   * 药品本位码
   */
  standardCode: string
  /**
   * 批准文号/注册证号
   */
  approvalNumber: string
  /**
   * 药品规格
   */
  specification: string
  /**
   * 药品英文名
   */
  enName: string
  /**
   * 相关标签
   */
  tags: string
  /**
   * 剂型
   */
  formulation: string
  /**
   * 批准日期
   */
  approvalDate: number
  /**
   * 医保类别：0 非医保，1 甲，2 乙，3 丙，4 民族药
   */
  medicareCategoryId: number
  /**
   * 成分
   */
  ingredient: string
  /**
   * 适应症/主治功能
   */
  indication: string
  /**
   * 用法用量
   */
  usage: string
  /**
   * 药理作用
   */
  pharmacological: string
  /**
   * 药动学
   */
  pharmacokinetics: string
  /**
   * 药物相互作用
   */
  drugInteraction: string
  /**
   * 不良反应
   */
  adverseReaction: string
  /**
   * 禁忌
   */
  contraindication: string
  /**
   * 注意事项
   */
  consideration: string
  /**
   * 贮藏
   */
  storage: string
  /**
   * 有效期
   */
  shelfLife: string
  /**
   * 生产单位地址
   */
  manufacturerAddress: string
  /**
   * 生产单位联系方式
   */
  manufacturerPhone: string
  /**
   * 包装规格
   */
  packs: Array<PackDto>
  /**
   * 基本 Spu
   */
  baseSpuEntity: void
}
export interface SpuDtos {
  baseSpuEntity: SpuBaseEntityDto
  spuMachineEntity: SpuMachineEntityDto
  spuNutritionEntity: SpuNutritionEntiryDto
  spuCnMedEntity: SpuCnMedEntityDto
  spuMedEntity: SpuMedDto
  spuCosmeticEntity: SpuCosmeticEntityDto
}
export interface SpuPaginateResDto {
  /**
   * 总条数
   */
  total: number
  /**
   * 数据项
   */
  data: Array<SpuDtos>
}
export interface DraftDto {
  /**
   * 草稿 ID
   */
  id: string
  entity: SpuDto
  rulesEntity: RulesDto
}
export interface SpuDraftResDto {
  total: number
  data: Array<DraftDto>
}
export interface DoctorDto {
  /**
   * 医生 ID
   */
  userId: number
  /**
   * 医生姓名
   */
  name: string
  /**
   * 手机号码
   */
  phone: string
  /**
   * 医院名称
   */
  hospital: string
  /**
   * 科室名称
   */
  section: string
  /**
   * 职称
   */
  title: string
  /**
   * 认证状态
   */
  verifyStatus: number
}
export interface GetMultiDoctorInfoResDto {
  /**
   * 医生信息
   */
  doctorInfo: Array<DoctorDto>
  /**
   * 总数
   */
  total: number
}
export interface DiscountInfoDto {
  /**
   * 优惠 ID
   */
  groupId: number
  /**
   * 优惠名称
   */
  name: string
  /**
   * 折扣比例
   */
  discount: number
  /**
   * 客户数
   */
  doctorNum: number
}
export interface GetCPDiscountGroupListResDto {
  /**
   * 优惠信息
   */
  discountInfos: Array<DiscountInfoDto>
  /**
   * 条数
   */
  totalNum: number
}
export interface CPDGQueryDoctorInfoDto {
  /**
   * 医生 ID
   */
  doctorId: number
  /**
   * 医生姓名
   */
  name: string
  /**
   * 手机号码
   */
  cellphone: string
  /**
   * 所在医院
   */
  hospital: string
  /**
   * 所在科室
   */
  section: string
  /**
   * 职称
   */
  title: string
  /**
   * 认证状态：0 注册用户 1 实名认证 2 健康服务认证 3 多点执业
   */
  verifyStatus: number
}
export interface CPDGQueryDoctorListResDto {
  /**
   * 总条数
   */
  totalNum: number
  /**
   * 医生信息
   */
  infos: Array<CPDGQueryDoctorInfoDto>
}
export interface QueryDoctorListResDto {
  /**
   * 总条数
   */
  totalNum: number
  /**
   * 医生信息
   */
  doctorInfos: Array<CPDGQueryDoctorInfoDto>
}
export interface SupplierChannelSearchResponseDto {
  data: Array<SupplierChannelDto>
  total: number
}
export interface BusinessChannelSearchResponseDto {
  list: Array<BusinessChannelDto>
  total: number
}
export interface ChannelBusinessChannelMappingDto {
  /**
   * 业务渠道ID
   */
  id: number
  /**
   * 供应商渠道ID
   */
  channelId: number
  /**
   * 一级类目ID
   */
  backgroundCategoryPpid: number
  /**
   * 业务渠道ID
   */
  businessChannelId: number
}
export interface ChannelDto {
  /**
   * 供应商渠道ID
   */
  id: number
  /**
   * 供应商渠道名称
   */
  title: string
  /**
   * 是否自营
   */
  isSelf: boolean
  /**
   * 备注
   */
  remark: string
  /**
   * 药店数量
   */
  pharmacyCount: number
  /**
   * SPU数量
   */
  spuCount: number
  /**
   * 创建时间戳
   */
  createdAt: number
  /**
   * 修改时间戳
   */
  updatedAt: number
  /**
   * 排序，越大越靠前
   */
  sort: number
  /**
   * 关联业务渠道
   */
  channelBusinessChannelMapping: Array<ChannelBusinessChannelMappingDto>
}
export interface ChannelSearchResponseDto {
  data: Array<ChannelDto>
  /**
   * 数目
   */
  total: number
  /**
   * 当前页
   */
  curPage: number
}
export interface PackResponseDto {
  list: Array<PackDto>
}
export interface PackPSResDto {}
export interface OrderDrugEntityDto {
  /**
   * 商品通用名称
   */
  tradeName: string
  /**
   * 商品数量
   */
  quantity: number
  /**
   * 器械类信息
   */
  machineInfos: OrderSkuDetailMachineInfoDto[];
  /**
   * 药品详情ID
   */
  id: number;
  /**
   * spuType
   */
  spuType: number;
  /**
   * 订单号
   */
  transNo: string;
}
export interface InvoiceDto {
  /**
   * 订单编号
   */
  transNo: string
  /**
   * 发票类型 0 不开发票，1 纸质发票，2 电子发票
   */
  type: number
  /**
   * 发票抬头
   */
  title: string
  /**
   * 发票邮箱
   */
  email: string
  /**
   * 发票抬头类型
   */
  titleType: number
  /**
   * 纳税人识别号
   */
  taxpayerNo: string
}
export interface OrderSearchV2Dto {
  /**
   * 订单编号
   */
  transNo: string
  /**
   * 药店名称
   */
  storeName: string
  /**
   * 是否为纸质处方 0不是，1是，2 全部
   */
  isPaperPrescription: number
  /**
   * 药品类型 0 西药 1 中药 3 推荐药品
   */
  typeOfDrug: number
  /**
   * 商品
   */
  details: Array<OrderDrugEntityDto>
  /**
   * 订单支付方式 1 货到付款，2 在线支付，4 到店支付，8 定金+尾款
   */
  payMethod: number
  /**
   * 配送方式 1快递配送，2 到店自取
   */
  deliveryMethod: number
  /**
   * 订单金额（分）
   */
  payPrice: number
  /**
   * 支付金额（分）
   */
  alreadyPayMoney: number
  /**
   * 商品总金额
   */
  drugsPrice: number
  /**
   * 优惠金额
   */
  discount: number
  /**
   * 处方患者姓名
   */
  prescriptionPatientName: string
  /**
   * 下单时间（时间戳）
   */
  createdAt: number
  /**
   * 支付时间（时间戳）
   */
  payAt: string
  /**
   * 发货时间（时间戳）
   */
  deliverAt: string
  /**
   * 订单状态 1 待支付，2 待发货，3 待收货，4 交易完成，5 已取消，6 交易关闭,7 退款中，8 待取药，9 部分发货
   */
  searchStatus: number
  /**
   * 订单那类型 1 首单，2 复购 3 预约单
   */
  buyType: number
  /**
   * 是否部分退货 1是，2不是
   */
  isPartReturn: number
  /**
   * 订单标签 1 正常 2 换购主订单 3 换购副订单 8 续方预约单
   */
  label: number
  /**
   * 备注
   */
  remark: string
  /**
   * ERP 推送状态：1 未推送 2 推送成功 3 推送失败
   */
  erpStatus: number
  /**
   * ERP 推送失败原因
   */
  erpRemark: string
  /**
   * ERP 最近推送时间
   */
  erpPushTime: string
  /**
   * 处方id
   */
  prescriptionId: number
  /**
   * 处方审核状态
   */
  prescriptionStatus: number
  /**
   * 处方编号
   */
  prescriptionNum: string
  /**
   * 订单审核状态
   */
  orderAuditStatus: number
  /**
   * 订单默认物流公司
   */
  logisticsCoCode: string
  /**
   * 是否需要发票 true 需要 false 不需要
   */
  isNeedInvoice: boolean
  invoice: InvoiceDto
  isMachine: boolean
}
export interface OrderSearchV2ResDto {
  /**
   * 总条数
   */
  total: number
  /**
   * 数据项
   */
  data: Array<OrderSearchV2Dto>
  /**
   * 部分发货订单数量
   */
  partialCount: number
}
export interface OrderMarkResponseDto {
  /**
   * 订单编号
   */
  transNo: string
  /**
   * 用户标记ID
   */
  markUserId: number
  /**
   * 标记原因ID
   */
  markReasonId: number
  /**
   * 标记处理结果
   */
  markResult: string
  /**
   * 标记人
   */
  markUserName: string
  /**
   * 标记时间
   */
  markTime: number
  /**
   * 标记原因
   */
  markReason: string
  /**
   * 客服备注时间
   */
  otherRemarkTime: number
}
export interface OrderCostDto {
  /**
   * 管理费（病程）
   */
  managePrice: number
  /**
   * 服务费（代煎费）
   */
  servicePrice: number
  /**
   * 数量
   */
  quantity: number
  /**
   * 医保扣减额
   */
  carePrice: number
  /**
   * 大客户折扣比例
   */
  doctorDiscount: number
  /**
   * 大客户折扣
   */
  doctorDiscountVal: number
  /**
   * 药材加成比例
   */
  doctorAddition: number
  /**
   * 药品库药品总额
   */
  salePriceClone: number
  /**
   * 医生加成金额
   */
  additionPrice: number
  /**
   * 药品底价和
   */
  skuBasePrice: number
}
export interface OrderCancelDto {
  /**
   * 取消原因
   */
  reasonMsg: string
  /**
   * 取消时间
   */
  createdAt: string
}
export interface AddressAreaDto {
  /**
   * 省ID
   */
  provinceId: number
  /**
   * 省
   */
  provinceName: string
  /**
   * 市ID
   */
  cityId: number
  /**
   * 市
   */
  cityName: string
  /**
   * 区ID
   */
  districtId: number
  /**
   * 区
   */
  districtName: string
  /**
   * 详细
   */
  detail: string
  /**
   * 地址信息
   */
  addressData: string
}
export interface OrderDto {
  /**
   * 订单自增id
   */
  id: number
  /**
   * 订单编号
   */
  transNo: string
  /**
   * 订单标签：1-普通，2-换购主订单，3-换购副订单 8 续方预约单
   */
  label: number
  /**
   * 端口来源 9 - 未来医生
   */
  portSrc: number
  /**
   * 订单创建时间（时间戳）
   */
  createdAt: string
  /**
   * 订单状态 1 待支付，2 待发货，3 待收货，4 交易完成，5 已取消，6 交易关闭,7 退款中，8 待取药，9 部分发货
   */
  searchStatus: number
  /**
   * 订单那类型 1 首单，2 复购 3 预约单
   */
  buyType: number
  /**
   * 商品金额（分）
   */
  totalPrice: number
  /**
   * 订单金额（分）
   */
  payPrice: number
  /**
   * 支付金额（分）
   */
  alreadyPayMoney: number
  /**
   * 订单支付方式 1 货到付款，2 在线支付，4 到店支付 8 定金+尾款
   */
  payMethod: number
  /**
   * 线上支付的具体支付方式：0 默认无，1 公众号，2 小程序，3 快捷支付，10 微信原生支付
   */
  onlinePayChannel: number
  /**
   * 支付方式的综合状态：1 货到付款，2 在线支付，4 到店支付，5 公众号，6 小程序，7 快捷支付，14 微信原生支付
   */

  paySearchMethod: number
  /**
   * 支付时间（时间戳）
   */
  payAt: number
  /**
   * 订单完成（时间戳）
   */
  completeAt: number
  /**
   * 配送方式 1快递配送，2 到店自取
   */
  deliveryMethod: number
  /**
   * 药店id
   */
  storeId: number
  /**
   * 渠道id
   */
  channelId: number
  /**
   * 药店名称
   */
  storeName: string
  /**
   * 运费（分）
   */
  freight: number
  /**
   * 发票类型
   */
  isNeedInvoice: boolean
  /**
   * 备注
   */
  remark: string
  /**
   * 客服备注
   */
  otherRemark: string
  /**
   * 患者id
   */
  patientId: number
  /**
   * 医生姓名
   */
  doctorName: string
  /**
   * 医生id
   */
  doctorId: number
  /**
   * 订单支付方式 1 货到付款，2 在线支付，4 到店支付
   */
  isPaperPrescription: number
  /**
   * 处方id
   */
  prescriptionId: number
  /**
   * 处方审核状态
   */
  prescriptionAuditStatus: number
  /**
   * 处方编号
   */
  prescrioptionNum: string
  /**
   * 优惠金额
   */
  discount: number
  /**
   * 满减补贴
   */
  allowancePrice: number
  /**
   * 药品总金额
   */
  drugsPrice: number
  /**
   * 当前登陆用户
   */
  patientName: string
  /**
   * 收货人姓名
   */
  deliverName: string
  /**
   * 处方患者姓名
   */
  prescriptionPatientName: string
  /**
   * 收货人电话
   */
  deliverPhone: string
  /**
   * 虚拟号码
   */
  virtualNumber: string
  /**
   * 收货人地址
   */
  deliveryAddress: string
  /**
   * 门牌号，接口层已拼接到deliveryAddress
   */
  deliveryHouseNum: string
  /**
   * 子支付通道
   */
  subChannel: number
  extraInfo: OrderMarkResponseDto
  /**
   * 药品类型 0 西药 1 中药
   */
  typeOfDrug: number
  costEntity: OrderCostDto
  /**
   * 是否是补方：1 是 2 否
   */
  isComplementType: number
  /**
   * 订单取消原因
   */
  cancelReason: Array<OrderCancelDto>
  addressArea: AddressAreaDto
  /**
   * 定金
   */
  onlinePayPrice: number
  /**
   * 是否器械订单
   */
  isMachine: boolean
}
export interface PatientDto {
  /**
   * 患者id
   */
  id: number
  /**
   * 患者性别：0 其他,1 男,2 女
   */
  gender: number
  /**
   * 患者手机号
   */
  phone: string
  /**
   * 患者生日 yyyymmdd
   */
  birthDate: number
  /**
   * 患者年龄
   */
  age: number
  /**
   * 患者姓名
   */
  name: string
}

export interface OrderSkuDetailMachineInfoDto {
  /**
   * 器械详情ID
   */
  id: number;

  /**
   * 订单编号
   */
  transNo: string;

  /**
   * 发货数量
   */
  batchQuantity: number;

   /**
   * 生产批号
   */
  batchNo?: string;

  /**
   * 序列号
   */
  sequenceNo?: string;

  /**
   * 有效期
   */
  shelfTime: number;
}

export interface OrderSkuDto {
  /**
   * 订单药品自增ID（用于退款）
   */
  refundSkuId: number
  /**
   * id
   */
  id: number
  /**
   * sku id
   */
  skuId: number
  /**
   * spu id
   */
  spuId: number
  /**
   * 药品名
   */
  genericName: string
  /**
   * 商品名
   */
  tradeName: string
  /**
   * 生产企业许可证
   */
  manufactureLicenseNu: string
  /**
   * 生产企业
   */
  manufacturerTitle: string
  /**
   * 包装规格
   */
  pack: string
  /**
   * 数量
   */
  quantity: number
  /**
   * 是否处方药
   */
  otcType: number
  /**
   * 原价（分）
   */
  originPrice: number
  /**
   * 售价（分）
   */
  salePrice: number
  /**
   * 药品总价
   */
  totalPrice: number
  /**
   * 批准文号
   */
  approvalNumber: string
  /**
   * 本位码
   */
  standardCode: string
  /**
   * 条形码
   */
  barCode: string
  /**
   * 用法用量
   */
  usage: string
  /**
   * 优惠金额
   */
  discount: number
  /**
   * 药品支付金额
   */
  payPrice: number
  /**
   * 优惠金额（退款单，订单使用这个）
   */
  singleDiscount: number
  /**
   * 服务费比例（万分之），使用百分数表示需除以100
   */
  serviceFeeRate: number
  /**
   * Spu Type
   */
  spuType: number
  /**
   * 电子监管码
   */
  eSupervisionCode: Array<string>
  /**
   * 发货数量
   */
  deliveredCount: number
  /**
   * erp货品id
   */
  erpGoodsId: number
  /**
   * erp店铺id
   * */
  erpStoreId: number
  /**
   * 器械类信息
   */
  machineInfos?: OrderSkuDetailMachineInfoDto[]
}
export interface PresTcmExtFieldsDto {
  /**
   * 孕妇标识
   */
  isPregnant: boolean
  /**
   * 是否代煎
   */
  isDecocting: boolean
  /**
   * 药材总量
   */
  totalWeight: number
  /**
   * 药材总价 单位分
   */
  drugTotalPrice: number
  /**
   * 药材加成
   */
  addition: number
  /**
   * 医生和中药药材是否属于同一中医馆
   */
  isTcmClinic: boolean
  /**
   * 中药饮片加工类型：0-不加工, 1-散剂, 2-水丸, 3-大蜜丸, 4-小蜜丸, 5-膏方 枚举HerbalProcessType
   */
  processType: number
  /**
   * 中药辅料
   */
  auxMaterials: Array<string>
}
export interface OrderPrescriptionDto {
  /**
   * 处方自增id
   */
  id: number
  /**
   * 处方类型：1 纸质，2 电子
   */
  prescriptionType?: number
  /**
   * 处方编号（纸质处方无处方编号）
   */
  transNo: number
  /**
   * 处方药品类型 0 成药 1 饮片 2 颗粒
   */
  drugShape: number
  /**
   * 处方图片（包含电子、纸质）
   */
  photo: string
  /**
   * 来源
   */
  originChannel: string
  /**
   * 用法用量
   */
  usages: string
  /**
   * 结构化的用法用量
   */
  structuredUsages: string
  /**
   * 备注
   */
  remark: string
  /**
   * 开具中药副数
   */
  drugPairs: number
  presTcmExtFields: PresTcmExtFieldsDto
  /**
   * 药师审核状态：-1-审核拒绝，0-未审核，1-审核通过
   */
  auditStatus: number
  /**
   * 状态：0-默认（刚上传），1-有效（未使用），2-已使用
   */
  status: number
  /**
   * 医生姓名 ID
   */
  prDoctorId: number
  /**
   * 医生姓名
   */
  prDoctorName: string
}
export interface OrderDetailSearchResponseDto {
  order: OrderDto
  patient: PatientDto
  /**
   * 药品信息
   */
  sku: Array<OrderSkuDto>
  /**
   * 药店id
   */
  searchStatus?: number
  prescription: OrderPrescriptionDto
}
export interface OrderSearchNewResponseDto {
  /**
   * 新增的订单个数
   */
  total: number
}
export interface LogisticsEntityDto {
  /**
   * 订单物流 id
   */
  id: number
  /**
   * 订单ID
   */
  orderId: number
  /**
   * 订单编号
   */
  transNo: string
  /**
   * 运单号
   */
  mailNo: string
  /**
   * 物流公司
   */
  logisticsCom: string
  /**
   * 物流公司码
   */
  logisticsComCode: string
  /**
   * 运费
   */
  freight: number
  /**
   * 保价费用
   */
  insurePrice: number
  /**
   * 寄件人姓名
   */
  deliverName: string
  /**
   * 寄件人公司
   */
  deliverCompany: string
  /**
   * 寄件人电话
   */
  deliverPhone: string
  /**
   * 寄件人地址
   */
  deliverAddress: string
  /**
   * 收件人姓名
   */
  receiverName: string
  /**
   * 收件人电话
   */
  receiverPhone: string
  /**
   * 收件人地址
   */
  receiverAddress: string
  /**
   * 发货单状态：-1 已取消 0 默认 2 提交成功
   */
  shipStatus: number
  /**
   * 打印状态：0 未打印 1 已打印
   */
  printStatus: number
  /**
   * 创建者：0 未知 1 顺丰 2 快递100
   */
  createBy: number
  /**
   * 创建时间
   */
  createdAt: number
  /**
   * 寄送状态:-1全部 0已发货，1已揽件，2运输中，3派送中，4待取件，5已签收 6拒签
   */
  logisticsActStatus: number
  /**
   * 顺丰发货单序号
   */
  sfCntId: number
  /**
   * 订单发货药品名称
   */
  logisticsMedName: string
}
export interface LogisticsActionEntityDto {
  /**
   * 追踪id
   */
  id: number
  /**
   * 订单编号
   */
  transNo: string
  /**
   * 到达区域
   */
  acceptAddress: string
  /**
   * 具体信息（包含配送信息）
   */
  remark: string
  /**
   * 物流公司状态码
   */
  opCode: string
  /**
   * 物流公司状态中文
   */
  opName: string
  /**
   * 创建时间（到达时间，时间戳）
   */
  createdAt: number
  /**
   * 物流时间
   */
  actionTime: number
}
export interface LogisticOrderDto {
  logistic: LogisticsEntityDto
  /**
   * 物流追踪信息
   */
  actions: Array<LogisticsActionEntityDto>
}
export interface TransactionDto {
  /**
   * 支付单自增id
   */
  id: number
  /**
   * 交易单里药店应得金额(分)
   */
  storeCalcPrice: number
  /**
   * 支付金额（分）
   */
  transactionPrice: number
  /**
   * 支付单号
   */
  transNo: string
  /**
   * 商户单号
   */
  transactionId: string
  /**
   * 支付创建时间
   */
  createdAt: number
}
export interface RefundDetailDto {
  /**
   * 退款商品订单id
   */
  orderDetailsId: number
  /**
   * 退款商品数量
   */
  refundQuantity: number
  /**
   * 退款商品金额
   */
  refundProductPrice: number
  /**
   * 当前sku应退金额
   */
  refundErpPrice: number
}
export interface RefundOrderSkuDto {
  /**
   * 退款数量
   */
  refundQuantity: number
  /**
   * 退款商品金额
   */
  refundProductPrice: number
  /**
   * sku id
   */
  skuId: number
  /**
   * 药品名
   */
  genericName: string
  /**
   * 商品名
   */
  tradeName: string
  /**
   * 生产企业
   */
  manufacturerTitle: string
  /**
   * 包装规格
   */
  pack: string
  /**
   * 数量
   */
  quantity: number
  /**
   * 原价（分）
   */
  originPrice: number
  /**
   * 售价（分）
   */
  salePrice: number
  /**
   * 药品总价
   */
  totalPrice: number
  /**
   * 批准文号
   */
  approvalNumber: string
  /**
   * 优惠金额
   */
  discount: number
  /**
   * 药品支付金额
   */
  payPrice: number
  /**
   * 当前sku应退金额
   */
  refundErpPrice: number
}
export interface RefundDto {
  /**
   * 退款单编号
   */
  id: number
  /**
   * 订单编号
   */
  transNo: string
  /**
   * 交易单号
   */
  refundTransactionId: string
  /**
   * 退款金额（分）
   */
  refundPrice: number
  /**
   * 订单金额（分）
   */
  orderPrice: number
  /**
   * 退款方式 1 仅退款，2 退货退款
   */
  refundType?: number
  /**
   * 退款单状态：0 全部，1 退款中，2 退款成功，3 退款失败
   */
  refundStatus: number
  /**
   * 退款类型：0 全部，1 退商品，2 退差价
   */
  refundCategory: number
  /**
   * 应退金额
   */
  details: Array<RefundDetailDto>
  /**
   * 患者姓名
   */
  patientName: string
  /**
   * 患者手机号
   */
  patientPhone: string
  /**
   * 是否可以重新发起退款
   */
  canReplyRefund: boolean
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 到账时间
   */
  recvAt: string
  /**
   * 创建人
   */
  createUser: string
  /**
   * 备注
   */
  remark: string
  /**
   * 退款渠道
   */
  refundChannel: string
  /**
   * 退款药品
   */
  sku: Array<RefundOrderSkuDto>
}
export interface PromotionInfoEntityDto {
  /**
   * 活动 ID
   */
  pid: string
  /**
   * 活动类型
   */
  ptype: number
  /**
   * 促销活动
   */
  name: string
  /**
   * 优惠金额
   */
  discount: number
}
export interface QueryOrderDetailsV2ResDto {
  order: OrderDto
  invoice: InvoiceDto
  /**
   * 药品信息
   */
  details: Array<OrderSkuDto>
  /**
   * 物流信息
   */
  logisticInfo: Array<LogisticOrderDto>
  /**
   * 支付单
   */
  tran: Array<TransactionDto>
  /**
   * 退款单
   */
  refund: Array<RefundDto>
  patient: PatientDto
  prescription: OrderPrescriptionDto
  /**
   * 优惠信息
   */
  promotions: Array<PromotionInfoEntityDto>
  /**
   * 是否是部分支付
   */
  partialPay: boolean
  /**
   * 病程管理费流水
   */
  managePriceTrans: number
}
export interface OrderRalateDto {
  order: OrderDto
  /**
   * 订单搜索状态
   */
  searchStatus: number
}
export interface QueryRelateOrderResDto {
  parent: OrderDto
  /**
   * 子订单信息
   */
  child: Array<OrderRalateDto>
}
export interface OrderDeliverErrorDetailDto {
  /**
   * 订单编号
   */
  transNo: string
  /**
   * 错误信息
   */
  errMsg: string
}
export interface OrderDeliverResponseDto {
  /**
   * 总更新订单条数
   */
  cnt: number
  /**
   * 成功更新订单条数
   */
  succ: number
  /**
   * 失败更新订单条数
   */
  fail: number
  /**
   * 详情更新信息
   */
  ret: Array<OrderDeliverErrorDetailDto>
}
export interface DeliveryAreaDto {
  /**
   * 省份ID
   */
  provinceId: number
  /**
   * 省份名
   */
  provinceName: string
  /**
   * 城市ID
   */
  cityId: number
  /**
   * 城市名
   */
  cityName: string
  /**
   * 区ID
   */
  districtId: number
  /**
   * 区名
   */
  districtName: string
}
export interface QueryPromotionResDto {
  /**
   * 数据项
   */
  data: Array<PromotionInfoEntityDto>
}
export interface CodeListDto {
  /**
   * 药品id
   */
  orderDetailId?: number
  /**
   * 电子监管码
   */
  eSupervisionCode?: Array<string>
}
export interface GetAvgPriceOfSkuRespDto {
  /**
   * 售后信息
   */
  AfterSalesInfo: Array<string>
}
export interface PrescriptionSimpleDtoV2 {
  /**
   * 处方id
   */
  id: number
  /**
   * 处方编号
   */
  transNo: string
  /**
   * 业务渠道ID
   */
  businessId: number
  /**
   * 业务渠道名称
   */
  businessName: string
  /**
   * 业务渠道类型 1-随诊，2-问诊，3-开药门诊，4-患者自购
   */
  businessType: number
  /**
   * 是否为测试数据：0 否，1 是
   */
  isTest: number
  /**
   * 处方类型：1 纸质，2 电子
   */
  prescriptionType?: number
  /**
   * 患者ID
   */
  patientId: number
  /**
   * 患者姓名
   */
  patientName: string
  /**
   * 患者手机号
   */
  patientPhone: string
  /**
   * 药品名称列表
   */
  drugNames: Array<string>
  /**
   * 医生ID
   */
  doctorId: number
  /**
   * 医生姓名
   */
  doctorName: string
  /**
   * 是否支持复诊开药：0 不支持，1 支持
   */
  doctorIsSupportReConsultation: number
  /**
   * 医院名称
   */
  hospitalName: string
  /**
   * 科室名称
   */
  sectionName: string
  /**
   * 省份
   */
  provinceName: string
  /**
   * 市
   */
  cityName: string
  /**
   * 经纪人姓名
   */
  brokerName: string
  status: number
  auditStatus: number
  /**
   * 处方状态 包含订单审核状态和使用状态：-1 审核拒绝（不合理），0 未审核（待审核），1 已审核（审核通过），2 已失效，5 已使用
   */
  searchStatus: number
  /**
   * 创建时间
   */
  createdAt: number
  /**
   * 更新时间
   */
  updatedAt: number
  /**
   * 审核时间
   */
  auditTime: number
  /**
   * 关联订单
   */
  linkTransNo: Array<string>
  /**
   * 续方时间
   */
  continueTime: number
  /**
   * 处方药品类型
   */
  pcDrugType: number
  /**
   * 医生类型
   */
  doctorType: number
  /**
   * 处方标签
   */
  prTagType: number
}
export interface PrescriptionSearchResponseDtoV2 {
  total: number
  list: Array<PrescriptionSimpleDtoV2>
}
export interface ElectronicEntityDto {
  /**
   * 处方 Id
   */
  id: number
  /**
   * 处方编号
   */
  transNo: string
  /**
   * 处方药品类型：1 西药/中成药 2 中药药方 3 中草药
   */
  type: number
  /**
   * 患者姓名
   */
  patientName: string
  /**
   * 患者出生日期
   */
  patientBirthday: number
  /**
   * 患者性别
   */
  patientGender: number
  /**
   * 患者体重
   */
  patientWeight: string
  /**
   * 皮试结果
   */
  skinTest: number
  /**
   * 疾病诊断
   */
  diagnose: string
  /**
   * 处方生成时间
   */
  createdTime: string
  /**
   * 医生类型：0 全部 1 定点医生 2 补方医生
   */
  doctorType: number
  /**
   * 医生姓名
   */
  prDoctorName: string
  /**
   * 处方医生所在医院
   */
  prDoctorHospitalName: string
  /**
   * 处方医生所在科室
   */
  prDoctorSectionName: string
  /**
   * 医保扣减额
   */
  medicareDeductFee: number
}
export interface DrugEntityDto {
  /**
   * Spu Id
   */
  spuId: number
  /**
   * 药品类型：1 西药 2 中成药 3 中药药方 4 中草药
   */
  medicationGenre: number
  /**
   * 商品名称
   */
  tradeName: string
  /**
   * 包装规格 ID
   */
  contentId: number
  /**
   * 药品通用名称
   */
  title: string
  /**
   * 是否OTC药
   */
  otcType: number
  /**
   * 包装规格
   */
  specification: string
  /**
   * 零售价
   */
  salePrice: number
  /**
   * 数量
   */
  quantity: number
  /**
   * 结构化的用法用量
   */
  structuredUsages: string
  /**
   * 药品名
   */
  genericName: string
}
export interface QueryOneResDto {
  electronic: ElectronicEntityDto
  /**
   * 药品信息
   */
  drugs: Array<DrugEntityDto>
}
export interface QueryEpResDto {
  /**
   * 总数
   */
  count: number
  /**
   * 数据项
   */
  data: Array<QueryOneResDto>
}
export interface DrugEintityTransDto {
  /**
   * 药品名
   */
  genericName?: string
  /**
   * 规格
   */
  specification?: string
  /**
   * 数量（带单位）
   */
  count?: string
  /**
   * 用法用量
   */
  usage?: string
  /**
   * 药品类型
   */
  medicationType?: number
  /**
   * 药品独立标签 (多个标签以英文逗号隔开)
   */
  drugTags?: string
  /**
   * 医生签名
   */
  doctorSign?: string
}
export interface PresDataDto {
  /**
   * 处方id
   */
  id?: string
  /**
   * 医院名称
   */
  hospitalName: string
  /**
   * 处方日期
   */
  date: string
  /**
   * 姓名
   */
  name: string
  /**
   * 性别
   */
  sex: string
  /**
   * 年龄
   */
  age: string
  /**
   * 科别
   */
  sectionType: string
  /**
   * 临床诊断
   */
  clinical: string
  /**
   * 药品列表
   */
  drugs: Array<DrugEintityTransDto>
  /**
   * 处方医生姓名
   */
  doctorName: string
  /**
   * 医生水印
   */
  doctorUrl: string
  /**
   * 审核、调配药师姓名
   */
  pharmacistName: string
  /**
   * 审核、调配药师水印
   */
  pharmacistUrl: string
  /**
   * 审核、发药 药师姓名
   */
  dispensingName: string
  /**
   * 审核、发药 药师水印
   */
  dispensingUrl: Array<string>
  /**
   * 处方类型 普通、儿童
   */
  type: string
  /**
   * 费别
   */
  costType: string
  /**
   * 有效期
   */
  shelfLife: string
  /**
   * 印章图片
   */
  sealUrl: string
  /**
   * 印章类型 1:测试 2:日照  3:银川 4:海尔僧
   */
  seaType: number
  /**
   * 处方状态
   */
  status: number
  /**
   * 开具中药副数
   */
  drugPairs: number
  /**
   * 中药/中草药:用法用量
   */
  usages: string
  /**
   * 中药病名
   */
  disease: string
  /**
   * 结构体用法用量
   */
  structuredUsages: string
  /**
   * 备注
   */
  remark: string
  /**
   * 药态
   */
  drugShapeName: string
  /**
   * 患者体重
   */
  patientWeight: string
  /**
   * 皮试结果
   */
  skinTest: string
  /**
   * 孕妇标识
   */
  isPregnant: boolean
  /**
   * 是否代煎
   */
  isDecocting: boolean
  /**
   * 药材总重（记得带上单位，例如说克或千克）
   */
  totalWeight: string
  /**
   * 中药加工方式
   */
  processMode: string
  /**
   * 中药新结构化用法用量
   */
  newStructuredUsages: string
  /**
   * 中药辅料 字符串数组 格式：饴糖-500g
   */
  auxMaterials: Array<string>
}
export interface SpecialPresDataDto {
  /**
   * 处方id
   */
  id?: string
  /**
   * 医院名称
   */
  hospitalName: string
  /**
   * 处方日期
   */
  date: string
  /**
   * 姓名
   */
  name: string
  /**
   * 性别
   */
  sex: string
  /**
   * 年龄
   */
  age: string
  /**
   * 科别
   */
  sectionType: string
  /**
   * 临床诊断
   */
  clinical: string
  /**
   * 药品列表
   */
  drugs: Array<DrugEintityTransDto>
  /**
   * 处方医生姓名
   */
  doctorName: string
  /**
   * 医生水印
   */
  doctorUrl: string
  /**
   * 审核、调配药师姓名
   */
  pharmacistName: string
  /**
   * 审核、调配药师水印
   */
  pharmacistUrl: string
  /**
   * 审核、发药 药师姓名
   */
  dispensingName: string
  /**
   * 审核、发药 药师水印
   */
  dispensingUrl: Array<string>
  /**
   * 调配药师姓名
   */
  deployName: string
  /**
   * 调配药师水印
   */
  deployUrl: string
}
export interface QueryPresHtmlDetailDto {
  /**
   * 处方页面渲染类型,1-西药处方 2-中药处方 3-特殊处方
   */
  prHtmlType: number
  presData: PresDataDto
  specialPresData: SpecialPresDataDto
}
export interface PrescriptionSearchNewResponseDto {
  /**
   * 新增的处方个数
   */
  count: number
}
export interface ReloadPrDocResDto {
  /**
   * 自增id
   */
  id: number
  /**
   * 处方号
   */
  transNo: string
  /**
   * 处方创建时间
   */
  createdTime: string
  /**
   * 处方状态
   */
  status: number
  auditStatus: number
  /**
   * 处方图片
   */
  prImg: string
}
export interface PharmacistDto {
  /**
   * 药师姓名
   */
  name: string
  /**
   * 药师手写起签名照
   */
  img: string
  /**
   * 药师拒绝理由
   */
  failedReason: string
  /**
   * 药师审核时间（秒时间戳，云药房不使用该数据！！！）
   */
  auditTime: number
}
export interface PrescriptionRetrieveResponseDto {
  /**
   * 处方自增id
   */
  id: number
  /**
   * 处方编号
   */
  transNo: string
  /**
   * 处方图片（包含电子、纸质）
   */
  photo: string
  /**
   * 处方审核状态：-1-审核拒绝，0-未审核，1-审核通过
   */
  auditStatus: number
  /**
   * 处方使用状态：-1-已失效，0-未发送给患者，1-有效，2-已使用
   */
  status: number
  /**
   * 处方状态：-1 审核拒绝（不合理），0 未审核（待审核），1 已审核（审核通过），2 已失效，5 已使用
   */
  searchStatus: number
  pharmacist: PharmacistDto
  /**
   * 处方创建时间
   */
  createdTime: string
  /**
   * 处方审核时间
   */
  auditTime: number
  /**
   * 是否可以补方：0 不能补方，1 可以补方
   */
  isConvert: number
  /**
   * 纸质处方对应的订单药品信息
   */
  sku: Array<OrderSkuDto>
}
export interface PrescriptionDrugSkuDto {
  /**
   * 订单药品自增ID（用于退款）
   */
  refundSkuId: number
  /**
   * sku id
   */
  id: number
  /**
   * sku id
   */
  skuId: number
  /**
   * spu id
   */
  spuId: number
  /**
   * 药品名
   */
  genericName: string
  /**
   * 商品名
   */
  tradeName: string
  /**
   * 生产企业
   */
  manufacturerTitle: string
  /**
   * 包装规格
   */
  pack: string
  /**
   * 数量
   */
  quantity: number
  /**
   * 是否处方药 0-处方 1-otc
   */
  otcType: number
  /**
   * 原价（分）
   */
  originPrice: number
  /**
   * 售价（分）
   */
  salePrice: number
  /**
   * 药品总价
   */
  totalPrice: number
  /**
   * 批准文号
   */
  approvalNumber: string
  /**
   * 本位码
   */
  standardCode: string
  /**
   * 条形码
   */
  barCode: string
  /**
   * 用法用量
   */
  usage: string
  /**
   * 优惠金额
   */
  discount: number
  /**
   * 药品支付金额
   */
  payPrice: number
  /**
   * 优惠金额（退款单，订单使用这个）
   */
  singleDiscount: number
  /**
   * 服务费比例（万分之），使用百分数表示需除以100
   */
  serviceFeeRate: number
  /**
   * Spu Type
   */
  spuType: number
  /**
   * 电子监管码
   */
  eSupervisionCode: Array<string>
  /**
   * 发货数量
   */
  deliveredCount: number
  /**
   * 给药途径
   */
  instructionsCategory: number
  /**
   * 包装规格
   */
  packs: Array<PackDto>
}
export interface PrescriptionPaperRetrieveDto {
  /**
   * 自增id
   */
  id: number
  /**
   * 补方后的电子处方编号
   */
  prescriptionId: number
  /**
   * 患者姓名
   */
  patientName: string
  /**
   * 患者性别：0 未知，1 男，2 女
   */
  patientGender: number
  /**
   * 患者生日yyyy-mm-dd格式数字转换为时间戳
   */
  patientBirthday: number
  /**
   * 患者年龄
   */
  patientAge: number
  pharmacist: PharmacistDto
  /**
   * 临床诊断
   */
  diagnose: string
  /**
   * 纸质处方对应的订单药品信息
   */
  sku: Array<PrescriptionDrugSkuDto>
}
export interface OrderPrescriptionResponseDto {
  /**
   * 电子处方id
   */
  id: number
}
export interface SecretLogVO {
  name: string
  userName?: string
  userId: number
  path: string
  deletedAt?: number
  createdAt: number
  updatedAt: number
  apiType: number
  status: number
}
export interface SecretLogResVO {
  data: SecretLogVO
  total: number
}
export interface OrderStateDto {
  /**
   * 订单编号
   */
  transNo: string
  /**
   * 推送状态
   */
  state: string
  /**
   * 失败原因
   */
  failReason: string
}
export interface OrderStateResDto {
  /**
   * 订单ERP推送状态数组
   */
  StateList: Array<OrderStateDto>
}
export interface RefundSimpleDto {
  /**
   * 退款单编号
   */
  id: number
  /**
   * 订单编号
   */
  transNo: string
  /**
   * 交易单号
   */
  refundTransactionId: string
  /**
   * 退款金额（分）
   */
  refundPrice: number
  /**
   * 订单金额（分）
   */
  orderPrice: number
  /**
   * 退款方式 1 仅退款，2 退货退款
   */
  refundType?: number
  /**
   * 退款单状态：0 全部，1 退款中，2 退款成功，3 退款失败
   */
  refundStatus: number
  /**
   * 退款类型：0 全部，1 退商品，2 退差价
   */
  refundCategory: number
  /**
   * 应退金额
   */
  details: Array<RefundDetailDto>
  /**
   * 患者姓名
   */
  patientName: string
  /**
   * 患者手机号
   */
  patientPhone: string
  /**
   * 是否可以重新发起退款
   */
  canReplyRefund: boolean
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 到账时间
   */
  recvAt: string
  /**
   * 创建人
   */
  createUser: string
  /**
   * 备注
   */
  remark: string
  /**
   * 退款渠道
   */
  refundChannel: string
}
export interface RefundSearchResponseDto {
  list: Array<RefundSimpleDto>
  total: number
}
export interface OrderRetrieveSearchResponseDto {
  order: OrderDto
  invoice: InvoiceDto
  /**
   * 药品信息
   */
  sku: Array<OrderSkuDto>
  logisticInfo: LogisticOrderDto
  /**
   * 支付单
   */
  tran: Array<TransactionDto>
  /**
   * 退款单
   */
  refund: Array<RefundDto>
  patient: PatientDto
  prescription: OrderPrescriptionDto
  /**
   * 优惠信息
   */
  promotions: Array<PromotionInfoEntityDto>
  /**
   * 是否是部分支付
   */
  partialPay: boolean
}
export interface RefundSkuDto {
  /**
   * 所选sku对应的自增id（OrderSkuDto.id）
   */
  orderDetailsId: number
  /**
   * 退还药品数量
   */
  refundQuantity: number
  /**
   * Sku id
   */
  skuId: number
}
export interface RefundTransDto {
  /**
   * 支付单自增id
   */
  id: number
  /**
   * 支付单商户单号（交易单id）
   */
  transactionId: string
  /**
   * 退款金额（分）
   */
  storeRefundPrice: number
}
export interface RefundCreateResponseDto {
  /**
   * 操作支付单数量
   */
  transCnt: number
  /**
   * 成功支付单数量
   */
  succCnt: number
  /**
   * 失败支付单数量
   */
  failCnt: number
}
export interface UserDetailDto {
  /**
   * ID
   */
  id: number
  /**
   * 用户 ID
   */
  userId: number
  /**
   * 用户项目
   */
  name: string
  /**
   * 用户邮箱.
   */
  email: string
  /**
   * 用户电话
   */
  phone: string
  /**
   * 角色id：1-超级管理员 2-管理员 3-云药房药师, 4-渠道管理员, 5-药店管理员
   */
  role: number
  /**
   * 用户账号状态：0 正常，1 禁用
   */
  blockFlag: number
  /**
   * 加入自动审方签名
   */
  autoAudit: number
  /**
   * 是否测试账号 1 否 2 是
   */
  isTest: number
  /**
   * 用户锁定状态 1 正常 2 锁定
   */
  locked: number
  /**
   * 账号归属 1 未设置 2 自营药房 3 合作药房
   */
  accountRelegation: number
  idcard: string
  ywxOpenId: string
  ywxVerifyStatus: number
}
export interface CpUserListRespDto {
  /**
   * 总条数
   */
  total: number
  list: Array<UserDetailDto>
}
export interface CpUserInfoRespDto {
  /**
   * ID
   */
  id: number
  /**
   * 用户 ID
   */
  userId: number
  /**
   * 用户姓名
   */
  name: string
  /**
   * 手机号码
   */
  phone: string
  /**
   * 邮箱
   */
  email: string
  /**
   * 创建人
   */
  createId: number
  /**
   * 角色id：1-超级管理员 2-管理员 3-云药房药师, 4-渠道管理员, 5-药店管理员
   */
  role: number
  /**
   * 权限管理
   */
  permissionData: Array<string>
  /**
   * 药师签名图
   */
  pharmacistSignature: string
  /**
   * 药师资格证
   */
  pharmacistCert: Array<string>
  /**
   * 药师资格编号
   */
   pharmacistCertNum: string
  /**
   * 身份证
   */
  idCards: Array<string>
  /**
   * 用户账号状态：0 正常，1 禁用
   */
  blockFlag: number
  /**
   * 用户工作状态：0 休息，1 工作
   */
  workStatus: number
  /**
   * 创建时间
   */
  createAt: number
  /**
   * 创建时间
   */
  updateAt: number
  /**
   * 供应商渠道 ID 列表
   */
  channelIds: Array<number>
  /**
   * 所属药店 ID
   */
  storeId: number
  /**
   * 支持自动审方 0 是 1 否
   */
  autoAudit: number
  /**
   * 是否测试账号 1 否 2 是
   */
  isTest: number
  /**
   * 用户锁定状态 1 正常 2 锁定
   */
  locked: number
  /**
   * 上次修改密码时间
   */
  lastChangePasswordTime: number
  /**
   * 药店名称
   */
  drugstoreName: string
  /**
   * 药店所在省 ID
   */
  drugstoreProvinceId: number
  /**
   * 药店类型
   */
  storeType: number
  /**
   * 药店渠道ID
   */
  storeChannelId: number
  /**
   * 中药店类型
   */
  cnMedStoreType: number
  /**
   * 业务渠道id 列表
   */
  businessChannelIds: Array<string>
  /**
   * 线下药店模式 是否有线下药店?是:1;否:2;默认2
   */
  toC: number
  /**
   * 账号归属 1 未设置 2 自营药房 3 合作药房
   */
  accountRelegation: number
  /**
   * 是否穿行药店 0 否 1 是
   */
  isTrajection: number
  /**
   * 购买方式：1 快递配送; 2 货到付款; 4 自提&线上支付; 8 自提&线下支付
   */
  buyMethods: Array<number>
}
export interface CheckPasswdIdenticalPhoneRespDto {
  /**
   * 是否需要修改密码
   */
  needChangePassword: boolean
  /**
   * 密码剩余天数
   */
  passwordRemainingDays: number
}
export interface CheckPasswordRightRespDto {
  /**
   * 是否成功
   */
  isSucc: boolean
}
export interface CheckPasswordRespDto {
  /**
   * 是否通过校验
   */
  isSucc: boolean
}
export interface CloudUserGetTokenResponseDto {
  /**
   * token
   */
  token: string
  /**
   * domain
   */
  domain: string
}
export interface HospitalDto {
  /**
   * 医院Id
   */
  id: number
  /**
   * 医院名称
   */
  name: string
  /**
   * 科室
   */
  keySection: string
}
export interface GetMultiHospitalInfoResDto {
  /**
   * 医院信息
   */
  hospitalInfo: Array<HospitalDto>
}
export interface SectionInfoDto {
  /**
   * 科室 Id
   */
  id: number
  /**
   * 科室名称
   */
  name: string
  /**
   * 科室图片
   */
  avatar: string
  /**
   * 变化效果
   */
  avatarChange: string
  /**
   * 时空专用头像
   */
  tsAvatar: string
  /**
   * 学术圈名称
   */
  xsqName: string
  /**
   * 学术圈科室ID
   */
  xsqId: number
}
export interface GetSectionInfoResDto {
  /**
   * 数据项
   */
  SectionInfo: Array<SectionInfoDto>
}
export interface LogisticsDto {
  /**
   * 顺丰发货单序号
   */
  sfCntId: number
  /**
   * 物流id
   */
  id: number
  /**
   * 订单号
   */
  transNo: string
  /**
   * 运单号
   */
  mailNo: string
  /**
   * 物流费
   */
  freight: number
  /**
   * 保价费
   */
  insurePrice: number
  /**
   * 打印状态：0 未打印，1 已打印
   */
  printStatus: number
  /**
   * 发货单状态：-1 已取消 ，0 默认 1 提交失败，2 ，提交成功
   */
  shipStatus: number
  /**
   * 寄送状态：0全部 1待取件，2运输中，3已签收，4已拒绝
   */
  logisticsActStatus: number
  /**
   * 寄送状态：1顺丰标快 其余不知道
   */
  expressType: number
  /**
   * 快递公司
   */
  logisticsCom: string
  /**
   * 药店
   */
  deliverCompany: string
  /**
   * 收货人姓名
   */
  receiverName: string
  /**
   * 收货人电话
   */
  receiverPhone: string
  /**
   * 收货人地址
   */
  receiverAddress: string
  /**
   * 创建时间
   */
  createdAt: number
  /**
   * 订单发货药品名称
   */
  logisticsMedNname: string
}
export interface LogisticsSearchResponseDto {
  list: Array<LogisticsDto>
  total: number
}
export interface LogisticsComDto {
  /**
   * 自增id
   */
  id: number
  /**
   * 公司自定义的编号（后端接收该值）
   */
  code: string
  /**
   * 快递公司名称
   */
  title: string
}
export interface LogisticsComResponseDto {
  data: Array<LogisticsComDto>
}
export interface LogisticsPrintResponseDto {
  /**
   * 返回的消息
   */
  msg: string
  /**
   * ...
   */
  outPut: string
  /**
   * 打印二联单
   */
  type: string
}
export interface JdPrintInfoDto {
  /**
   * 订单编号
   */
  transNo: string
  /**
   * 打印用信息
   */
  printInfo: string
}
export interface LogisticsJDPrintResponseDto {
  /**
   * 返回的消息
   */
  data: Array<JdPrintInfoDto>
}
export interface ExpressInfoDto {
  /**
   * 订单编号
   */
  transNo: string
  /**
   * 快递公司名字
   */
  logisticsCom: string
  /**
   * 物流单号
   */
  logisticsNo?: string
}
export interface ImportDataRetDetailDto {
  /**
   * 订单号
   */
  transNo: string
  /**
   * 错误信息
   */
  errMsg: string
}
export interface ImportDataResDto {
  /**
   * 更新数据总条数
   */
  cnt: number
  /**
   * 成功条数
   */
  succ: number
  /**
   * 失败条数
   */
  fail: number
  /**
   * 更新发货详细错误信息
   */
  ret: Array<ImportDataRetDetailDto>
}
export interface FailedListDto {
  /**
   * 订单号
   */
  transNo: string
  /**
   * 运单号
   */
  mainNo?: string
  /**
   * 失败原因
   */
  errMsg: string
}
export interface LogisticsDownloadFailDataResponseDto {
  path: string
}
export interface UpdateOrderLogisticsItemDto {
  /**
   * 物流 ID
   */
  logisticsId: number
  /**
   * 物流公司
   */
  logisticsCom: string
  /**
   * 物流单号
   */
  logisticsNo: string
}
export interface DeliverOrderDetailDto {
  /**
   * 订单商品详情ID
   */
  orderDetailId: number
  /**
   * 订单商品发货数量
   */
  deliverCount: number
}
export interface FreightTplSearchResponseDto {
  list: Array<FreightTplDetailDto>
  total: number
}
export interface FreightSecondTplDto {
  /**
   * 区域：是否是全国(不含港澳台)
   */
  isAnyArea: boolean
  /**
   * 包邮地区id
   */
  areaIds: Array<number>
  /**
   * 运费
   */
  shippingMoney: number
  /**
   * 满足费用(包邮)
   */
  freeShippingThreshold: number
  /**
   * 物流公司ID
   */
  logisticsCoCode?: string
}
export interface DeliveryDto {
  /**
   * 配送区域id
   */
  deliveryId: string
  /**
   * 配送区域
   */
  areaIds: Array<number>
}
export interface GetTplResDto {
  /**
   * 运费模版 ID
   */
  id: number
  /**
   * 运费模版名称
   */
  title: string
  /**
   * 统一运费
   */
  normalShippingPrice: number
  /**
   * 药店ID
   */
  storeId: number
  /**
   * 包邮条件
   */
  freeShippingThreshold: number
  /**
   * 默认运费模版
   */
  logisticsCoCode: string
}
export interface SettlementDto {
  /**
   * 结算单ID
   */
  id: number
  /**
   * 药店ID
   */
  storeId: number
  /**
   * 药店名称
   */
  storeName: string
  /**
   * 订单编号
   */
  transNo: string
  /**
   * 用户实际支付金额（含手续费）
   */
  payPrice: number
  /**
   * 用户实际支付/收到金额（含手续费）
   */
  realPrice: number
  /**
   * 平台优惠活动
   */
  ptypes: string
  /**
   * 平台优惠
   */
  discount: number
  /**
   * 收入
   */
  income: number
  /**
   * 支出
   */
  payout: number
  /**
   * 商户结算金额
   */
  settlementPrice: number
  /**
   * 平台补贴金额
   */
  allowancePrice: number
  /**
   * 支付手续费
   */
  payFee: number
  /**
   * 商品服务费
   */
  serviceFee: number
  /**
   * 创建时间
   */
  createdAt: number
}
export interface SettlementSearchResDto {
  /**
   * 总收入
   */
  incomeAmount: number
  /**
   * 用户实际支付/收到金额（含手续费）总计
   */
  netTradeAmt: number
  /**
   * 总支出
   */
  payFeeAmount: number
  /**
   * 总支付手续费
   */
  payoutAmount: number
  /**
   * 总商品服务费
   */
  serviceFeeAmount: number
  list: Array<SettlementDto>
  total: number
}
export interface ElectronicReqEntityDto {
  /**
   * 补方渠道 Id
   */
  businessId: number
  /**
   * 医生 Id
   */
  doctorId?: number
  /**
   * 医生类型
   */
  doctorType: number
  /**
   * 处方所属的互联网医院ID
   */
  internetHospitalId?: number
  /**
   * 患者姓名
   */
  patientName: string
  /**
   * 患者出生日期，如20200914
   */
  patientBirthday: number
  /**
   * 患者性别：0 未知 1 男 2 女
   */
  patientGender: number
  /**
   * 疾病诊断
   */
  disease: string
  /**
   * 疾病诊断
   */
  diagnose: string
  /**
   * 医保扣减额
   */
  medicareDeductFee: number
}
export interface DrugUsagesEntityDto {
  /**
   * 用药频率
   */
  cycle: string
  /**
   * 单次剂量
   */
  dosage: string
  /**
   * 单次剂量单位
   */
  dosagePerTimeUnit: string
  /**
   * 给药途径
   */
  usage: string
}
export interface DrugReqEntityDto {
  /**
   * SPU Id
   */
  spuId: number
  /**
   * 包装规格 Id
   */
  contentId: number
  /**
   * 数量
   */
  quantity: number
  structuredUsages: DrugUsagesEntityDto
}
export interface ReinforingCreateResponseDto {
  /**
   * 处方 ID
   */
  prescriptionId: number
}
export interface ReinforingGetQRCodeResDto {
  /**
   * 二维码地址
   */
  qrCodeUrl: string
}
export interface WarningEntityDto {
  /**
   * 告警 Id
   */
  id: string
  /**
   * Sku Id
   */
  skuId: number
  /**
   * 药品通用名称
   */
  genericName: string
  /**
   * 商品名称
   */
  tradeName: string
  /**
   * 告警时间
   */
  warningDate: number
  /**
   * 告警类型
   */
  noticeType: number
  /**
   * 阅读状态 0 未读 1 已读
   */
  readStatus: number
  // 证书
  msg: string
}
export interface PaginateNoticeResDto {
  /**
   * 总条数
   */
  total: number
  /**
   * 未读数
   */
  noReadNum: number
  /**
   * 告警
   */
  warningEntitys: Array<WarningEntityDto>
}
export interface RetrieveNoticeResDto {
  warningEntity: WarningEntityDto
}
export interface SkuWarningEntiry {
  /**
   * 预警Id
   */
  id: number
  spu: SpuSimpleDo
  pack: PackDto
  sku: SkuSimpleDto
  /**
   * 当前库存
   */
  currentStock: number
  /**
   * 安全库存
   */
  safeStock: number
  /**
   * 安全库存计算方法 0 人工填写 1 自动计算
   */
  stockCalcMethod: number
  /**
   * 预警状态 0 正常 1 预警
   */
  warningStatus: number
  /**
   * 补货周期
   */
  replenishmentEpoch: number
}
export interface PaginateSkuWarningResDto {
  /**
   * 总条数
   */
  total: number
  /**
   * Sku Warning Entiry
   */
  data: Array<SkuWarningEntiry>
}
export interface SetPackWarningMethodResDto {
  /**
   * 预警 Id
   */
  id: number
}
export interface PostV1ApplyCreateRequestBody {
  /**
   * 药品渠道
   */
  channelId: number
  /**
   * SPU ID
   */
  spuId: number
  /**
   * 包装规格 ID
   */
  spuPackId: number
  /**
   * 零售价
   */
  salePrice: number
  /**
   * 库存
   */
  stock: number
  /**
   * 热度
   */
  hot: number
  /**
   * 上架状态：-1 未上架，1 上架
   */
  status?: number
  /**
   * 运费模版ID
   */
  freightId: number
  /**
   * 申请类型
   */
  applyType: number
  /**
   * SKU ID
   */
  skuId: number
  /**
   * 第三方编码
   */
  thirdPartyNo?: string
  /**
   * 第三方平台
   */
  thirdPlatformNo?: number
  /**
   * 线下渠道零售价,要求大于0
   */
  toCPrice?: number
}
export interface PostV1ApplyCreateResponse {}

export interface GetV1ApplyApplySkuByIdResponse {
  spu: SpuSimpleDo
  pack: PackDto
  sku: SkuSimpleDto
  /**
   * 审核状态
   */
  status: number
  /**
   * 申请人 Id
   */
  userId: number
  /**
   * 申请人
   */
  userName: string
  /**
   * 药店ID
   */
  storeId: number
  /**
   * 运费模版ID
   */
  freightId: number
}

export interface PutV1ApplyApplySkuByIdRequestBody {
  /**
   * 运费模版id
   */
  freightId: number
  /**
   * 药品渠道
   */
  channelId: number
  /**
   * SPU ID
   */
  spuId: number
  /**
   * 包装规格 ID
   */
  spuPackId: number
  /**
   * 零售价
   */
  salePrice: number
  /**
   * 库存
   */
  stock: number
  /**
   * 热度
   */
  hot: number
  /**
   * 上架状态：-1 未上架，1 上架
   */
  status?: number
  /**
   * 业务渠道ids
   */
  businessChannelId?: Array<number>
}
export interface PutV1ApplyApplySkuByIdResponse {}

export interface DeleteV1ApplyApplySkuByIdResponse {}

export interface PostV1ApplyExamSkuByIdRequestBody {
  /**
   * 驳回原因
   */
  remark?: string
  /**
   * 提交审核状态
   */
  status: number
}
export interface PostV1ApplyExamSkuByIdResponse {}

export interface GetV1ApplyApplySpuByIdResponse {
  /**
   * 草稿 ID
   */
  objectId: string
  /**
   * 申请类型 0 spu 1 pack 2 sku
   */
  applyType: number
  /**
   * 药店ID
   */
  storeId: number
  /**
   * 申请人ID
   */
  userId: number
  /**
   * 申请状态 0 待审核 1 通过 2 驳回
   */
  auditStatus: number
  /**
   * 审核时间
   */
  AuditTime: object
  /**
   * 审核人 ID
   */
  operatorId: object
  spuEntity: SpuDto
  skuEntity: SkuSimpleDto
  /**
   * Pack Entity
   */
  packEntitys: Array<PackDto>
  /**
   * 创建人
   */
  userName: string
  /**
   * 创建时间
   */
  createdAt: number
  /**
   * 运费模版ID
   */
  freightId: number
  /**
   * 驳回原因
   */
  remark: string
  /**
   * 渠道名称
   */
  channelName: string
  rulesEntity: RulesDto
}

export interface PutV1ApplyApplySpuByIdRequestBody {
  /**
   * 药品本位码
   */
  standardCode: string
  /**
   * 后台类目ID
   */
  backgroundCategoryId: number
  /**
   * 商品名
   */
  tradeName: string
  /**
   * 药品通用名（药品名）
   */
  genericName: string
  /**
   * 药品规格
   */
  specification: string
  /**
   * 生产企业
   */
  manufacturerTitle: string
  /**
   * 批准文号/注册证号，格式：国药试字/国药准字+1位字母+8位数字。（记录时，须含"国药准字"等前缀）
   */
  approvalNumber: string
  /**
   * 相关标签
   */
  tags?: string
  /**
   * 所属慢病
   */
  chronicDiseases?: Array<number>
  /**
   * 药学分类 1 中药 2 西药
   */
  genre: number
  /**
   * 是否处方药 -1 未知 0 处方药 1 非处方药
   */
  otcType: number
  /**
   * 限制类别 0 无 1 精神一类 2 精神二类 3 含麻黄碱类 4 麻醉类
   */
  restrainType: number
  /**
   * 适应症分类 0 无 1 慢病 2 非慢病 3 慢病/非慢病
   */
  indicationCategory?: number
  /**
   * 给药途径
   */
  instructionsCategory?: number
  /**
   * 医保类别 0 非医保 1 甲 2 乙 3 丙 4 民族药
   */
  medicareCategoryId: number
  /**
   * 英文名
   */
  enName?: string
  /**
   * 剂型
   */
  formulation?: string
  /**
   * 生产企业地址
   */
  manufacturerAddress?: string
  /**
   * 联系方式
   */
  manufacturerPhone?: string
  /**
   * 批准日期
   */
  approvalDate?: number
  /**
   * 有效期
   */
  shelfLife?: string
  /**
   * 适应症/功能主治
   */
  indication?: string
  /**
   * 成分
   */
  ingredient?: string
  /**
   * 用法用量
   */
  usage?: string
  /**
   * 药理作用
   */
  pharmacological?: string
  /**
   * 药动学
   */
  pharmacokinetics?: string
  /**
   * 药物相互作用
   */
  drugInteraction?: string
  /**
   * 禁忌
   */
  contraindication?: string
  /**
   * 特殊人群用药
   */
  specialCrowdNotice?: string
  /**
   * 注意事项
   */
  consideration?: string
  /**
   * 不良反应
   */
  adverseReaction?: string
  /**
   * 贮藏
   */
  storage?: string
  /**
   * 包装单位
   */
  saleUnit?: string
  /**
   * 起售数量
   */
  minimumSale?: number
  /**
   * 包装规格
   */
  packs: Array<PackDto>
}
export interface PutV1ApplyApplySpuByIdResponse {}

export interface PostV1ApplyApplySpuCampRequestBody {
  /**
   * 药品本位码
   */
  standardCode: string
  /**
   * 后台类目ID
   */
  backgroundCategoryId: number
  /**
   * 商品名
   */
  tradeName: string
  /**
   * 药品通用名（药品名）
   */
  genericName: string
  /**
   * 药品规格
   */
  specification: string
  /**
   * 生产企业
   */
  manufacturerTitle: string
  /**
   * 批准文号/注册证号，格式：国药试字/国药准字+1位字母+8位数字。（记录时，须含"国药准字"等前缀）
   */
  approvalNumber: string
  /**
   * 相关标签
   */
  tags?: string
  /**
   * 所属慢病
   */
  chronicDiseases?: Array<number>
  /**
   * 药学分类 1 中药 2 西药
   */
  genre: number
  /**
   * 是否处方药 -1 未知 0 处方药 1 非处方药
   */
  otcType: number
  /**
   * 限制类别 0 无 1 精神一类 2 精神二类 3 含麻黄碱类 4 麻醉类
   */
  restrainType: number
  /**
   * 适应症分类 0 无 1 慢病 2 非慢病 3 慢病/非慢病
   */
  indicationCategory?: number
  /**
   * 给药途径
   */
  instructionsCategory?: number
  /**
   * 医保类别 0 非医保 1 甲 2 乙 3 丙 4 民族药
   */
  medicareCategoryId: number
  /**
   * 英文名
   */
  enName?: string
  /**
   * 剂型
   */
  formulation?: string
  /**
   * 生产企业地址
   */
  manufacturerAddress?: string
  /**
   * 联系方式
   */
  manufacturerPhone?: string
  /**
   * 批准日期
   */
  approvalDate?: number
  /**
   * 有效期
   */
  shelfLife?: string
  /**
   * 适应症/功能主治
   */
  indication?: string
  /**
   * 成分
   */
  ingredient?: string
  /**
   * 用法用量
   */
  usage?: string
  /**
   * 药理作用
   */
  pharmacological?: string
  /**
   * 药动学
   */
  pharmacokinetics?: string
  /**
   * 药物相互作用
   */
  drugInteraction?: string
  /**
   * 禁忌
   */
  contraindication?: string
  /**
   * 特殊人群用药
   */
  specialCrowdNotice?: string
  /**
   * 注意事项
   */
  consideration?: string
  /**
   * 不良反应
   */
  adverseReaction?: string
  /**
   * 贮藏
   */
  storage?: string
  /**
   * 包装单位
   */
  saleUnit?: string
  /**
   * 起售数量
   */
  minimumSale?: number
  /**
   * 包装规格
   */
  packs: Array<PackDto>
  /**
   * 税率二级类目id
   */
  taxCategoryId: number
}
export interface PostV1ApplyApplySpuCampResponse {}

export interface PostV1ApplyAddPackByIdRequestBody {
  /**
   * 包装规格名称
   */
  pack: string
  /**
   * 零售价
   */
  salePrice: number
  /**
   * 包装规格图片
   */
  images: Array<string>
  /**
   * 结构化数据
   */
  packFormatUnit: number
  packFormatNum: number
  version: number
  infos: Array<PackFormatInfoDto>
}
export interface PostV1ApplyAddPackByIdResponse {}

export interface PackEnumDose {
  dose_unit: number
  dose_unit_name: string
}
export interface PackEnumPackUnit {
  pack_unit: number
  pack_unit_name: string
}

export interface PackEnumSeparatorCharacters {
  separator_unit: number
  separator_unit_name: string
}
export interface PostGetPackEnumResponse {
  dose: PackEnumDose[]
  pack_unit: PackEnumPackUnit[]
  separator_characters: PackEnumSeparatorCharacters[]
}

export interface PutV1ApplyAddPackByIdRequestBody {
  /**
   * SPU ID
   */
  spuId: number
  /**
   * pack名
   */
  pack: string
  /**
   * images
   */
  images: Array<string>
  /**
   * 零售价
   */
  salePrice: number
  /**
   * 结构化数据
   */
  packFormatUnit: number
  packFormatNum: number
  version: number
  infos: Array<PackFormatInfoDto>
}
export interface PutV1ApplyAddPackByIdResponse {}

export interface DeleteV1ApplyByIdResponse {
  /**
   * 草稿 ID
   */
  objectId: string
  /**
   * 申请类型 0 spu 1 pack 2 sku
   */
  applyType: number
  /**
   * 药店ID
   */
  storeId: number
  /**
   * 申请人ID
   */
  userId: number
  /**
   * 申请状态 0 待审核 1 通过 2 驳回
   */
  auditStatus: number
  /**
   * 审核时间
   */
  AuditTime: object
  /**
   * 审核人 ID
   */
  operatorId: object
  spuEntity: SpuDto
  skuEntity: SkuSimpleDto
  /**
   * Pack Entity
   */
  packEntitys: Array<PackDto>
  /**
   * 创建人
   */
  userName: string
  /**
   * 创建时间
   */
  createdAt: number
  /**
   * 运费模版ID
   */
  freightId: number
  /**
   * 驳回原因
   */
  remark: string
  /**
   * 渠道名称
   */
  channelName: string
  rulesEntity: RulesDto
}

export interface PutV1ApplyApplyStatusByIdRequestBody {
  /**
   * 修改状态 0 待审核 1 通过 -1 驳回
   */
  auditStatus: number
}
export interface PutV1ApplyApplyStatusByIdResponse {}
export interface GetV1ApplyApplyListRequestParams {
  page: number

  limit: number
  /**
   * 搜索字段排序：sorts=[key,-key]；+或空为正序 -为倒序
   */
  sorts?: string
  /**
   * 审核状态 -1 驳回 0 待审核 1 已审核
   */
  auditStatus?: number
  /**
   * 审核类别 0 spu 1 pack 2 sku
   */
  type?: number
  /**
   * 二级分类
   */
  backgroundCategoryPid?: number
  /**
   * 三级分类
   */
  backgroundCategoryId?: number
  /**
   * 是否处方药
   */
  otcType?: number
  /**
   * 药学分类
   */
  genre?: number
  /**
   * 限制类别
   */
  restrainType?: number
  /**
   * 药品类型
   */
  spuType?: number
  /**
   * 渠道名
   */
  channelName?: string
  /**
   * 药品名
   */
  medicineName?: string
  /**
   * 商品名
   */
  tradeName?: string
  /**
   * 本位码
   */
  standardCode?: string
  /**
   * 批准文号
   */
  approvalNumber?: string
  /**
   * SPU ID
   */
  spuId?: number
}

export interface GetV1ApplyApplyListResponse {
  total: number
  data: Array<ExContentDto>
}
export interface GetV1BackendCategoryRequestParams {
  page: number

  limit: number
  /**
   * 搜索字段排序：sorts=[key,-key]；+或空为正序 -为倒序
   */
  sorts?: string
  /**
   * 后台类目标题
   */
  title?: string
  /**
   * 后台类目父级id
   */
  pid?: number
  /**
   * 后台类目ids
   */
  ids?: Array<number>
}

export interface GetV1BackendCategoryResponse {
  total: number
  data: Array<BackendCategoryDto>
}

export interface PostV1BackendCategoryRequestBody {
  /**
   * 后台类目父级id
   */
  pid: number
  /**
   * 后台类目标题
   */
  title: string
}
export interface PostV1BackendCategoryResponse {}

export interface PutV1BackendCategoryRequestBody {
  /**
   * 后台类目父级id
   */
  pid: number
  /**
   * 后台类目标题
   */
  title: string
  /**
   * 后台类目id
   */
  id: number
}
export interface PutV1BackendCategoryResponse {}
export interface DeleteV1BackendCategoryRequestParams {
  /**
   * 后台类目id
   */
  id: number
}

export interface DeleteV1BackendCategoryResponse {}
export interface GetV1BackendCategoryShowRequestParams {
  /**
   * 后台类目id
   */
  id: object
}

export interface GetV1BackendCategoryShowResponse {
  /**
   * 后台类目id
   */
  id: number
  /**
   * 后台类目父id
   */
  pid: number
  /**
   * 分类级别
   */
  type: number
  /**
   * 后台类目名称
   */
  title: string
  /**
   * 后台类目父名称
   */
  ptitle: string
  /**
   * 后台类目下子类目数量
   */
  childCategoryCount: number
  /**
   * 后台类目下spu数量
   */
  spuCount: number
}
export interface GetV1SkuRequestParams {
  page: number

  limit: number
  /**
   * 搜索字段排序：sorts=[key,-key]；+或空为正序 -为倒序
   */
  sorts?: string
  /**
   * 关键词
   */
  keyword?: string
  /**
   * sku id 搜索
   */
  id?: string
  /**
   * spuId
   */
  spuId?: number
  /**
   * 是否赠品
   */
  isGiveaway?: number
  /**
   * 是否为处方药：0 处方，1 非处方
   */
  otcType?: number
  /**
   * 库存，仅做排序字段
   */
  stock?: number
  /**
   * 零售价，仅做排序字段
   */
  originPrice?: number
  /**
   * 业务渠道
   */
  businessChannelId?: number
  /**
   * 创建时间，仅做排序字段
   */
  createdAt?: number
  /**
   * 运费模板id
   */
  freightTplId?: number
  /**
   * 药品名
   */
  genericName?: string
  /**
   * 品牌名
   */
  tradeName?: string
  /**
   * 本位码
   */
  standardCode?: string
  /**
   * 批准文号
   */
  approvalNumber?: string
  /**
   * 条形码
   */
  barCode?: string
  /**
   * 下架原因
   */
  offReason?: number
  /**
   * spu、sku商品类目：DRUG-药品，MEDICAL-医疗器械，HEALTH-保健品，SERVICE-医疗服务, COSMETIC-化妆品, CHINESE-中药饮片
   */
  backCategoryType?: string
  /**
   * 商品状态：-1 下架， 1 上架
   */
  status?: number
  /**
   * ERP货品ID
   */
  erpGoodsId?: number
}

export interface GetV1SkuResponse {
  list: Array<SkuSimpleDto>
  total: number
}

export interface PostV1SkuRequestBody {
  /**
   * 供应商渠道id
   */
  channelId?: number
  /**
   * spu id
   */
  spuId: number
  /**
   * spu包装规格id
   */
  spuPackId: number
  /**
   * 库存数量
   */
  stock: number
  /**
   * 原价格（分）
   */
  originPrice?: number
  /**
   * 优惠价格（分）
   */
  salePrice?: number
  /**
   * 上架状态：-1 未上架，1 上架
   */
  status?: number
  /**
   * 热度
   */
  hot: number
  /**
   * 业务渠道ids
   */
  businessChannelId?: Array<number>
  /**
   * 运费模板id（编辑不允许操作运费模板）
   */
  tplId?: number
  /**
   * 产品批次
   */
  batchNu?: string
  /**
   * 是否赠品：0：非赠品 1：赠品 -1：不限制筛选
   */
  isGiveaway?: number
  /**
   * 底价 (售价=底价*(1+加成比例))
   */
  basePrice?: number
  /**
   * 加成比例 加成比例的数值*100;例:70(加成比例70%)
   */
  additionPercentage?: number
  /**
   * 是否单独加成 枚举值: 1:不单独加成 2:单独加成 默认:1
   */
  aloneStatus?: number
  /**
   * 模式设置 枚举值: 1:高开模式 2:加成模式 默认:1
   */
  pricingMode?: number
  stockInfo?: StockInfoDto
  producingArea?: string
}
export interface PostV1SkuResponse {}

export interface GetV1SkuByIdResponse {
  /**
   * sku id
   */
  id: number
  /**
   * 供应商渠道名称
   */
  channelText: string
  /**
   * 包装规格名称
   */
  packText: string
  /**
   * 零售价（分）
   */
  originPrice: number
  /**
   * 区域价格
   */
  priceZone: Array<PriceZoneDto>
  /**
   * 优惠价（分）
   */
  salePrice: number
  /**
   * 线下零售价
   */
  marketPrice: number
  /**
   * 库存
   */
  stock: number
  /**
   * 产地
   */
  producingArea: string
  /**
   * 热度
   */
  hot: number
  /**
   * 上架状态：-1 未上架；1-上架
   */
  status: number
  spu: SpuDto
  /**
   * 创建人
   */
  createName: string
  /**
   * 创建人ID
   */
  creatorId: number
  spuPack: PackDto
  /**
   * ERP货品ID
   */
  erpGoodsId: number
  channelSpu: SpuChannelDto
  batchNu: string
  /**
   * 业务渠道
   */
  businessChannel: Array<BusinessChannelDto>
  /**
   * 是否关联运费模板
   */
  relatedFreights: boolean
  /**
   * 下架原因
   */
  offReason: number
  /**
   * 失效原因
   */
  invalidReason: number
  /**
   * 是否赠品：0：非赠品 1：赠品 -1：不限制筛选
   */
  isGiveaway?: number
  /**
   * 底价 (售价=底价*(1+加成比例))
   */
  basePrice?: number
  /**
   * 加成比例 加成比例的数值*100;例:70(加成比例70%)
   */
  additionPercentage?: number
  /**
   * 是否单独加成 枚举值: 1:不单独加成 2:单独加成 默认:1
   */
  aloneStatus?: number
  stockInfo: StockInfoDto
  channel: SupplierChannelDto
  store: StoreDto
  /**
   * 运费模板
   */
  freights: Array<FreightTplDetailDto>
}

export interface PutV1SkuByIdRequestBody {
  /**
   * 供应商渠道id
   */
  channelId?: number
  /**
   * spu id
   */
  spuId: number
  /**
   * spu包装规格id
   */
  spuPackId: number
  /**
   * 库存数量
   */
  stock: number
  storeId: number
  /**
   * 原价格（分）
   */
  originPrice?: number
  /**
   * 优惠价格（分）
   */
  salePrice?: number
  /**
   * 上架状态：-1 未上架，1 上架
   */
  status?: number
  /**
   * 热度
   */
  hot: number
  /**
   * 业务渠道ids
   */
  businessChannelId?: Array<number>
  /**
   * 运费模板id（编辑不允许操作运费模板）
   */
  tplId?: number
  /**
   * 产品批次
   */
  batchNu?: string
  /**
   * 是否赠品：0：非赠品 1：赠品 -1：不限制筛选
   */
  isGiveaway?: number
  /**
   * 底价 (售价=底价*(1+加成比例))
   */
  basePrice?: number
  /**
   * 加成比例 加成比例的数值*100;例:70(加成比例70%)
   */
  additionPercentage?: number
  /**
   * 是否单独加成 枚举值: 1:不单独加成 2:单独加成 默认:1
   */
  aloneStatus?: number
  /**
   * 模式设置 枚举值: 1:高开模式 2:加成模式 默认:1
   */
  pricingMode?: number
  stockInfo?: StockInfoDto
}
export interface PutV1SkuByIdResponse {}

export interface DeleteV1SkuByIdResponse {}

export interface PutV1SkuStatusByIdRequestBody {
  /**
   * 上架状态：-1 未上架，1 上架
   */
  status?: number
  /**
   * 价格
   */
  originPrice?: number
  /**
   * 优惠价格
   */
  salePrice?: number
  /**
   * 底价
   */
  basePrice?: number
  /**
   * 加成比例
   */
  additionPercentage?: number
  /**
   * 是否单独加成
   */
  aloneStatus?: number
}
export interface PutV1SkuStatusByIdResponse {}

export interface PutV1SkuStockMulRequestBody {
  file?: void
}
export interface PutV1SkuStockMulResponse {}

export interface PostV1SkuPutawayByIdRequestBody {
  /**
   * 药店渠道
   */
  channelId: number
  /**
   * 业务渠道
   */
  businessChannelId: Array<number>
  /**
   * SKU id
   */
  skuId: number
  /**
   * SPU ID
   */
  spuId: number
  /**
   * SPU PACK ID
   */
  spuPackId: number
  /**
   * 销售价格
   */
  salePrice: number
  /**
   * 库存
   */
  stock: number
  /**
   * 热度
   */
  hot: number
  /**
   * 状态 1 上架 -1 下架 -2 失效
   */
  status: number
  /**
   * 包装规格ID
   */
  tplId: number
}
export interface PostV1SkuPutawayByIdResponse {}

export interface PostV1SkuSetAdditionRequestBody {
  /**
   * 药店id
   */
  storeId?: number
  /**
   * 加成比例，取值0-50
   */
  additionPercentage?: number
}
export interface PostV1SkuSetAdditionResponse {}

export interface GetV1SkuDownloadFloorPriceTemplateResponse {}

export interface PostV1SkuImportFloorPriceRequestBody {
  file?: void
}
export interface PostV1SkuImportFloorPriceResponse {
  /**
   * 成功条数
   */
  SuccessNum: number
  /**
   * 失败条数
   */
  FailedNum: number
  /**
   * 失败内容
   */
  FailedList: Array<BatchImportFailedListDto>
}

export interface PostV1SkuDownloadFailDataRequestBody {
  /**
   * 表头
   */
  tableHeader: Array<string>
  /**
   * 失败数据
   */
  failData: Array<string>
  /**
   * 用户姓名
   */
  name: string
  /**
   * 用户名
   */
  userName: string
  /**
   * 用户id
   */
  userId: number
  /**
   * 用户姓名
   */
  path: string
}
export interface PostV1SkuDownloadFailDataResponse {
  path: string
}

export interface PostV1SkuImportBatchAddRequestBody {
  file?: void
}
export interface PostV1SkuImportBatchAddResponse {
  /**
   * 成功条数
   */
  TotalNumber: number
  /**
   * 成功条数
   */
  SuccessNumber: number
  /**
   * 失败条数
   */
  FailedNumber: number
  /**
   * 成功内容
   */
  SuccessList: Array<BatchAddResData>
  /**
   * 失败内容
   */
  FailedList: Array<BatchAddResData>
}

export interface PostV1SkuBatchPutawayRequestBody {
  /**
   * 要上架的药品id
   */
  SkuIDs: Array<number>
  /**
   * 药店id
   */
  storeId: number
}
export interface PostV1SkuBatchPutawayResponse {
  /**
   * 成功条数
   */
  TotalNumber: number
  /**
   * 成功条数
   */
  SuccessNumber: number
  /**
   * 失败条数
   */
  FailedNumber: number
  /**
   * 成功内容
   */
  SuccessList: Array<number>
  /**
   * 失败内容
   */
  FailedList: Array<number>
}
export interface GetV1YhRequestParams {
  page: number

  limit: number
  /**
   * 搜索字段排序：sorts=[key,-key]；+或空为正序 -为倒序
   */
  sorts?: string
  /**
   * 三方编码
   */
  thirdPartyNo?: string
  /**
   * 批准文号
   */
  approvalNumber?: string
  /**
   * 药品名称
   */
  genericName?: string
}

export interface GetV1YhResponse {
  total: number
  data: Array<SkuYhDto>
}
export interface GetV1YhShowRequestParams {
  /**
   * 三方编码
   */
  thirdPartyNo?: string
  /**
   * 批准文号
   */
  approvalNumber?: string
  /**
   * 药品名称
   */
  genericName?: string
}

export interface GetV1YhShowResponse {
  /**
   * 药品编码
   */
  medNumber: string
  /**
   * 批准文号
   */
  approvalNumber: string
  /**
   * 药品名称
   */
  genericName: string
  /**
   * 产地
   */
  manufacturerAddress: string
  /**
   * 规格
   */
  pack: string
  /**
   * 售卖单元
   */
  saleUnit: string
  /**
   * 卖价
   */
  salePrice: number
  /**
   * 库存
   */
  stock: number
  /**
   * 创建时间
   */
  createTime: number
}

export interface PutV1BusinessChannelSkuMappingModifySalePriceRequestBody {
  /**
   * 业务渠道ID
   */
  businessChannelId: number
  /**
   * SKU ID
   */
  skuId: number
  /**
   * 业务渠道零售价
   */
  salePrice: number
}
export interface PutV1BusinessChannelSkuMappingModifySalePriceResponse {}

export interface PostV1BusinessChannelSkuMappingImportPriceRequestBody {
  file?: void
}
export interface PostV1BusinessChannelSkuMappingImportPriceResponse {
  /**
   * 批量导入列表
   */
  bcPriceList: Array<BcPriceListDto>
  /**
   * 成功数量
   */
  successNum: number
  /**
   * 失败数量
   */
  failedNum: number
}

export interface GetV1BusinessChannelSkuMappingExportTemplateResponse {}

export interface PostV1BusinessChannelSkuMappingDownloadFailDataRequestBody {
  /**
   * 表头
   */
  tableHeader: Array<string>
  /**
   * 失败数据
   */
  failData: Array<string>
  /**
   * 用户姓名
   */
  name: string
  /**
   * 用户名
   */
  userName: string
  /**
   * 用户id
   */
  userId: number
  /**
   * 用户姓名
   */
  path: string
}
export interface PostV1BusinessChannelSkuMappingDownloadFailDataResponse {
  path: string
}
export interface GetV1ErrorLogRequestParams {
  page: number

  limit: number
  /**
   * 搜索字段排序：sorts=[key,-key]；+或空为正序 -为倒序
   */
  sorts?: string
}

export interface GetV1ErrorLogResponse {
  list: Array<string>
  total: number
}

export interface GetV1ErrorLogExportByIdResponse {}
export interface GetV1StoreRequestParams {
  page: number

  limit: number
  /**
   * 搜索字段排序：sorts=[key,-key]；+或空为正序 -为倒序
   */
  sorts?: string
  /**
   * 药店 ID
   */
  id?: number
  /**
   * 供应商渠道id
   */
  channelId?: Array<number>
  /**
   * 药店名称
   */
  title?: string
}

export interface GetV1StoreResponse {
  list: Array<StoreDto>
  total: number
}

export interface GetV1StoreByIdResponse {
  /**
   * 药店id
   */
  id: number
  /**
   * 供应商渠道id
   */
  channelId: number
  /**
   * 药店名称
   */
  title: string
  /**
   * 是否支持代煎
   */
  canMake: number
  /**
   * 代煎费
   */
  makePrice: number
  /**
   * 药店类型 1 西药 2 中药
   */
  storeType: number
  /**
   * 中药店类型 1 引片 2 颗粒
   */
  cnMedStoreType: number
  /**
   * 定价模式 1 高开模式 2 加成模式
   */
  pricingMode: number
  /**
   * 线下药店模式 是否有线下药店?是:1;否:2;默认2
   */
  toC: number
  /**
   * 药店开铺时间
   */
  startTime: number
  /**
   * 药店打烊时间
   */
  endTime: number
  /**
   * 是否穿行药店 0 否 1 是
   */
  isTrajection: number
  /**
   * 购买方式：1 快递配送; 2 货到付款; 4 自提&线上支付; 8 自提&线下支付
   */
  buyMethods: Array<number>
}

export interface PutV1StoreByIdRequestBody {
  /**
   * 是否待煎
   */
  canMake?: number
  /**
   * 代煎费
   */
  makePrice?: number
  /**
   * 开铺时间
   */
  startTime?: number
  /**
   * 打烊时间
   */
  endTime?: number
}
export interface PutV1StoreByIdResponse {}

export interface PutV1StoreSetStoreToCRequestBody {
  /**
   * 线下药店模式 是否有线下药店?是:1;否:2;默认2
   */
  toC: number
}
export interface PutV1StoreSetStoreToCResponse {}

export interface PostV1StoreChangePricingModeByIdRequestBody {
  /**
   * 定价模式
   */
  pricingMode?: number
}
export interface PostV1StoreChangePricingModeByIdResponse {}
export interface GetV1StoreProcessingRequestParams {
  /**
   * 中药药店类型
   */
  cnMedStoreType?: number
  /**
   * 剂型加工方式
   */
  method?: number
}

export interface GetV1StoreProcessingResponse {
  /**
   * 实体类
   */
  data: Array<ProcessingEntityDto>
}

export interface PostV1StoreProcessingRequestBody {
  /**
   * 中药药店类型
   */
  cnMedStoreType: number
  /**
   * 剂型加工方式
   */
  method: number
  /**
   * 起订量
   */
  minQuantity: number
  /**
   * 出方率上限
   */
  upperOutRate: number
  /**
   * 出方率下限
   */
  lowerOutRate: number
  /**
   * 收费标准
   */
  processingCharges: Array<ProcessingChargeReqDto>
}
export interface PostV1StoreProcessingResponse {}

export interface PutV1StoreProcessingByIdRequestBody {
  /**
   * 中药药店类型
   */
  cnMedStoreType: number
  /**
   * 剂型加工方式
   */
  method: number
  /**
   * 起订量
   */
  minQuantity: number
  /**
   * 出方率上限
   */
  upperOutRate: number
  /**
   * 出方率下限
   */
  lowerOutRate: number
  /**
   * 收费标准
   */
  processingCharges: Array<ProcessingChargeEntityDto>
}
export interface PutV1StoreProcessingByIdResponse {}

export interface DeleteV1StoreProcessingByIdRequestBody {
  /**
   * 药店 ID
   */
  storeId?: number
  /**
   * 中药药店类型
   */
  cnMedStoreType?: number
  /**
   * 剂型加工方式
   */
  method?: number
}
export interface DeleteV1StoreProcessingByIdResponse {}
export interface GetV1SpuRequestParams {
  page: number

  limit: number
  /**
   * 搜索字段排序：sorts=[key,-key]；+或空为正序 -为倒序
   */
  sorts?: string
  /**
   * 通用名称
   */
  genericName?: string
  /**
   * Spu Id
   */
  id?: number
  /**
   * 状态
   */
  status?: number
  /**
   * 平台规则
   */
  storeRole?: number
  /**
   * Spu Type
   */
  spuType: number
  /**
   * 批准文号/注册证
   */
  approvalNumber?: string
  /**
   * 本位码
   */
  standardCode?: string
  /**
   * 一级类目 Id
   */
  backCategoryType: string
  /**
   * 药店ID
   */
  storeId?: number
}

export interface GetV1SpuResponse {
  /**
   * 总条数
   */
  total: number
  /**
   * 数据项
   */
  data: Array<SpuDtos>
}
export interface GetV1SpuDraftRequestParams {
  page: number

  limit: number
  /**
   * 搜索字段排序：sorts=[key,-key]；+或空为正序 -为倒序
   */
  sorts?: string
  /**
   * 本位码
   */
  standardCode?: string
  /**
   * 批准文号
   */
  approvalNumber?: string
  /**
   * 药品状态 -1-无效/下架，0-未知（默认），1-有效/上架
   */
  status?: number
  /**
   * 关键词
   */
  keyword?: string
  /**
   * spu、sku商品类目：DRUG-药品，MEDICAL-医疗器械，HEALTH-保健品，SERVICE-医疗服务, COSMETIC-化妆品, CHINESE-中药饮片
   */
  backCategoryType?: string
  /**
   * 店铺规则 0-无限制；1-仅限自营药店
   */
  storeRule?: number
  /**
   * 药品名称
   */
  medicineName?: string
  /**
   * 商品名称
   */
  tradeName?: string
}

export interface GetV1SpuDraftResponse {
  total: number
  data: Array<DraftDto>
}

export interface GetV1SpuByIdResponse {
  /**
   * spu id
   */
  id: number
  backgroundCategory: BackendCategoryDto
  backgroundCategoryPInfo: BackendCategoryDto
  backgroundCategoryPpInfo: BackendCategoryDto
  /**
   * 药品名
   */
  tradeName: string
  /**
   * 商品名
   */
  genericName: string
  /**
   * 药学分类
   */
  genre: number
  /**
   * 限制类别
   */
  restrainType: number
  /**
   * 医保类别：0-非医保；1-甲；2-乙；3-丙；4-民族药
   */
  medicareCategoryId?: number
  /**
   * 规格
   */
  specification: string
  /**
   * 生产企业
   */
  manufacturerTitle: string
  /**
   * 批准文号/注册称号
   */
  approvalNumber: string
  /**
   * 药品本位码
   */
  standardCode: string
  /**
   * 处方类型： 0-处方；1-非处方
   */
  otcType: number
  /**
   * 给药途径
   */
  instructionsCategory: number
  /**
   * 是否自营：0 否 1 是
   */
  storeRule: number
  /**
   * 上下架：-1 下架 0 未知 1 上架
   */
  status: number
  /**
   * 是否自营
   */
  isSelf: boolean
  /**
   * 是否统一定价
   */
  isUnifiedPrice: boolean
  /**
   * 合作药企
   */
  cooperative: number
  /**
   * 售卖区域
   */
  saleZone: number
  spuCnMed: SpuCnMedEntityDto
  spuMachine: SpuMachineEntityDto
  spuNutrition: SpuNutritionEntiryDto
  spuCosmetic: SpuCosmeticEntityDto
  /**
   * 相关标签
   */
  tags: string
  /**
   * 英文名称
   */
  enName?: string
  /**
   * 剂型
   */
  formulation?: string
  /**
   * 生产地址
   */
  manufacturerAddress?: string
  /**
   * 联系人
   */
  manufacturerPhone?: string
  /**
   * 批准日期
   */
  approvalDate?: number
  /**
   * 所属慢病
   */
  chronicDiseases: Array<ChronicDiseaseDto>
  /**
   * 适应症分类
   */
  indicationCategory: number
  /**
   * 有效期
   */
  shelfLife?: string
  /**
   * 功能主治
   */
  indication?: string
  /**
   * 成分
   */
  ingredient?: string
  /**
   * 用法用量
   */
  usage?: string
  /**
   * 药理作用
   */
  pharmacological?: string
  /**
   * 药动学
   */
  pharmacokinetics?: string
  /**
   * 药物相互作用
   */
  drugInteraction?: string
  /**
   * 不良反应
   */
  adverseReaction?: string
  /**
   * 禁忌
   */
  contraindication?: string
  /**
   * 特殊人群用药
   */
  specialCrowdNotice?: string
  /**
   * 注意事项
   */
  consideration?: string
  /**
   * 贮藏
   */
  storage?: string
  /**
   * 起售数量
   */
  minimumSale?: number
  /**
   * 销售单位/包装单位
   */
  saleUnit?: string
  /**
   * 包装规格
   */
  packs: Array<PackDto>
}

export interface PostV1SpuSaveRuleRequestBody {
  /**
   * SPU id
   */
  spuId: number
  /**
   * 是否自营
   */
  isSelf: boolean
  /**
   * 是否统一定价
   */
  isUnifiedPrice?: boolean
  /**
   * 包装规格对应的价格
   */
  spuPacks?: Array<SpuPackRulesDto>
  /**
   * 合作药企
   */
  cooperative?: number
  /**
   * 售卖区域
   */
  saleZone: number
  /**
   * 药店规则
   */
  storeRule: number
  /**
   * spu销售地区
   */
  spuSaleZoneEntity?: Array<SpuSaleZoneDto>
}
export interface PostV1SpuSaveRuleResponse {
  /**
   * spuId
   */
  spuId: number
  /**
   * 是否自营
   */
  isSelf: boolean
  /**
   * 是否统一定价
   */
  isUnifiedPrice: boolean
  /**
   * 规则信息
   */
  spuPacks: Array<SpuPackRulesDto>
  /**
   * 合作药企
   */
  cooperative: number
  /**
   * 当药店规格为指定药店
   */
  spuSpecificStoreEntity: Array<SpuSpecificStoreDto>
  /**
   * 销售地区
   */
  spuSaleZoneEntity: Array<SpuSaleZoneDto>
  /**
   * 售卖区域 0 全国 1 部分区域
   */
  saleZone: number
  /**
   * 药店规则 仅限自营药房 0 否 1 是
   */
  storeRule: number
}

export interface PostV1SpuPutawayByIdRequestBody {
  /**
   * spu id
   */
  id: number
  backgroundCategory: BackendCategoryDto
  backgroundCategoryPInfo: BackendCategoryDto
  backgroundCategoryPpInfo: BackendCategoryDto
  /**
   * 药品名
   */
  tradeName: string
  /**
   * 商品名
   */
  genericName: string
  /**
   * 药品类型
   */
  genre: number
  /**
   * 限制类别
   */
  restrainType: number
  /**
   * 适应症分类
   */
  medicareCategoryId?: number
  /**
   * 规格
   */
  specification: string
  /**
   * 生产企业
   */
  manufacturerTitle: string
  /**
   * 批准文号/注册称号
   */
  approvalNumber: string
  /**
   * 药品本位码
   */
  standardCode: string
  /**
   * 处方类型： 0-处方；1-非处方
   */
  otcType: number
  /**
   * 给药途径
   */
  instructionsCategory: number
  /**
   * 药店规则
   */
  storeRule: number
  /**
   * 状态
   */
  status: number
  /**
   * 是否自营
   */
  isSelf: boolean
  /**
   * 是否统一定价
   */
  isUnifiedPrice: boolean
  /**
   * 合作药企
   */
  cooperative: number
  /**
   * 销售区域
   */
  saleZone: number
  spuCnMed: SpuCnMedEntityDto
  spuMachine: SpuMachineEntityDto
  spuNutrition: SpuNutritionEntiryDto
  spuCosmetic: SpuCosmeticEntityDto
  /**
   * SPU ID
   */
  spuId: number
  /**
   * SPU PACK ID
   */
  spuPackId: number
  /**
   * 包装规格名称
   */
  pack: string
  /**
   * 零售价
   */
  salePrice: number
  /**
   * 图片
   */
  images: Array<string>
  /**
   * 药店渠道 ID
   */
  channelId: number
  /**
   * 业务渠道 ID
   */
  businessChannelId: Array<number>
  /**
   * 后台类目ID
   */
  backgroundCategoryId: number
  /**
   * 后台一级类目
   */
  backgroundCategoryPpid: number
  /**
   * 包装规格
   */
  packs: Array<PackDto>
  /**
   * 热度
   */
  hot: number
  /**
   * 库存
   */
  stock: number
  /**
   * 运费模版ID
   */
  tplId: number
  /**
   * 是否统一定价
   */
  spuPacks: Array<SpuPackRulesDto>
  /**
   * 申请类型 0 spu 1 pack 2 sku
   */
  applyType: number
  /**
   * 销售区域
   */
  spuSaleZoneEntity: Array<SpuSaleZoneDto>
  /**
   * 当前药店为指定药店
   */
  spuSpecificStoreEntity: Array<SpuSpecificStoreDto>
}
export interface PostV1SpuPutawayByIdResponse {}

export interface GetV1SpuDownloadBatchAddTemplateResponse {}

export interface GetV1SpuMachineByIdResponse {
  /**
   * Spu Id
   */
  spuId: number
  /**
   * 商品名称
   */
  tradeName: string
  /**
   * 通用名称
   */
  genericName: string
  /**
   * 批准文号/注册证号
   */
  approvalNumber: string
  /**
   * 生产单位
   */
  manufacturerTitle: string
  /**
   * 器械类别
   */
  genre: number
  /**
   * 结构及组成
   */
  indication: string
  /**
   * 使用范围
   */
  usage: string
  /**
   * 生产企业许可证号
   */
  manufactureLicenseNu: string
  /**
   * 产品技术要求编号
   */
  trNu: string
  /**
   * 药械注册证
   */
  machineRegistration: string
  /**
   * 禁忌
   */
  taboo: string
  /**
   * 生产单位地址
   */
  manufacturerAddress: string
  /**
   * 有效期
   */
  shelfLife: string
  /**
   * 相关标签
   */
  tags: string
  /**
   * 批准日期
   */
  approvalDate: number
  /**
   * 包装规格
   */
  packs: Array<PackDto>
  /**
   * 条形码
   */
  barCode: string
  /**
   * 基础 Spu
   */
  baseSpuEntity: void
}

export interface GetV1SpuCnMedByIdResponse {
  /**
   * Spu Id
   */
  spuId: number
  /**
   * 药品名称
   */
  genericName: string
  /**
   * 生产单位
   */
  produceCompany: string
  /**
   * 药品规格
   */
  specification: string
  /**
   * 首字母缩写
   */
  letterName: string
  /**
   * 性味归经
   */
  medType: string
  /**
   * 适应症/主治功能
   */
  indication: string
  /**
   * 用法用量
   */
  usage: string
  /**
   * 注意事项
   */
  consideration: string
  /**
   * 中药类型：1 成药，2 汤药，3 颗粒
   */
  cnMedType: number
  /**
   * 是否处方药：-1 未知，0 处方药，1 OTC药
   */
  otcType: number
  /**
   * 包装单位
   */
  saleUnit: string
  /**
   * 产地
   */
  producingArea: string
  /**
   * 包装规格
   */
  packs: Array<PackDto>
  /**
   * 基础 Spu 信息
   */
  baseSpuEntity: void
  /**
   * 妊娠禁忌 0 无 1 慎用药 2 禁用药
   */
  pregnancyContraindication: number
  /**
   * 是否毒麻类 0 否 1 是
   */
  isToxic: number
  /**
   * 推荐剂量
   */
  recommendDose: string
  /**
   * 用药方法 0 无 1 先煎 2 后下 3 包煎 4 烊化 5 另煎 6 另包 7 冲服
   */
  drugUsage: Array<number>
}

export interface GetV1SpuMedByIdResponse {
  /**
   * Spu Id
   */
  spuId: number
  /**
   * 商品名称
   */
  tradeName: string
  /**
   * 药品名称
   */
  genericName: string
  /**
   * 生产单位
   */
  manufacturerTitle: string
  /**
   * 是否处方药：-1 未知，0 处方药，1 非处方药
   */
  otcType: number
  /**
   * 药品本位码
   */
  standardCode: string
  /**
   * 批准文号/注册证号
   */
  approvalNumber: string
  /**
   * 药品规格
   */
  specification: string
  /**
   * 药品英文名
   */
  enName: string
  /**
   * 相关标签
   */
  tags: string
  /**
   * 剂型
   */
  formulation: string
  /**
   * 批准日期
   */
  approvalDate: number
  /**
   * 医保类别：0 非医保，1 甲，2 乙，3 丙，4 民族药
   */
  medicareCategoryId: number
  /**
   * 成分
   */
  ingredient: string
  /**
   * 适应症/主治功能
   */
  indication: string
  /**
   * 用法用量
   */
  usage: string
  /**
   * 药理作用
   */
  pharmacological: string
  /**
   * 药动学
   */
  pharmacokinetics: string
  /**
   * 药物相互作用
   */
  drugInteraction: string
  /**
   * 不良反应
   */
  adverseReaction: string
  /**
   * 禁忌
   */
  contraindication: string
  /**
   * 注意事项
   */
  consideration: string
  /**
   * 贮藏
   */
  storage: string
  /**
   * 有效期
   */
  shelfLife: string
  /**
   * 生产单位地址
   */
  manufacturerAddress: string
  /**
   * 生产单位联系方式
   */
  manufacturerPhone: string
  /**
   * 包装规格
   */
  packs: Array<PackDto>
  /**
   * 基本 Spu
   */
  baseSpuEntity: void
}

export interface GetV1SpuNutritionByIdResponse {
  /**
   * Spu Id
   */
  spuId: number
  /**
   * 商品名称
   */
  tradeName: string
  /**
   * 通用名称
   */
  genericName: string
  /**
   * 批准文号/注册证号
   */
  approvalNumber: string
  /**
   * 生产单位
   */
  manufacturerTitle: string
  /**
   * 生产单位地址
   */
  manufacturerAddress: string
  /**
   * 有效期
   */
  shelfLife: string
  /**
   * 适用人群：0 全部适用，1 儿童，2 成年人，3 老人
   */
  applicablePeople: number
  /**
   * 适应症/功能主治
   */
  indication: string
  /**
   * 成分
   */
  ingredient: string
  /**
   * 用法用量
   */
  usage: string
  /**
   * 注意事项
   */
  consideration: string
  /**
   * 包装规格
   */
  packs: Array<PackDto>
  /**
   * 条形码
   */
  barCode: string
  /**
   * 基本 Spu
   */
  baseSpuEntity: void
}

export interface GetV1SpuCosmeticByIdResponse {
  /**
   * Spu Id
   */
  spuId: number
  /**
   * 商品名称
   */
  tradeName: string
  /**
   * 通用名称
   */
  genericName: string
  /**
   * 批准文号/注册证号
   */
  approvalNumber: string
  /**
   * 生产单位
   */
  manufacturerTitle: string
  /**
   * 生产单位地址
   */
  manufacturerAddress: string
  /**
   * 成分
   */
  ingredient: string
  /**
   * 适应症/主治功能
   */
  indication: string
  /**
   * 用法用量
   */
  usage: string
  /**
   * 适用人群：0 全部适用，1 儿童，2 成年人，3 老人
   */
  applicablePeople: number
  /**
   * 注意事项
   */
  consideration: string
  /**
   * 有效期
   */
  shelfLife: string
  /**
   * 包装规格
   */
  packs: Array<PackDto>
  /**
   * 条形码
   */
  barCode: string
  /**
   * 基本 Spu
   */
  baseSpuEntity: void

  /**
   * 货号
   */
  itemNo?: string
  /**
   * 重量
   */
  goodsWeight?: string
  /**
   * 配件
   */
  parts?: string
  /**
   * 商品编号
   */
  goodsNo?: string
}

export interface GetV1SpuLifeGoodsByIdResponse {
  /**
   * Spu Id
   */
  spuId: number
  /**
   * 商品名称
   */
  tradeName: string
  /**
   * 通用名称
   */
  genericName: string
  /**
   * 生产单位
   */
  manufacturerTitle: string
  /**
   * 适应症/主治功能
   */
  indication: string
  /**
   * 注意事项
   */
  consideration: string
  /**
   * 包装规格
   */
  packs: Array<PackDto>
  /**
   * 基本 Spu
   */
  baseSpuEntity: void

  /**
   * 货号
   */
  itemNo?: string
  /**
   * 重量
   */
  goodsWeight?: string
  /**
   * 配件
   */
  parts?: string
  /**
   * 商品编号
   */
  goodsNo?: string
}
export interface GetV1DoctorRequestParams {
  /**
   * 医生 Id
   */
  userId?: Array<number>
  /**
   * 医生姓名
   */
  name?: string
  /**
   * 医院 Id
   */
  hospitalId?: Array<number>
  /**
   * 科室 Id
   */
  sectionId?: number
  /**
   * 当前页
   */
  page: number
  /**
   * 查找尺寸
   */
  size: number
}

export interface GetV1DoctorResponse {
  /**
   * 医生信息
   */
  doctorInfo: Array<DoctorDto>
  /**
   * 总数
   */
  total: number
}
export interface GetV1DiscountDiscountRequestParams {
  page: number
  /**
   * 页面Size
   */
  limit: number
}

export interface GetV1DiscountDiscountResponse {
  /**
   * 优惠信息
   */
  discountInfos: Array<DiscountInfoDto>
  /**
   * 条数
   */
  totalNum: number
}

export interface PostV1DiscountDiscountRequestBody {
  /**
   * 优惠名称
   */
  name: string
  /**
   * 优惠折扣
   */
  discount: number
}
export interface PostV1DiscountDiscountResponse {}

export interface PutV1DiscountDiscountByIdRequestBody {
  /**
   * 优惠折扣
   */
  discount: number
  /**
   * 折扣名称
   */
  name: string
}
export interface PutV1DiscountDiscountByIdResponse {}

export interface DeleteV1DiscountDiscountByIdRequestBody {}
export interface DeleteV1DiscountDiscountByIdResponse {}
export interface GetV1DiscountDoctorRequestParams {
  page: number

  limit: number
  /**
   * 搜索字段排序：sorts=[key,-key]；+或空为正序 -为倒序
   */
  sorts?: string
  /**
   * 优惠 ID
   */
  groupId: number
  /**
   * 医生用户 ID
   */
  doctorId?: number
  /**
   * 医生用户姓名
   */
  name?: string
  /**
   * 手机号码
   */
  cellphone?: string
}

export interface GetV1DiscountDoctorResponse {
  /**
   * 总条数
   */
  totalNum: number
  /**
   * 医生信息
   */
  infos: Array<CPDGQueryDoctorInfoDto>
}

export interface PostV1DiscountDoctorRequestBody {
  /**
   * 优惠 ID
   */
  groupId: number
  /**
   * 医生 ID
   */
  doctorId: number
}
export interface PostV1DiscountDoctorResponse {}

export interface DeleteV1DiscountDoctorRequestBody {
  /**
   * 优惠 ID
   */
  groupId: number
  /**
   * 医生 ID
   */
  doctorId: number
}
export interface DeleteV1DiscountDoctorResponse {}
export interface GetV1DiscountDoctorAllRequestParams {
  /**
   * 医生ID
   */
  doctorId?: number
  /**
   * 医生姓名
   */
  name?: string
  /**
   * 电话号码
   */
  cellphone?: string

  page: number
  /**
   * 页面Size
   */
  limit: number
}

export interface GetV1DiscountDoctorAllResponse {
  /**
   * 总条数
   */
  totalNum: number
  /**
   * 医生信息
   */
  doctorInfos: Array<CPDGQueryDoctorInfoDto>
}
export interface GetV1SupplierChannelRequestParams {
  page: number

  limit: number
  /**
   * 搜索字段排序：sorts=[key,-key]；+或空为正序 -为倒序
   */
  sorts?: string
  /**
   * 供应商 ID
   */
  id?: number
  /**
   * 是否自营
   */
  isSelf?: boolean
  /**
   * 供应商渠道名称
   */
  title?: string
}

export interface GetV1SupplierChannelResponse {
  data: Array<SupplierChannelDto>
  total: number
}
export interface GetV1BusinessChannelRequestParams {
  page: number

  limit: number
  /**
   * 搜索字段排序：sorts=[key,-key]；+或空为正序 -为倒序
   */
  sorts?: string
}

export interface GetV1BusinessChannelResponse {
  list: Array<BusinessChannelDto>
  total: number
}
export interface GetV1BusinessChannelChannelRequestParams {
  page: number

  limit: number
  /**
   * 搜索字段排序：sorts=[key,-key]；+或空为正序 -为倒序
   */
  sorts?: string
  /**
   * 供应商渠道ID
   */
  id?: number
  /**
   * 供应商渠道标题
   */
  title?: string
  /**
   * 供应商渠道状态
   */
  status?: number
  /**
   * 供应商渠道是否自营
   */
  isSelf?: boolean
  /**
   * 供应商渠道ids
   */
  ids?: Array<number>
}

export interface GetV1BusinessChannelChannelResponse {
  data: Array<ChannelDto>
  /**
   * 数目
   */
  total: number
  /**
   * 当前页
   */
  curPage: number
}
export interface GetV1PackRequestParams {
  page: number

  limit: number
  /**
   * 搜索字段排序：sorts=[key,-key]；+或空为正序 -为倒序
   */
  sorts?: string
  /**
   * spu id
   */
  spuId: number
}

export interface GetV1PackResponse {
  list: Array<PackDto>
}

export interface PostV1PackRequestBody {
  /**
   * 包装规格名称
   */
  pack: string
  /**
   * 零售价
   */
  salePrice: number
  /**
   * 包装规格图片
   */
  images: Array<string>
  /**
   * SpuId
   */
  spuId: number
  /**
   * 状态
   */
  status?: number
}
export interface PostV1PackResponse {
  /**
   * 包装规格id
   */
  id: number
  /**
   * 包装规格名称
   */
  pack: string
  /**
   * 包装规格图片
   */
  images: Array<string>
  /**
   * 用药频率
   */
  medFrequency: number
  /**
   * 单次剂量
   */
  dose: number
  /**
   * 单次剂量单位
   */
  doseUnit: number
  /**
   * 默认价格
   */
  price: number
  /**
   * 默认优惠价格
   */
  salePrice: number
  /**
   * 单盒药量
   */
  quantity: number
  /**
   * 条形码
   */
  barCode: string
}

export interface PostV1PackPutawayByIdRequestBody {
  /**
   * 药店渠道
   */
  channelId: number
  /**
   * 业务渠道
   */
  businessChannelId: Array<number>
  /**
   * SPU ID
   */
  spuId: number
  /**
   * SPU PACK ID
   */
  spuPackId: number
  /**
   * 包装规格名称
   */
  pack: string
  /**
   * 零售价
   */
  salePrice: number
  /**
   * 零售价
   */
  images: Array<string>
  /**
   * 状态
   */
  status: number
  /**
   * 库存
   */
  stock: number
  /**
   * 热度
   */
  hot: number
  /**
   * 运费模版ID
   */
  tplId: number
}
export interface PostV1PackPutawayByIdResponse {}
export interface GetV1PackPriceAndStockRequestParams {
  /**
   * 包装规格Ids
   */
  ids?: Array<number>
  /**
   * 业务渠道Id
   */
  businessChannelId?: number
  /**
   * 省Id
   */
  provinceId?: number
}

export interface GetV1PackPriceAndStockResponse {}
export interface GetV1OrderRequestParams {
  page: number

  limit: number
  /**
   * 搜索字段排序：sorts=[key,-key]；+或空为正序 -为倒序
   */
  sorts?: string
  /**
   * 订单编号
   */
  transNo?: string
  /**
   * 三方订单编号
   */
   thirdOrderId?: string
  /**
   * 药品名称
   */
  medName?: string
  /**
   * 订单患者姓名
   */
  patientName?: string
  /**
   * 订单患者手机号码
   */
  patientPhone?: string
  /**
   * 处方患者姓名
   */
  prescriptionPatientName?: string
  /**
   * 药品类型 0 西药 1 中药 3 推荐
   */
  typeOfDrug?: number
  /**
   * 处方类型 0 不是纸质 1 是纸质
   */
  isPaperPrescription?: number
  /**
   * 订单支付方式 1 货到付款，2 在线支付，4 到店支付
   */
  payMethod?: number
  /**
   * 下单时间（开始）
   */
  createdAtStart?: number
  /**
   * 下单时间（结束）
   */
  createdAtEnd?: number
  /**
   * 支付时间（开始）
   */
  payAtStart?: number
  /**
   * 支付时间（结束）
   */
  payAtEnd?: number
  /**
   * 发货时间（开始）
   */
  deliverAtStart?: number
  /**
   * 发货时间（结束）
   */
  deliverAtEnd?: number
  /**
   * 配送方式 1快递配送，2 到店自取
   */
  deliveryMethod?: number
  /**
   * 订单标签：1-普通，2-换购主订单，3-换购副订单, 5-线下b2b2c, 6-线上b2b2c 7 歌礼 8 续方预约单
   */
  label?: number
  /**
   * 物流单号
   */
  mailNo?: string
  /**
   * 医生姓名
   */
  doctorName?: string
  /**
   * 医生ID
   */
  doctorId?: number
  /**
   * 药品渠道 ID
   */
  channelId?: number
  /**
   * 药品渠道 ID集合
   */
  channelIds?: Array<number>
  /**
   * 药店 ID
   */
  storeId?: number
  /**
   * 订单状态 1 待支付，2 待发货，3 待收货，4 交易完成，5 已取消，6 交易关闭,7 退款中，8 待取药，9 部分发货
   */
  searchStatus?: number
  /**
   * 是否部分退货 1是，2不是
   */
  isPartReturn?: number
  /**
   * 订单推送状态 0 全部 1 未推送 2 推送成功 3 推送失败
   */
  erpStatus?: number
  /**
   * 包装规格
   */
  pack?: string
  /**
   * 处方编号
   */
  prescriptionNum?: string
  /**
   * 端口来源
   */
  portSrc?: number
}

export interface GetV1OrderResponse {
  /**
   * 总条数
   */
  total: number
  /**
   * 数据项
   */
  data: Array<OrderSearchV2Dto>
  /**
   * 部分发货订单数量
   */
  partialCount: number
}
export interface GetV1OrderDetailRequestParams {
  /**
   * 物流单号
   */
  orderTransNo?: string
  /**
   * 药店id
   */
  storeId?: number
}

export interface GetV1OrderDetailResponse {
  order: OrderDto
  patient: PatientDto
  /**
   * 药品信息
   */
  sku: Array<OrderSkuDto>
  /**
   * 药店id
   */
  searchStatus?: number
  prescription: OrderPrescriptionDto
}
export interface GetV1OrderNewRequestParams {
  /**
   * 查询起始时间（时间戳）
   */
  createdAt: number
  /**
   * 药店Id
   */
  storeId?: number
}

export interface GetV1OrderNewResponse {
  /**
   * 新增的订单个数
   */
  total: number
}

export interface GetV1OrderByIdResponse {
  order: OrderDto
  invoice: InvoiceDto
  /**
   * 药品信息
   */
  details: Array<OrderSkuDto>
  /**
   * 物流信息
   */
  logisticInfo: Array<LogisticOrderDto>
  /**
   * 支付单
   */
  tran: Array<TransactionDto>
  /**
   * 退款单
   */
  refund: Array<RefundDto>
  patient: PatientDto
  prescription: OrderPrescriptionDto
  /**
   * 优惠信息
   */
  promotions: Array<PromotionInfoEntityDto>
  /**
   * 是否是部分支付
   */
  partialPay: boolean
  /**
   * 病程管理费流水
   */
  managePriceTrans: number
}

export interface GetV1OrderRelateByIdResponse {
  parent: OrderDto
  /**
   * 子订单信息
   */
  child: Array<OrderRalateDto>
}

export interface PostV1OrderUploadRequestBody {
  file?: void
}
export interface PostV1OrderUploadResponse {
  /**
   * 总更新订单条数
   */
  cnt: number
  /**
   * 成功更新订单条数
   */
  succ: number
  /**
   * 失败更新订单条数
   */
  fail: number
  /**
   * 详情更新信息
   */
  ret: Array<OrderDeliverErrorDetailDto>
}

export interface PutV1OrderStatusByIdRequestBody {
  /**
   * 订单状态扭转类型 1 货到付款==>确认收款，2 网付店取==>确认取药，3 店付店取==>确认取药，4 货到付款==>拒收
   */
  setType: number
}
export interface PutV1OrderStatusByIdResponse {}

export interface PutV1OrderRemarkByIdRequestBody {
  /**
   * 订单备注
   */
  remark: string
}
export interface PutV1OrderRemarkByIdResponse {}

export interface PutV1OrderAddressByIdRequestBody {
  /**
   * 收货人姓名
   */
  deliverName: string
  /**
   * 收货人手机号
   */
  deliverPhone: string
  /**
   * 详细地址
   */
  deliveryAddressDetail: string
  deliveryArea: DeliveryAreaDto
}
export interface PutV1OrderAddressByIdResponse {}

export interface PostV1OrderConfirmLogisticRequestBody {
  /**
   * 订单编号
   */
  transNo?: string
}
export interface PostV1OrderConfirmLogisticResponse {}

export interface PostV1OrderPushToErpRequestBody {
  /**
   * 订单编号
   */
  transNo: Array<string>
}
export interface PostV1OrderPushToErpResponse {}

export interface GetV1OrderPromotionListResponse {
  /**
   * 数据项
   */
  data: Array<PromotionInfoEntityDto>
}

export interface GetV1OrderDownloadJdExpressTemplateResponse {}

export interface PostV1OrderSaveESupervisionCodeRequestBody {
  /**
   * 物流单号
   */
  transNo?: string
  /**
   * 电子监管码数据组
   */
  codeList?: Array<CodeListDto>
}
export interface PostV1OrderSaveESupervisionCodeResponse {}

export interface PostV1OrderGetAvgPriceOfSkuRequestBody {
  /**
   * 订单编号
   */
  transNo: string
  /**
   * 售后信息
   */
  AfterSalesInfo: Array<string>
}
export interface PostV1OrderGetAvgPriceOfSkuResponse {
  /**
   * 售后信息
   */
  AfterSalesInfo: Array<string>
}

export interface PostV1OrderCityDistructionRequestBody {
  /**
   * 订单
   */
  orderNo: Array<string>
  /**
   * 1 表示测试联调
   */
  type?: number
}
export interface PostV1OrderCityDistructionResponse {}
export interface GetV1PrescriptionRequestParams {
  page: number

  limit: number
  /**
   * 搜索字段排序：sorts=[key,-key]；+或空为正序 -为倒序
   */
  sorts?: string
  /**
   * 处方id
   */
  id?: number
  /**
   * 处方编号
   */
  transNo?: string
  /**
   * 患者姓名
   */
  patientName?: string
  /**
   * 患者电话
   */
  patientPhone?: string
  /**
   * 处方类型 0 忽略，1 纸质，2 电子
   */
  prescriptionType?: number
  /**
   * 医院名称
   */
  hospitalName?: string
  /**
   * 创建起始时间
   */
  createdStart?: number
  /**
   * 创建结束时间
   */
  createdEnd?: number
  /**
   * 渠道id列表
   */
  businessId?: Array<number>
  /**
   * 是否为测试处方：0 否，1 是
   */
  isTest?: number
  /**
   * 处方状态 包含订单审核状态和使用状态：-1 审核拒绝（不合理），0 未审核（待审核），1 已审核（审核通过），2 已失效，5 已使用
   */
  searchStatus?: number
  /**
   * 医生名称
   */
  doctorName?: string
  /**
   * 医生类型
   */
  doctorType?: number
  /**
   * 药品名称
   */
  drugName?: string
  /**
   * 药品类型：0 未知 1 中西成药 2/3 中药
   */
  pcDrugType?: Array<number>
  /**
   * 处方标签
   */
  prTagType?: number
}

export interface GetV1PrescriptionResponse {
  total: number
  list: Array<PrescriptionSimpleDtoV2>
}
export interface GetV1PrescriptionElectRequestParams {
  page: number

  limit: number
  /**
   * 搜索字段排序：sorts=[key,-key]；+或空为正序 -为倒序
   */
  sorts?: string
  /**
   * 医生 Id
   */
  doctorId?: number
  /**
   * 创建时间开始
   */
  createdBegin?: number
  /**
   * 创建时间结束
   */
  createEnd?: number
  /**
   * 医生类型：0 未设置(默认) 1 定点医生 2 补方医生
   */
  doctorType?: number
  /**
   * 患者 Id
   */
  patientId?: number
  /**
   * 是否补方
   */
  isRemedyPr: number
}

export interface GetV1PrescriptionElectResponse {
  /**
   * 总数
   */
  count: number
  /**
   * 数据项
   */
  data: Array<QueryOneResDto>
}

export interface GetV1PrescriptionElectPrescriptByIdResponse {
  /**
   * 处方页面渲染类型,1-西药处方 2-中药处方 3-特殊处方
   */
  prHtmlType: number
  presData: PresDataDto
  specialPresData: SpecialPresDataDto
}

export interface GetV1PrescriptionElectByIdResponse {
  electronic: ElectronicEntityDto
  /**
   * 药品信息
   */
  drugs: Array<DrugEntityDto>
}
export interface GetV1PrescriptionNewRequestParams {
  /**
   * 查询起始时间（时间戳）
   */
  startTime: number
}

export interface GetV1PrescriptionNewResponse {
  /**
   * 新增的处方个数
   */
  count: number
}

export interface GetV1PrescriptionIllnessResponse {}
export interface GetV1PrescriptionReloadPrDocRequestParams {
  /**
   * 处方号
   */
  transNo: string
}

export interface GetV1PrescriptionReloadPrDocResponse {
  /**
   * 自增id
   */
  id: number
  /**
   * 处方号
   */
  transNo: string
  /**
   * 处方创建时间
   */
  createdTime: string
  /**
   * 处方状态
   */
  status: number
  auditStatus: number
  /**
   * 处方图片
   */
  prImg: string
}
export interface GetV1PrescriptionByIdRequestParams {
  /**
   * 处方类型：1 纸质，2 电子
   */
  type: number
}

export interface GetV1PrescriptionByIdResponse {
  /**
   * 处方自增id
   */
  id: number
  /**
   * 处方编号
   */
  transNo: string
  /**
   * 处方图片（包含电子、纸质）
   */
  photo: string
  /**
   * 处方审核状态：-1-审核拒绝，0-未审核，1-审核通过
   */
  auditStatus: number
  /**
   * 处方使用状态：-1-已失效，0-未发送给患者，1-有效，2-已使用
   */
  status: number
  /**
   * 处方状态：-1 审核拒绝（不合理），0 未审核（待审核），1 已审核（审核通过），2 已失效，5 已使用
   */
  searchStatus: number
  pharmacist: PharmacistDto
  /**
   * 处方创建时间
   */
  createdTime: string
  /**
   * 处方审核时间
   */
  auditTime: number
  /**
   * 是否可以补方：0 不能补方，1 可以补方
   */
  isConvert: number
  /**
   * 纸质处方对应的订单药品信息
   */
  sku: Array<OrderSkuDto>
}

export interface GetV1PrescriptionPaperByIdResponse {
  /**
   * 自增id
   */
  id: number
  /**
   * 补方后的电子处方编号
   */
  prescriptionId: number
  /**
   * 患者姓名
   */
  patientName: string
  /**
   * 患者性别：0 未知，1 男，2 女
   */
  patientGender: number
  /**
   * 患者生日yyyy-mm-dd格式数字转换为时间戳
   */
  patientBirthday: number
  /**
   * 患者年龄
   */
  patientAge: number
  pharmacist: PharmacistDto
  /**
   * 临床诊断
   */
  diagnose: string
  /**
   * 纸质处方对应的订单药品信息
   */
  sku: Array<PrescriptionDrugSkuDto>
}

export interface PutV1PrescriptionAuditByIdRequestBody {
  /**
   * 操作人类别
   */
  operatorType?: number
  /**
   * 驳回原因
   */
  reason?: string
  /**
   * 备注
   */
  remark?: string
  /**
   * 审核状态：-1 不通过，1 通过
   */
  auditStatus: number
  /**
   * 处方类型：1 纸质，2 电子
   */
  type: number
}
export interface PutV1PrescriptionAuditByIdResponse {}

export interface PutV1PrescriptionConvertByIdRequestBody {
  /**
   * 患者姓名
   */
  patientName: string
  /**
   * 患者性别：0 未知，1 男，2 女
   */
  patientGender: number
  /**
   * 患者年龄
   */
  age: number
}
export interface PutV1PrescriptionConvertByIdResponse {
  /**
   * 电子处方id
   */
  id: number
}
export interface GetV1SecretLogRequestParams {
  page: number

  limit: number
  /**
   * 搜索字段排序：sorts=[key,-key]；+或空为正序 -为倒序
   */
  sorts?: string

  apiType?: number

  status: number
}

export interface GetV1SecretLogResponse {
  data: SecretLogVO
  total: number
}

export interface PostV1OrderErpPushRequestBody {
  /**
   * 订单编号
   */
  transNo: Array<string>
}
export interface PostV1OrderErpPushResponse {}
export interface GetV1OrderErpRequestParams {
  /**
   * 订单编号数组
   */
  TransNoList: Array<string>
}

export interface GetV1OrderErpResponse {
  /**
   * 订单ERP推送状态数组
   */
  StateList: Array<OrderStateDto>
}
export interface GetV1RefundRequestParams {
  page: number

  limit: number
  /**
   * 搜索字段排序：sorts=[key,-key]；+或空为正序 -为倒序
   */
  sorts?: string
  /**
   * 退款订单编号
   */
  id?: number
  /**
   * 订单编号
   */
  transNo?: string
  /**
   * 患者姓名
   */
  patientName?: string
  /**
   * 患者电话
   */
  patientPhone?: string
  /**
   * 退款方式：1 仅退款，2 退货退款
   */
  refundType?: number
  /**
   * 退款单状态：0 全部，1 退款中，2 退款成功，3 退款失败
   */
  refundStatus?: number
  /**
   * 创建起始时间:时间戳
   */
  createdAtStart?: number
  /**
   * 创建结束时间:时间戳
   */
  createdAtEnd?: number
  /**
   * 到账起始时间：时间戳
   */
  recvAtStart?: number
  /**
   * 到账结束时间:时间戳
   */
  recvAtEnd?: number
  /**
   * 退款类型：0 全部，1 退商品，2 退差价
   */
  refundCategory?: number
}

export interface GetV1RefundResponse {
  list: Array<RefundSimpleDto>
  total: number
}

export interface PostV1RefundRequestBody {
  /**
   * 订单id
   */
  transNo: string
  /**
   * 退款商品列表
   */
  sku: Array<RefundSkuDto>
  /**
   * 支付单退款金额设置
   */
  refundStoreInfo: Array<RefundTransDto>
  /**
   * 退款金额（分）
   */
  refundPrice: number
  /**
   * 备注
   */
  remark: string
  /**
   * 操作人
   */
  createUser: string
  /**
   * 退款类型：0 全部，1 退商品，2 退差价
   */
  refundCategory?: number
  /**
   * 是否部分退货 1是，2不是
   */
  isPartReturn: number
}
export interface PostV1RefundResponse {
  /**
   * 操作支付单数量
   */
  transCnt: number
  /**
   * 成功支付单数量
   */
  succCnt: number
  /**
   * 失败支付单数量
   */
  failCnt: number
}

export interface GetV1RefundByIdResponse {
  order: OrderDto
  invoice: InvoiceDto
  /**
   * 药品信息
   */
  sku: Array<OrderSkuDto>
  logisticInfo: LogisticOrderDto
  /**
   * 支付单
   */
  tran: Array<TransactionDto>
  /**
   * 退款单
   */
  refund: Array<RefundDto>
  patient: PatientDto
  prescription: OrderPrescriptionDto
  /**
   * 优惠信息
   */
  promotions: Array<PromotionInfoEntityDto>
  /**
   * 是否是部分支付
   */
  partialPay: boolean
}

export interface PutV1RefundByIdResponse {}
export interface GetV1UserRequestParams {
  /**
   * 查询页码
   */
  page: number
  /**
   * 查询页长
   */
  limit: number
  /**
   * 查询关键字（姓名/手机号）
   */
  queryStr?: string
  /**
   * 用户角色：1 超级管理员 2 管理员 3 云药房药师 4 渠道管理员 5 药店管理员 6 账号管理员
   */
  role?: number
  /**
   * 是否自动审方：1 是 0 否
   */
  autoAudit?: number
  /**
   * 用户状态：0 正常 1 禁用
   */
  blockFlag?: number
  /**
   * 供应商渠道id 列表
   */
  channelIds?: Array<number>
  /**
   * 账号锁定状态：1 正常 2 锁定
   */
  locked?: number
  /**
   * 药店ID
   */
  storeId?: number
}

export interface GetV1UserResponse {
  /**
   * 总条数
   */
  total: number
  list: Array<UserDetailDto>
}

export interface PostV1UserRequestBody {
  /**
   * 姓名
   */
  name: string
  /**
   * 手机号码
   */
  phone: string
  /**
   * 邮箱
   */
  email?: string
  /**
   * 角色id 1 超级管理员 2 管理员 3 云药房药师 4 渠道管理员 5 药店管理员 6 账号管理员
   */
  role: number
  /**
   * 权限列表
   */
  permissions: Array<string>
  /**
   * 渠道列表（渠道管理员和药师必传）
   */
  channelIds?: Array<string>
  /**
   * 药师资格证图片列表
   */
  pharmacistCerts?: Array<string>
  /**
   * 药师资格编号
   */
   pharmacistCertNum?: string
  /**
   * 身份证图片列表
   */
  idCards?: Array<string>
  /**
   * 药师签名图片（药师必传）
   */
  pharmacistSignature?: string
  /**
   * 工作状态：0 休息，1 工作（药师必传）
   */
  workStatus?: number
  /**
   * 药店列表（药店管理员必传）
   */
  storeId?: number
  /**
   * 是否自动审方 1 是 0 否
   */
  autoAudit: object
  /**
   * 是否测试账号 1 否 2 是
   */
  isTest: number
  /**
   * 账号归属 1 未设置 2 自营药房 3 合作药房
   */
  accountRelegation: number
}
export interface PostV1UserResponse {}

export interface GetV1UserMeResponse {
  /**
   * ID
   */
  id: number
  /**
   * 用户 ID
   */
  userId: number
  /**
   * 用户姓名
   */
  name: string
  /**
   * 手机号码
   */
  phone: string
  /**
   * 邮箱
   */
  email: string
  /**
   * 创建人
   */
  createId: number
  /**
   * 角色id：1-超级管理员 2-管理员 3-云药房药师, 4-渠道管理员, 5-药店管理员
   */
  role: number
  /**
   * 权限管理
   */
  permissionData: Array<string>
  /**
   * 药师签名图
   */
  pharmacistSignature: string
  /**
   * 药师资格证
   */
  pharmacistCert: Array<string>
  /**
   * 药师资格编号
   */
   pharmacistCertNum: string
  /**
   * 身份证
   */
  idCards: Array<string>
  // 身份证号
  idcard: string
  // 医网信openid
  ywxOpenId: string
  // 医网信认证状态
  // 第三方（医网信）审核医生的状态. 1：未审核 2：审核中 3：审核通过 4：审核未通过
  ywxVerifyStatus: number
  /**
   * 用户账号状态：0 正常，1 禁用
   */
  blockFlag: number
  /**
   * 用户工作状态：0 休息，1 工作
   */
  workStatus: number
  /**
   * 创建时间
   */
  createAt: number
  /**
   * 创建时间
   */
  updateAt: number
  /**
   * 供应商渠道 ID 列表
   */
  channelIds: Array<number>
  /**
   * 所属药店 ID
   */
  storeId: number
  /**
   * 支持自动审方 0 是 1 否
   */
  autoAudit: number
  /**
   * 是否测试账号 1 否 2 是
   */
  isTest: number
  /**
   * 用户锁定状态 1 正常 2 锁定
   */
  locked: number
  /**
   * 上次修改密码时间
   */
  lastChangePasswordTime: number
  /**
   * 药店名称
   */
  drugstoreName: string
  /**
   * 药店所在省 ID
   */
  drugstoreProvinceId: number
  /**
   * 药店类型
   */
  storeType: number
  /**
   * 药店渠道ID
   */
  storeChannelId: number
  /**
   * 中药店类型
   */
  cnMedStoreType: number
  /**
   * 业务渠道id 列表
   */
  businessChannelIds: Array<string>
  /**
   * 线下药店模式 是否有线下药店?是:1;否:2;默认2
   */
  toC: number
  /**
   * 账号归属 1 未设置 2 自营药房 3 合作药房
   */
  accountRelegation: number
  /**
   * 是否穿行药店 0 否 1 是
   */
  isTrajection: number
  /**
   * 购买方式：1 快递配送; 2 货到付款; 4 自提&线上支付; 8 自提&线下支付
   */
  buyMethods: Array<number>
}

export interface GetV1UserCheckPasswdIdenticalPhoneResponse {
  /**
   * 是否需要修改密码
   */
  needChangePassword: boolean
  /**
   * 密码剩余天数
   */
  passwordRemainingDays: number
}
export interface GetV1UserInfoRequestParams {
  /**
   * 电话号码
   */
  phone?: string
}

export interface GetV1UserInfoResponse {
  /**
   * ID
   */
  id: number
  /**
   * 用户 ID
   */
  userId: number
  /**
   * 用户姓名
   */
  name: string
  /**
   * 手机号码
   */
  phone: string
  /**
   * 邮箱
   */
  email: string
  /**
   * 创建人
   */
  createId: number
  /**
   * 角色id：1-超级管理员 2-管理员 3-云药房药师, 4-渠道管理员, 5-药店管理员
   */
  role: number
  /**
   * 权限管理
   */
  permissionData: Array<string>
  /**
   * 药师签名图
   */
  pharmacistSignature: string
  /**
   * 药师资格证
   */
  pharmacistCert: Array<string>
  /**
   * 药师资格编号
   */
   pharmacistCertNum: string
  /**
   * 身份证
   */
  idCards: Array<string>
  /**
   * 用户账号状态：0 正常，1 禁用
   */
  blockFlag: number
  /**
   * 用户工作状态：0 休息，1 工作
   */
  workStatus: number
  /**
   * 创建时间
   */
  createAt: number
  /**
   * 创建时间
   */
  updateAt: number
  /**
   * 供应商渠道 ID 列表
   */
  channelIds: Array<number>
  /**
   * 所属药店 ID
   */
  storeId: number
  /**
   * 支持自动审方 0 是 1 否
   */
  autoAudit: number
  /**
   * 是否测试账号 1 否 2 是
   */
  isTest: number
  /**
   * 用户锁定状态 1 正常 2 锁定
   */
  locked: number
  /**
   * 上次修改密码时间
   */
  lastChangePasswordTime: number
  /**
   * 药店名称
   */
  drugstoreName: string
  /**
   * 药店所在省 ID
   */
  drugstoreProvinceId: number
  /**
   * 药店类型
   */
  storeType: number
  /**
   * 药店渠道ID
   */
  storeChannelId: number
  /**
   * 中药店类型
   */
  cnMedStoreType: number
  /**
   * 业务渠道id 列表
   */
  businessChannelIds: Array<string>
  /**
   * 线下药店模式 是否有线下药店?是:1;否:2;默认2
   */
  toC: number
  /**
   * 账号归属 1 未设置 2 自营药房 3 合作药房
   */
  accountRelegation: number
  /**
   * 是否穿行药店 0 否 1 是
   */
  isTrajection: number
  /**
   * 购买方式：1 快递配送; 2 货到付款; 4 自提&线上支付; 8 自提&线下支付
   */
  buyMethods: Array<number>
}
export interface GetV1UserCheckPasswordRightRequestParams {
  /**
   * 密码
   */
  password: string
}

export interface GetV1UserCheckPasswordRightResponse {
  /**
   * 是否成功
   */
  isSucc: boolean
}

export interface GetV1UserByIdResponse {
  /**
   * ID
   */
  id: number
  /**
   * 用户 ID
   */
  userId: number
  /**
   * 用户姓名
   */
  name: string
  /**
   * 手机号码
   */
  phone: string
  /**
   * 邮箱
   */
  email: string
  /**
   * 创建人
   */
  createId: number
  /**
   * 角色id：1-超级管理员 2-管理员 3-云药房药师, 4-渠道管理员, 5-药店管理员
   */
  role: number
  /**
   * 权限管理
   */
  permissionData: Array<string>
  /**
   * 药师签名图
   */
  pharmacistSignature: string
  /**
   * 药师资格证
   */
  pharmacistCert: Array<string>
  /**
   * 药师资格编号
   */
  pharmacistCertNum: string
  /**
   * 身份证
   */
  idCards: Array<string>
  idcard: string
  ywxOpenId: string
  // 第三方（医网信）审核医生的状态. 1：未审核 2：审核中 3：审核通过 4：审核未通过
  ywxVerifyStatus: number
  /**
   * 用户账号状态：0 正常，1 禁用
   */
  blockFlag: number
  /**
   * 用户工作状态：0 休息，1 工作
   */
  workStatus: number
  /**
   * 创建时间
   */
  createAt: number
  /**
   * 创建时间
   */
  updateAt: number
  /**
   * 供应商渠道 ID 列表
   */
  channelIds: Array<number>
  /**
   * 所属药店 ID
   */
  storeId: number
  /**
   * 支持自动审方 0 是 1 否
   */
  autoAudit: number
  /**
   * 是否测试账号 1 否 2 是
   */
  isTest: number
  /**
   * 用户锁定状态 1 正常 2 锁定
   */
  locked: number
  /**
   * 上次修改密码时间
   */
  lastChangePasswordTime: number
  /**
   * 药店名称
   */
  drugstoreName: string
  /**
   * 药店所在省 ID
   */
  drugstoreProvinceId: number
  /**
   * 药店类型
   */
  storeType: number
  /**
   * 药店渠道ID
   */
  storeChannelId: number
  /**
   * 中药店类型
   */
  cnMedStoreType: number
  /**
   * 业务渠道id 列表
   */
  businessChannelIds: Array<string>
  /**
   * 线下药店模式 是否有线下药店?是:1;否:2;默认2
   */
  toC: number
  /**
   * 账号归属 1 未设置 2 自营药房 3 合作药房
   */
  accountRelegation: number
  /**
   * 是否穿行药店 0 否 1 是
   */
  isTrajection: number
  /**
   * 购买方式：1 快递配送; 2 货到付款; 4 自提&线上支付; 8 自提&线下支付
   */
  buyMethods: Array<number>
}

export interface PostV1UserCheckPasswordRequestBody {
  /**
   * phone
   */
  phone: string
  /**
   * 用户密码
   */
  password: string
}
export interface PostV1UserCheckPasswordResponse {
  /**
   * 是否通过校验
   */
  isSucc: boolean
}

export interface PutV1UserCpUpdateProfileByIdRequestBody {
  /**
   * Primary ID
   */
  userId: number
  /**
   * 手机号码
   */
  phone?: string
  /**
   * 邮箱
   */
  email?: string
  /**
   * 药师资格证图片列表
   */
  pharmacistCerts?: Array<string>
  /**
   * 药师资格编号
   */
   pharmacistCertNum?: string
  /**
   * 身份证图片列表
   */
  idCards?: Array<string>
  /**
   * 药师签名图片（药师必传）
   */
  pharmacistSignature?: string
  /**
   * 工作状态：0 休息，1 工作（药师必传）
   */
  workStatus?: number
}
export interface PutV1UserCpUpdateProfileByIdResponse {}

export interface PutV1UserCpUpdateMemberInfoByIdRequestBody {
  /**
   * Primary ID
   */
  userId: number
  /**
   * 姓名
   */
  name?: string
  /**
   * 手机号码
   */
  phone?: string
  /**
   * 邮箱
   */
  email?: object
  /**
   * 角色id 1 超级管理员 2 管理员 3 云药房药师 4 渠道管理员 5 药店管理员 6 账号管理员
   */
  role?: number
  /**
   * 权限列表
   */
  permissions?: Array<string>
  /**
   * 渠道列表（渠道管理员和药师必传）
   */
  channelIds?: Array<string>
  /**
   * 药师资格证图片列表
   */
  pharmacistCerts?: Array<string>
  /**
   * 药师资格编号
   */
   pharmacistCertNum?: string
  /**
   * 身份证图片列表
   */
  idCards?: Array<string>
  /**
   * 药师签名图片（药师必传）
   */
  pharmacistSignature?: string
  /**
   * 工作状态：0 休息，1 工作（药师必传）
   */
  workStatus?: number
  /**
   * 药店列表（药店管理员必传）
   */
  storeId?: number
  /**
   * 是否自动审方 1 是 0 否
   */
  autoAudit?: object
  /**
   * 是否测试账号 1 否 2 是
   */
  isTest?: number
  /**
   * 账号归属 1 未设置 2 自营药房 3 合作药房
   */
  accountRelegation?: number
}
export interface PutV1UserCpUpdateMemberInfoByIdResponse {}

export interface PutV1UserCpForbiddenMemberByIdRequestBody {
  /**
   * 用户账号状态：0 正常，1 禁用
   */
  blockFlag?: number
  /**
   * 用户锁定状态 1 正常 2 锁定
   */
  locked?: number
}
export interface PutV1UserCpForbiddenMemberByIdResponse {}

export interface PutV1UserChangePasswordRequestBody {
  /**
   * 用户 ID
   */
  id?: number
  /**
   * 用户手机号码
   */
  phone?: string
  /**
   * 用户新密码
   */
  newPassword?: string
  /**
   * 用户新密码
   */
  oldPassword?: string
  /**
   * 验证码
   */
  verifyCode?: string
}
export interface PutV1UserChangePasswordResponse {}

export interface PutV1UserForgetPasswordRequestBody {
  /**
   * 用户 ID
   */
  id?: number
  /**
   * 用户手机号码
   */
  phone: string
  /**
   * 用户新密码
   */
  newPassword: string
  /**
   * 验证类型 已登录时填 1，未登录填 3
   */
  updateType: number
  /**
   * 验证码
   */
  verifyCode: string
}
export interface PutV1UserForgetPasswordResponse {}

export interface PutV1UserResetPasswordRequestBody {
  /**
   * 用户 ID
   */
  id: number
  /**
   * 用户手机号码
   */
  phone: string
}
export interface PutV1UserResetPasswordResponse {}

export interface PutV1UserClearCookieResponse {}

export interface PostV1UserTokenRequestBody {
  /**
   * 文件上传空间
   */
  scope: string
  /**
   * 是否添加水印
   */
  watermark?: boolean
  /**
   * 上传策略
   */
  policy?: object
}
export interface PostV1UserTokenResponse {
  /**
   * token
   */
  token: string
  /**
   * domain
   */
  domain: string
}
export interface GetV1HospitalHospitalRequestParams {
  /**
   * 医院 Id
   */
  id?: Array<number>
  /**
   * 医院名称
   */
  name?: string
  /**
   * 经纪人 Id
   */
  brokerId?: number
}

export interface GetV1HospitalHospitalResponse {
  /**
   * 医院信息
   */
  hospitalInfo: Array<HospitalDto>
}
export interface GetV1HospitalSectionRequestParams {
  /**
   * 科室ID
   */
  sectionId?: number
  /**
   * 科室名称
   */
  name?: string
  /**
   * 上级ID
   */
  parentId?: number
}

export interface GetV1HospitalSectionResponse {
  /**
   * 数据项
   */
  SectionInfo: Array<SectionInfoDto>
}
export interface GetV1LogisticsRequestParams {
  page: number

  limit: number
  /**
   * 搜索字段排序：sorts=[key,-key]；+或空为正序 -为倒序
   */
  sorts?: string
  /**
   * 订单编号
   */
  transNo?: string
  /**
   * 运单编号
   */
  mailNo?: string
  /**
   * 收货人姓名
   */
  receiverName?: string
  /**
   * 发货状态：-1 已取消 ，0 默认, 1 提交失败，2 ，提交成功
   */
  shipStatus?: number
  /**
   * 打印状态：0 未打印，1 已打印，3 全部
   */
  printStatus?: number
  /**
   * 寄送状态:-1全部 0已发货，1已揽件，2运输中，3派送中，4待取件，5已签收 6拒签
   */
  logisticsActStatus?: number
  /**
   * 创建时间起始时间
   */
  createdAtStart?: number
  /**
   * 创建时间结束
   */
  createdAtEnd?: number
  /**
   * 物流公司：1 顺丰，2 其他公司
   */
  platform: number
}

export interface GetV1LogisticsResponse {
  list: Array<LogisticsDto>
  total: number
}

export interface GetV1LogisticsCompanyListResponse {
  data: Array<LogisticsComDto>
}

export interface PutV1LogisticsOrderRequestBody {
  /**
   * 订单编号
   */
  transNo: string
  /**
   * 物流公司
   */
  logisticsCom: string
  /**
   * 物流单号
   */
  logisticsNo: string
}
export interface PutV1LogisticsOrderResponse {}

export interface PostV1LogisticsPrintRequestBody {
  /**
   * 需要打印的发货单id列表
   */
  ids: Array<number>
}
export interface PostV1LogisticsPrintResponse {
  /**
   * 返回的消息
   */
  msg: string
  /**
   * ...
   */
  outPut: string
  /**
   * 打印二联单
   */
  type: string
}

export interface PostV1LogisticsJdprintRequestBody {
  /**
   * 需要打印的发货单订单号列表
   */
  transNo: Array<string>
}
export interface PostV1LogisticsJdprintResponse {
  /**
   * 返回的消息
   */
  data: Array<JdPrintInfoDto>
}

export interface PostV1LogisticsDeliveryImportRequestBody {
  file?: void
}
export interface PostV1LogisticsDeliveryImportResponse {
  /**
   * 更新数据总条数
   */
  cnt: number
  /**
   * 成功条数
   */
  succ: number
  /**
   * 失败条数
   */
  fail: number
  /**
   * 更新发货详细错误信息
   */
  ret: Array<ImportDataRetDetailDto>
}

export interface PostV1LogisticsDeliverySfRequestBody {
  /**
   * 来源
   */
  createdBy?: number
  /**
   * 物流公司
   */
  logisticsCom?: string
  /**
   * 物流数据
   */
  data?: Array<ExpressInfoDto>
}
export interface PostV1LogisticsDeliverySfResponse {
  /**
   * 更新数据总条数
   */
  cnt: number
  /**
   * 成功条数
   */
  succ: number
  /**
   * 失败条数
   */
  fail: number
  /**
   * 更新发货详细错误信息
   */
  ret: Array<ImportDataRetDetailDto>
}

export interface PostV1BachUpdateLogisticsBody {
  /**
   * 订单变化
   */
  transNos: string[]
}
export interface PostV1BachUpdateLogisticsResponse {
  /**
   * 更新数据总条数
   */
  cnt: number
  /**
   * 成功条数
   */
  succ: number
  /**
   * 失败条数
   */
  fail: number
  /**
   * 更新发货详细错误信息
   */
  ret: Array<ImportDataRetDetailDto>
}

export interface PostV1LogisticsUploadFailDataRequestBody {
  /**
   * 失败条数
   */
  failData: Array<FailedListDto>
  /**
   * 用户姓名
   */
  name: string
  /**
   * 用户名
   */
  userName: string
  /**
   * 用户id
   */
  userId: number
  /**
   * 用户姓名
   */
  path: string
}
export interface PostV1LogisticsUploadFailDataResponse {
  path: string
}

export interface PutV1LogisticsOrderLogisticsByIdRequestBody {
  /**
   * 订单物流信息
   */
  data?: Array<UpdateOrderLogisticsItemDto>
}
export interface PutV1LogisticsOrderLogisticsByIdResponse {}

export interface PostV1LogisticsOrderDeliverRequestBody {
  /**
   * 订单编号
   */
  transNo: string
  /**
   * 物流公司
   */
  logisticsCom: string
  /**
   * 物流编号
   */
  logisticsNo?: string
  /**
   * 发货人电话
   */
  deliverPhone?: string
  /**
   * 发货地址
   */
  deliverAddress?: string
  /**
   * 发货详情
   */
  detail: Array<DeliverOrderDetailDto>
}
export interface PostV1LogisticsOrderDeliverResponse {}

export interface PostV1LogisticsStoreConfirmReceiveByIdResponse {}
export interface GetV1FreightTemplateRequestParams {
  page: number

  limit: number
  /**
   * 搜索字段排序：sorts=[key,-key]；+或空为正序 -为倒序
   */
  sorts?: string
  /**
   * 名称
   */
  title?: string
  /**
   * 模版类型: 1 统一运费, 2 指定包邮
   */
  type?: number
}

export interface GetV1FreightTemplateResponse {
  list: Array<FreightTplDetailDto>
  total: number
}

export interface PostV1FreightTemplateRequestBody {
  /**
   * 模板名称
   */
  title: string
  /**
   * 模版类型: 1 统一运费, 2 指定包邮
   */
  type: number
  /**
   * 统一运费(统一模板或者达不到包邮条件)
   */
  normalShippingPrice: number
  /**
   * 包邮条件：默认-1则未设置
   */
  freeShippingThreshold: number
  /**
   * 药店id
   */
  storeId?: number
  /**
   * 配送区域ID
   */
  deliveryId?: string
  /**
   * 配送区域
   */
  deliveryAreas?: Array<string>
  /**
   * 物流公司ID
   */
  logisticsCoCode?: string
  /**
   * 是否货到付款 0 否 1 是
   */
  cashOnDelivery: number
  /**
   * 如果是指定包邮则有二级模板
   */
  freightSecondTpls?: Array<FreightSecondTplDto>
}
export interface PostV1FreightTemplateResponse {
  /**
   * 模板id
   */
  id: number
  /**
   * 模板名称
   */
  title: string
  /**
   * 模版类型: 1 统一运费, 2 指定包邮
   */
  type: number
  /**
   * 统一运费(统一模板或者达不到包邮条件)
   */
  normalShippingPrice: number
  /**
   * 关联的SKU数量
   */
  skuCount: number
  /**
   * 药店id
   */
  storeId: number
  /**
   * 二级模板：如果是统一模板则为空数组
   */
  freightSecondTpls: Array<SubFreightTpl>
  /**
   * 包邮条件：-1为未设置
   */
  freeShippingThreshold: number
  /**
   * 运费配送区域ID
   */
  deliveryId: string
  /**
   * 物流公司对应ID
   */
  logisticsCoCode: string
  /**
   * 是否支持货到付款 0 不支持 1 支持
   */
  cashOnDelivery: number
}

export interface GetV1FreightTemplateByIdResponse {
  /**
   * 模板id
   */
  id: number
  /**
   * 模板名称
   */
  title: string
  /**
   * 模版类型: 1 统一运费, 2 指定包邮
   */
  type: number
  /**
   * 统一运费(统一模板或者达不到包邮条件)
   */
  normalShippingPrice: number
  /**
   * 关联的SKU数量
   */
  skuCount: number
  /**
   * 药店id
   */
  storeId: number
  /**
   * 二级模板：如果是统一模板则为空数组
   */
  freightSecondTpls: Array<SubFreightTpl>
  /**
   * 包邮条件：-1为未设置
   */
  freeShippingThreshold: number
  /**
   * 运费配送区域ID
   */
  deliveryId: string
  /**
   * 物流公司对应ID
   */
  logisticsCoCode: string
  /**
   * 是否支持货到付款 0 不支持 1 支持
   */
  cashOnDelivery: number
}

export interface PutV1FreightTemplateByIdRequestBody {
  /**
   * 模板名称
   */
  title: string
  /**
   * 模版类型: 1 统一运费, 2 指定包邮
   */
  type: number
  /**
   * 统一运费(统一模板或者达不到包邮条件)
   */
  normalShippingPrice: number
  /**
   * 包邮条件：默认-1则未设置
   */
  freeShippingThreshold: number
  /**
   * 药店id
   */
  storeId?: number
  /**
   * 配送区域ID
   */
  deliveryId?: string
  /**
   * 配送区域
   */
  deliveryAreas?: Array<string>
  /**
   * 物流公司ID
   */
  logisticsCoCode?: string
  /**
   * 是否货到付款 0 否 1 是
   */
  cashOnDelivery: number
  /**
   * 如果是指定包邮则有二级模板
   */
  freightSecondTpls?: Array<FreightSecondTplDto>
}
export interface PutV1FreightTemplateByIdResponse {
  /**
   * 模板id
   */
  id: number
  /**
   * 模板名称
   */
  title: string
  /**
   * 模版类型: 1 统一运费, 2 指定包邮
   */
  type: number
  /**
   * 统一运费(统一模板或者达不到包邮条件)
   */
  normalShippingPrice: number
  /**
   * 关联的SKU数量
   */
  skuCount: number
  /**
   * 药店id
   */
  storeId: number
  /**
   * 二级模板：如果是统一模板则为空数组
   */
  freightSecondTpls: Array<SubFreightTpl>
  /**
   * 包邮条件：-1为未设置
   */
  freeShippingThreshold: number
  /**
   * 运费配送区域ID
   */
  deliveryId: string
  /**
   * 物流公司对应ID
   */
  logisticsCoCode: string
  /**
   * 是否支持货到付款 0 不支持 1 支持
   */
  cashOnDelivery: number
  /**
   * 是否是默认模版 0: 否，1: 是
   */
  isDefault: number
}

export interface DeleteV1FreightTemplateByIdResponse {}

export interface PostV1FreightRelateSkuRequestBody {
  /**
   * 模板Id
   */
  freightTplId: number
  /**
   * SKU Id
   */
  skuId?: Array<number>
  /**
   * 关键词搜索（用于批量绑定）
   */
  keywords?: string
}
export interface PostV1FreightRelateSkuResponse {}

export interface DeleteV1FreightRelateSkuRequestBody {
  /**
   * 模板Id
   */
  freightTplId: number
  /**
   * SKU Id
   */
  skuId?: Array<number>
  /**
   * 关键词搜索（用于批量绑定）
   */
  keywords?: string
}
export interface DeleteV1FreightRelateSkuResponse {}
export interface GetV1FreightRetrieveDeliveryRequestParams {
  /**
   * 配送区域ID
   */
  deliveryId?: string
}

export interface GetV1FreightRetrieveDeliveryResponse {
  /**
   * 配送区域id
   */
  deliveryId: string
  /**
   * 配送区域
   */
  areaIds: Array<number>
}
export interface GetV1FreightTplRequestParams {
  /**
   * SKU ID
   */
  skuId: number
  /**
   * 药店 ID
   */
  storeId: number
  /**
   * 区域ID（市）
   */
  areaId: number
}

export interface GetV1FreightTplResponse {
  /**
   * 运费模版 ID
   */
  id: number
  /**
   * 运费模版名称
   */
  title: string
  /**
   * 统一运费
   */
  normalShippingPrice: number
  /**
   * 药店ID
   */
  storeId: number
  /**
   * 包邮条件
   */
  freeShippingThreshold: number
  /**
   * 默认运费模版
   */
  logisticsCoCode: string
}

export interface PostV1FreightCreateDeliveryRequestBody {
  /**
   * 配送区域
   */
  areaIds?: number
}
export interface PostV1FreightCreateDeliveryResponse {
  /**
   * 配送区域id
   */
  deliveryId: string
  /**
   * 配送区域
   */
  areaIds: Array<number>
}
export interface GetV1SettlementRequestParams {
  page: number

  limit: number
  /**
   * 搜索字段排序：sorts=[key,-key]；+或空为正序 -为倒序
   */
  sorts?: string
  /**
   * 起始时间
   */
  createdAtStart?: number
  /**
   * 结束时间
   */
  createdAtEnd?: number
  /**
   * 药店ID
   */
  storeId?: Array<number>
  /**
   * 总金额起始
   */
  amountStart?: number
  /**
   * 总金额截止
   */
  amountEnd?: number
  /**
   * 资金流向: 0-全部,1-收入,2-支出
   */
  queryType?: number
}

export interface GetV1SettlementResponse {
  /**
   * 总收入
   */
  incomeAmount: number
  /**
   * 用户实际支付/收到金额（含手续费）总计
   */
  netTradeAmt: number
  /**
   * 总支出
   */
  payFeeAmount: number
  /**
   * 总支付手续费
   */
  payoutAmount: number
  /**
   * 总商品服务费
   */
  serviceFeeAmount: number
  list: Array<SettlementDto>
  total: number
}

export interface PostV1ReinforcingPresRequestBody {
  /**
   * 是否是补方
   */
  reinforcing: boolean
  electronic: ElectronicReqEntityDto
  /**
   * 处方选择药品
   */
  drugs: Array<DrugReqEntityDto>
}
export interface PostV1ReinforcingPresResponse {
  /**
   * 处方 ID
   */
  prescriptionId: number
}
export interface GetV1ReinforcingPresQrRequestParams {
  /**
   * 补方d
   */
  prescriptionId: number
}

export interface GetV1ReinforcingPresQrResponse {
  /**
   * 二维码地址
   */
  qrCodeUrl: string
}
export interface GetV1WarningNoticeRequestParams {
  page: number

  limit: number
  /**
   * 搜索字段排序：sorts=[key,-key]；+或空为正序 -为倒序
   */
  sorts?: string
  /**
   * 通知类型
   */
  noticeType?: number
  /**
   * 通知时间起始
   */
  startDate?: number
  /**
   * 通知时间结束
   */
  endDate?: number
  storeId?: number
}

export interface GetV1WarningNoticeResponse {
  /**
   * 总条数
   */
  total: number
  /**
   * 未读数
   */
  noReadNum: number
  /**
   * 告警
   */
  warningEntitys: Array<WarningEntityDto>
}

export interface GetV1WarningNoticeByIdResponse {
  warningEntity: WarningEntityDto
}
export interface GetV1WarningSkuRequestParams {
  page: number

  limit: number
  /**
   * 搜索字段排序：sorts=[key,-key]；+或空为正序 -为倒序
   */
  sorts?: string
  /**
   * 库存状态
   */
  warningStatus?: number
  /**
   * Sku Id
   */
  skuId?: number
  /**
   * Pack Id
   */
  packId?: number
  /**
   * 商品名称
   */
  tradeName?: string
  /**
   * 通用名称
   */
  genericName?: string
  /**
   * 后台一级类目
   */
  backgroundCategoryPpid?: number
  /**
   * 后台二级类目
   */
  backgroundCategoryPid?: number
  /**
   * 后台三级类目
   */
  backgroundCategoryId?: number
  /**
   * 安全库存计算方式
   */
  stockCalcMethod?: number
}

export interface GetV1WarningSkuResponse {
  /**
   * 总条数
   */
  total: number
  /**
   * Sku Warning Entiry
   */
  data: Array<SkuWarningEntiry>
}

export interface PutV1WarningSkuRequestBody {
  /**
   * 预警 Id
   */
  id: number
  /**
   * 安全库存类型
   */
  stockCalcMethod: number
  /**
   * 补货周期
   */
  replenishmentEpoch?: number
  /**
   * 安全库存
   */
  safeStock?: number
}
export interface PutV1WarningSkuResponse {
  /**
   * 预警 Id
   */
  id: number
}
export interface GetV1WarningSkuExportRequestParams {
  page: number

  limit: number
  /**
   * 搜索字段排序：sorts=[key,-key]；+或空为正序 -为倒序
   */
  sorts?: string
  /**
   * 库存状态
   */
  warningStatus?: number
  /**
   * Sku Id
   */
  skuId?: number
  /**
   * Pack Id
   */
  packId?: number
  /**
   * 商品名称
   */
  tradeName?: string
  /**
   * 通用名称
   */
  genericName?: string
  /**
   * 后台一级类目
   */
  backgroundCategoryPpid?: number
  /**
   * 后台二级类目
   */
  backgroundCategoryPid?: number
  /**
   * 后台三级类目
   */
  backgroundCategoryId?: number
  /**
   * 安全库存计算方式
   */
  stockCalcMethod?: number
}

export interface GetV1WarningSkuExportResponse {}

export interface TaxClassificationCategories {
  /**
   * 类目级别
   */
  taxLevel: string
  /**
   * 税率
   */
  tax: number
  /**
   * 税率编码
   */
  taxNo: string
  /**
   * 一级类目id
   */
  taxCategoryPId: number
  /**
   * 二级类目id
   */
  taxCategoryId: number
  /**
   * 税率名称
   */
  taxName: string
}
export interface GetV1TaxClassificationCategoriesRequestPramas {}
export interface GetV1TaxClassificationCategoriesResponse {
  total: number
  taxCategoryEntity: Array<TaxClassificationCategories>
}

export interface GetV1ChannelNameRequestPramas {
  title?: string
  page?: number
  limit?: number
}
interface ChannelBusinessChannelMapping {
  id: number
  channelId: number
  backgroundCategoryPpid: number
  businessChannelId: number
  storeType: number
  setPriceOption: number
  doorServicePrice: number
  storeServicePrice: number
  selfServicePrice: number
}
export interface GetV1ChannelNameResponse {
  data: {
    id: number
    title: string
    isSelf: boolean
    remark: string
    pharmacyCount: number
    spuCount: number
    createdAt: number
    updatedAt: number
    sort: number
    channelBusinessChannelMapping: ChannelBusinessChannelMapping
    total: number
    curPage: number
  }
  code: number
  errcode: number
  message: string
  errmsg: string
}

/**
 * 创建SKU（申请上架SKU）
 */
export const postV1ApplyCreate = (
  params: PostV1ApplyCreateRequestBody
): AxiosCancelablePromise<ApiData<PostV1ApplyCreateResponse>> => {
  return service.post(`/v1/apply/create`, params, { baseURL: baseUrl.node })
}

/**
 * 查询SKU申请
 */
export const getV1ApplyApplySkuById = (
  id: string,
  params?: {}
): AxiosCancelablePromise<ApiData<GetV1ApplyApplySkuByIdResponse>> => {
  return service.get(`/v1/apply/applySku/${id}`, { params, baseURL: baseUrl.node })
}

/**
 * 修改SKU申请
 */
export const putV1ApplyApplySkuById = (
  id: string,
  params: PutV1ApplyApplySkuByIdRequestBody
): AxiosCancelablePromise<ApiData<PutV1ApplyApplySkuByIdResponse>> => {
  return service.put(`/v1/apply/applySku/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 删除SKU申请
 */
export const deleteV1ApplyApplySkuById = (
  id: string,
  params?: {}
): AxiosCancelablePromise<ApiData<DeleteV1ApplyApplySkuByIdResponse>> => {
  return service.delete(`/v1/apply/applySku/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 审核SKU申请
 */
export const postV1ApplyExamSkuById = (
  id: string,
  params: PostV1ApplyExamSkuByIdRequestBody
): AxiosCancelablePromise<ApiData<PostV1ApplyExamSkuByIdResponse>> => {
  return service.post(`/v1/apply/examSku/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 查询SPU申请
 */
export const getV1ApplyApplySpuById = (
  id: string,
  params?: {}
): AxiosCancelablePromise<ApiData<GetV1ApplyApplySpuByIdResponse>> => {
  return service.get(`/v1/apply/applySpu/${id}`, { params, baseURL: baseUrl.node })
}

/**
 * 修改首营
 */
export const putV1ApplyApplySpuById = (
  id: string,
  params: PutV1ApplyApplySpuByIdRequestBody
): AxiosCancelablePromise<ApiData<PutV1ApplyApplySpuByIdResponse>> => {
  return service.put(`/v1/apply/applySpu/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 申请首营
 */
export const postV1ApplyApplySpuCamp = (
  params: PostV1ApplyApplySpuCampRequestBody
): AxiosCancelablePromise<ApiData<PostV1ApplyApplySpuCampResponse>> => {
  return service.post(`/v1/apply/applySpuCamp`, params, { baseURL: baseUrl.node })
}

/**
 * 新增包装规格
 */
export const postV1ApplyAddPackById = (
  id: number,
  params: PostV1ApplyAddPackByIdRequestBody
): AxiosCancelablePromise<ApiData<PostV1ApplyAddPackByIdResponse>> => {
  return service.post(`/v1/apply/addPack/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 获取剂量单位
 * @returns
 */
export const getPackEnum = (): AxiosCancelablePromise<ApiData<PostGetPackEnumResponse>> => {
  // return service.post(`/v1/apply/addPack/${id}`, params, { baseURL: baseUrl.node })
  return service.get(`/medication-interface/v1/pack/enum`, {
    params: {},
    baseURL: baseUrl.cloudPharmacyInterface,
  })
}

/**
 * 修改包装规格
 */
export const putV1ApplyAddPackById = (
  id: string,
  params: PutV1ApplyAddPackByIdRequestBody
): AxiosCancelablePromise<ApiData<PutV1ApplyAddPackByIdResponse>> => {
  return service.put(`/v1/apply/addPack/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 移除申请（撤回）
 */
export const deleteV1ApplyById = (
  id: string,
  params?: {}
): AxiosCancelablePromise<ApiData<DeleteV1ApplyByIdResponse>> => {
  return service.delete(`/v1/apply/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 修改状态
 */
export const putV1ApplyApplyStatusById = (
  id: string,
  params: PutV1ApplyApplyStatusByIdRequestBody
): AxiosCancelablePromise<ApiData<PutV1ApplyApplyStatusByIdResponse>> => {
  return service.put(`/v1/apply/applyStatus/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 检索SPU申请
 */
export const getV1ApplyApplyList = (
  params: GetV1ApplyApplyListRequestParams
): AxiosCancelablePromise<ApiData<GetV1ApplyApplyListResponse>> => {
  return service.get(`/v1/apply/applyList`, { params, baseURL: baseUrl.node })
}

/**
 * 查询后台类目列表
 */
export const getV1BackendCategory = (
  params: GetV1BackendCategoryRequestParams
): AxiosCancelablePromise<ApiData<GetV1BackendCategoryResponse>> => {
  return service.get(`/v1/backendCategory`, { params, baseURL: baseUrl.node })
}

/**
 * 创建后台类目
 */
export const postV1BackendCategory = (
  params: PostV1BackendCategoryRequestBody
): AxiosCancelablePromise<ApiData<PostV1BackendCategoryResponse>> => {
  return service.post(`/v1/backendCategory`, params, { baseURL: baseUrl.node })
}

/**
 * 编辑后台类目
 */
export const putV1BackendCategory = (
  params: PutV1BackendCategoryRequestBody
): AxiosCancelablePromise<ApiData<PutV1BackendCategoryResponse>> => {
  return service.put(`/v1/backendCategory`, params, { baseURL: baseUrl.node })
}

/**
 * 删除后台类目
 */
export const deleteV1BackendCategory = (
  params: DeleteV1BackendCategoryRequestParams
): AxiosCancelablePromise<ApiData<DeleteV1BackendCategoryResponse>> => {
  return service.delete(`/v1/backendCategory`, params, { baseURL: baseUrl.node })
}

/**
 * 检索后台类目
 */
export const getV1BackendCategoryShow = (
  params: GetV1BackendCategoryShowRequestParams
): AxiosCancelablePromise<ApiData<GetV1BackendCategoryShowResponse>> => {
  return service.get(`/v1/backendCategory/show`, { params, baseURL: baseUrl.node })
}

/**
 * 搜索sku列表
 */
export const getV1Sku = (
  params: GetV1SkuRequestParams
): AxiosCancelablePromise<ApiData<GetV1SkuResponse>> => {
  return service.get(`/v1/sku`, { params, baseURL: baseUrl.node })
}

/**
 * 创建sku
 */
export const postV1Sku = (
  params: PostV1SkuRequestBody
): AxiosCancelablePromise<ApiData<PostV1SkuResponse>> => {
  return service.post(`/v1/sku`, params, { baseURL: baseUrl.node })
}

/**
 * 检索sku
 */
export const getV1SkuById = (
  id: number,
  params?: {}
): AxiosCancelablePromise<ApiData<GetV1SkuByIdResponse>> => {
  return service.get(`/v1/sku/${id}`, { params, baseURL: baseUrl.node })
}

/**
 * 编辑sku
 */
export const putV1SkuById = (
  id: number,
  params: PutV1SkuByIdRequestBody
): AxiosCancelablePromise<ApiData<PutV1SkuByIdResponse>> => {
  return service.put(`/v1/sku/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 删除sku
 */
export const deleteV1SkuById = (
  id: string,
  params?: {}
): AxiosCancelablePromise<ApiData<DeleteV1SkuByIdResponse>> => {
  return service.delete(`/v1/sku/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 编辑sku上下架状态和价格（如果未传价格，则使用原价格）
 */
export const putV1SkuStatusById = (
  id: number,
  params: PutV1SkuStatusByIdRequestBody
): AxiosCancelablePromise<ApiData<PutV1SkuStatusByIdResponse>> => {
  return service.put(`/v1/sku/status/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 上传sku批量修改库存
 */
export const putV1SkuStockMul = (
  params: PutV1SkuStockMulRequestBody
): AxiosCancelablePromise<ApiData<PutV1SkuStockMulResponse>> => {
  // return service.put(`/v1/sku/stock/mul`, params, { baseURL: baseUrl.node })
  return service.post(`/medication-interface/v1/channelManager/batch/sku/stock`, params, { baseURL: baseUrl.cloudPharmacyInterface })
}

/**
 * 上架SKU
 */
export const postV1SkuPutawayById = (
  id: string,
  params: PostV1SkuPutawayByIdRequestBody
): AxiosCancelablePromise<ApiData<PostV1SkuPutawayByIdResponse>> => {
  return service.post(`/v1/sku/putaway/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 设置加成
 */
export const postV1SkuSetAddition = (
  params: PostV1SkuSetAdditionRequestBody
): AxiosCancelablePromise<ApiData<PostV1SkuSetAdditionResponse>> => {
  return service.post(`/v1/sku/setAddition`, params, { baseURL: baseUrl.node })
}

/**
 * 下载导入底价模板
 */
export const getV1SkuDownloadFloorPriceTemplate = (params?: {}): AxiosCancelablePromise<ApiData<
  GetV1SkuDownloadFloorPriceTemplateResponse
>> => {
  return service.get(`/v1/sku/download/floorPriceTemplate`, { params, baseURL: baseUrl.node })
}

/**
 * 导入底价
 */
export const postV1SkuImportFloorPrice = (
  params: PostV1SkuImportFloorPriceRequestBody
): AxiosCancelablePromise<ApiData<PostV1SkuImportFloorPriceResponse>> => {
  return service.post(`/v1/sku/import/floorPrice`, params, { baseURL: baseUrl.node })
}

/**
 * 下载失败数据
 */
export const postV1SkuDownloadFailData = (
  params: PostV1SkuDownloadFailDataRequestBody
): AxiosCancelablePromise<ApiData<PostV1SkuDownloadFailDataResponse>> => {
  return service.post(`/v1/sku/download/failData`, params, { baseURL: baseUrl.node })
}

/**
 * 批量添加中药
 */
export const postV1SkuImportBatchAdd = (
  params: PostV1SkuImportBatchAddRequestBody
): AxiosCancelablePromise<ApiData<PostV1SkuImportBatchAddResponse>> => {
  return service.post(`/v1/sku/import/batchAdd`, params, { baseURL: baseUrl.node })
}

/**
 * 批量上架
 */
export const postV1SkuBatchPutaway = (
  params: PostV1SkuBatchPutawayRequestBody
): AxiosCancelablePromise<ApiData<PostV1SkuBatchPutawayResponse>> => {
  return service.post(`/v1/sku/batch/putaway`, params, { baseURL: baseUrl.node })
}

/**
 * 查询燕化药品列表
 */
export const getV1Yh = (
  params: GetV1YhRequestParams
): AxiosCancelablePromise<ApiData<GetV1YhResponse>> => {
  return service.get(`/v1/yh`, { params, baseURL: baseUrl.node })
}

/**
 * 查询燕华药品详情
 */
export const getV1YhShow = (
  params: GetV1YhShowRequestParams
): AxiosCancelablePromise<ApiData<GetV1YhShowResponse>> => {
  return service.get(`/v1/yh/show`, { params, baseURL: baseUrl.node })
}

/**
 * 修改业务渠道价格
 */
export const putV1BusinessChannelSkuMappingModifySalePrice = (
  params: PutV1BusinessChannelSkuMappingModifySalePriceRequestBody
): AxiosCancelablePromise<ApiData<PutV1BusinessChannelSkuMappingModifySalePriceResponse>> => {
  return service.put(`/v1/businessChannelSkuMapping/modifySalePrice`, params, {
    baseURL: baseUrl.node,
  })
}

/**
 * 导入线下零售价模板
 */
export const postV1BusinessChannelSkuMappingImportPrice = (
  params: PostV1BusinessChannelSkuMappingImportPriceRequestBody
): AxiosCancelablePromise<ApiData<PostV1BusinessChannelSkuMappingImportPriceResponse>> => {
  return service.post(`/v1/businessChannelSkuMapping/importPrice`, params, {
    baseURL: baseUrl.node,
  })
}

/**
 * 导出线下零售价导入模板
 */
export const getV1BusinessChannelSkuMappingExportTemplate = (params?: {}): AxiosCancelablePromise<ApiData<
  GetV1BusinessChannelSkuMappingExportTemplateResponse
>> => {
  return service.get(`/v1/businessChannelSkuMapping/exportTemplate`, {
    params,
    baseURL: baseUrl.node,
  })
}

/**
 * 下载失败数据
 */
export const postV1BusinessChannelSkuMappingDownloadFailData = (
  params: PostV1BusinessChannelSkuMappingDownloadFailDataRequestBody
): AxiosCancelablePromise<ApiData<PostV1BusinessChannelSkuMappingDownloadFailDataResponse>> => {
  return service.post(`/v1/businessChannelSkuMapping/download/failData`, params, {
    baseURL: baseUrl.node,
  })
}

export const getV1ErrorLog = (
  params: GetV1ErrorLogRequestParams
): AxiosCancelablePromise<ApiData<GetV1ErrorLogResponse>> => {
  return service.get(`/v1/error-log`, { params, baseURL: baseUrl.node })
}

export const getV1ErrorLogExportById = (
  id: string,
  params?: {}
): AxiosCancelablePromise<ApiData<GetV1ErrorLogExportByIdResponse>> => {
  return service.get(`/v1/error-log/export/${id}`, { params, baseURL: baseUrl.node })
}

/**
 * 获取药店列表
 */
export const getV1Store = (
  params: GetV1StoreRequestParams
): AxiosCancelablePromise<ApiData<GetV1StoreResponse>> => {
  return service.get(`/v1/store`, { params, baseURL: baseUrl.node })
}

/**
 * 获取药店信息
 */
export const getV1StoreById = (
  id: number,
  params?: {}
): AxiosCancelablePromise<ApiData<GetV1StoreByIdResponse>> => {
  return service.get(`/v1/store/${id}`, { params, baseURL: baseUrl.node })
}

/**
 * 编辑药店信息
 */
export const putV1StoreById = (
  id: number,
  params: PutV1StoreByIdRequestBody
): AxiosCancelablePromise<ApiData<PutV1StoreByIdResponse>> => {
  return service.put(`/v1/store/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 修改药店线下模式
 */
export const putV1StoreSetStoreToC = (
  params: PutV1StoreSetStoreToCRequestBody
): AxiosCancelablePromise<ApiData<PutV1StoreSetStoreToCResponse>> => {
  return service.put(`/v1/store/setStoreToC`, params, { baseURL: baseUrl.node })
}

/**
 * 编辑定价模式
 */
export const postV1StoreChangePricingModeById = (
  id: number,
  params: PostV1StoreChangePricingModeByIdRequestBody
): AxiosCancelablePromise<ApiData<PostV1StoreChangePricingModeByIdResponse>> => {
  return service.post(`/v1/store/changePricingMode/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 查询药店支持的剂型加工方式
 */
export const getV1StoreProcessing = (
  params: GetV1StoreProcessingRequestParams
): AxiosCancelablePromise<ApiData<GetV1StoreProcessingResponse>> => {
  return service.get(`/v1/storeProcessing`, { params, baseURL: baseUrl.node })
}

/**
 * 添加药店支持的剂型加工方式
 */
export const postV1StoreProcessing = (
  params: PostV1StoreProcessingRequestBody
): AxiosCancelablePromise<ApiData<PostV1StoreProcessingResponse>> => {
  return service.post(`/v1/storeProcessing`, params, { baseURL: baseUrl.node })
}

/**
 * 修改药店支持的剂型加工方式
 */
export const putV1StoreProcessingById = (
  id: number,
  params: PutV1StoreProcessingByIdRequestBody
): AxiosCancelablePromise<ApiData<PutV1StoreProcessingByIdResponse>> => {
  return service.put(`/v1/storeProcessing/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 删除药店支持的剂型加工方式
 */
export const deleteV1StoreProcessingById = (
  id: number,
  params: DeleteV1StoreProcessingByIdRequestBody
): AxiosCancelablePromise<ApiData<DeleteV1StoreProcessingByIdResponse>> => {
  return service.delete(`/v1/storeProcessing/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 查询 Spu
 */
export const getV1Spu = (
  params: GetV1SpuRequestParams
): AxiosCancelablePromise<ApiData<GetV1SpuResponse>> => {
  return service.get(`/v1/spu`, { params, baseURL: baseUrl.node })
}

/**
 * 检索SPU草稿列表
 */
export const getV1SpuDraft = (
  params: GetV1SpuDraftRequestParams
): AxiosCancelablePromise<ApiData<GetV1SpuDraftResponse>> => {
  return service.get(`/v1/spu/draft`, { params, baseURL: baseUrl.node })
}

/**
 * 检索spu
 */
export const getV1SpuById = (
  id: number,
  params?: {}
): AxiosCancelablePromise<ApiData<GetV1SpuByIdResponse>> => {
  return service.get(`/v1/spu/${id}`, { params, baseURL: baseUrl.node })
}

/**
 * 创建平台规则
 */
export const postV1SpuSaveRule = (
  params: PostV1SpuSaveRuleRequestBody
): AxiosCancelablePromise<ApiData<PostV1SpuSaveRuleResponse>> => {
  return service.post(`/v1/spu/saveRule`, params, { baseURL: baseUrl.node })
}

/**
 * 上架SKU
 */
export const postV1SpuPutawayById = (
  id: string,
  params: PostV1SpuPutawayByIdRequestBody
): AxiosCancelablePromise<ApiData<PostV1SpuPutawayByIdResponse>> => {
  return service.post(`/v1/spu/putaway/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 下载导入底价模板
 */
export const getV1SpuDownloadBatchAddTemplate = (params?: {}): AxiosCancelablePromise<ApiData<
  GetV1SpuDownloadBatchAddTemplateResponse
>> => {
  return service.get(`/v1/spu/download/batchAddTemplate`, { params, baseURL: baseUrl.node })
}

/**
 * 检索 Spu
 */
export const getV1SpuMachineById = (
  id: number,
  params?: {}
): AxiosCancelablePromise<ApiData<GetV1SpuMachineByIdResponse>> => {
  return service.get(`/v1/spuMachine/${id}`, { params, baseURL: baseUrl.node })
}

/**
 * 检索中药 Spu
 */
export const getV1SpuCnMedById = (
  id: number,
  params?: {}
): AxiosCancelablePromise<ApiData<GetV1SpuCnMedByIdResponse>> => {
  return service.get(`/v1/spuCnMed/${id}`, { params, baseURL: baseUrl.node })
}

/**
 * 检索 Spu
 */
export const getV1SpuMedById = (
  id: number,
  params?: {}
): AxiosCancelablePromise<ApiData<GetV1SpuMedByIdResponse>> => {
  return service.get(`/v1/spuMed/${id}`, { params, baseURL: baseUrl.node })
}

/**
 * 检索 Spu
 */
export const getV1SpuNutritionById = (
  id: number,
  params?: {}
): AxiosCancelablePromise<ApiData<GetV1SpuNutritionByIdResponse>> => {
  return service.get(`/v1/spuNutrition/${id}`, { params, baseURL: baseUrl.node })
}

/**
 * 检索 Spu
 */
export const getV1SpuCosmeticById = (
  id: number,
  params?: {}
): AxiosCancelablePromise<ApiData<GetV1SpuCosmeticByIdResponse>> => {
  return service.get(`/v1/spuCosmetic/${id}`, { params, baseURL: baseUrl.node })
}

/**
 * 检索 Spu
 */
export const getV1SpuLifeGoodById = (
  id: number,
  params?: {}
): AxiosCancelablePromise<ApiData<GetV1SpuLifeGoodsByIdResponse>> => {
  return service.get(`/v1/spuLifeGoods/${id}`, { params, baseURL: baseUrl.node })
}

/**
 * 搜索医生列表
 */
export const getV1Doctor = (
  params: GetV1DoctorRequestParams
): AxiosCancelablePromise<ApiData<GetV1DoctorResponse>> => {
  return service.get(`/v1/doctor`, { params, baseURL: baseUrl.node })
}

/**
 * 修改云药房医生折扣组
 */
export const getV1DiscountDiscount = (
  params: GetV1DiscountDiscountRequestParams
): AxiosCancelablePromise<ApiData<GetV1DiscountDiscountResponse>> => {
  return service.get(`/v1/discount/discount`, { params, baseURL: baseUrl.node })
}

/**
 * 新增云药房医生折扣组
 */
export const postV1DiscountDiscount = (
  params: PostV1DiscountDiscountRequestBody
): AxiosCancelablePromise<ApiData<PostV1DiscountDiscountResponse>> => {
  return service.post(`/v1/discount/discount`, params, { baseURL: baseUrl.node })
}

/**
 * 修改云药房医生折扣组
 */
export const putV1DiscountDiscountById = (
  id: number,
  params: PutV1DiscountDiscountByIdRequestBody
): AxiosCancelablePromise<ApiData<PutV1DiscountDiscountByIdResponse>> => {
  return service.put(`/v1/discount/discount/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 删除云药房医生折扣组
 */
export const deleteV1DiscountDiscountById = (
  id: number,
  params: DeleteV1DiscountDiscountByIdRequestBody
): AxiosCancelablePromise<ApiData<DeleteV1DiscountDiscountByIdResponse>> => {
  return service.delete(`/v1/discount/discount/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 查询云药房医生折扣组内医生列表信息
 */
export const getV1DiscountDoctor = (
  params: GetV1DiscountDoctorRequestParams
): AxiosCancelablePromise<ApiData<GetV1DiscountDoctorResponse>> => {
  return service.get(`/v1/discount/doctor`, { params, baseURL: baseUrl.node })
}

/**
 * 云药房医生折扣组添加医生
 */
export const postV1DiscountDoctor = (
  params: PostV1DiscountDoctorRequestBody
): AxiosCancelablePromise<ApiData<PostV1DiscountDoctorResponse>> => {
  return service.post(`/v1/discount/doctor`, params, { baseURL: baseUrl.node })
}

/**
 * 云药房医生折扣组删除医生
 */
export const deleteV1DiscountDoctor = (
  params: DeleteV1DiscountDoctorRequestBody
): AxiosCancelablePromise<ApiData<DeleteV1DiscountDoctorResponse>> => {
  return service.delete(`/v1/discount/doctor`, params, { baseURL: baseUrl.node })
}

/**
 * 查询所有医生列表信息
 */
export const getV1DiscountDoctorAll = (
  params: GetV1DiscountDoctorAllRequestParams
): AxiosCancelablePromise<ApiData<GetV1DiscountDoctorAllResponse>> => {
  return service.get(`/v1/discount/doctorAll`, { params, baseURL: baseUrl.node })
}

/**
 * 获取渠道供应商列表
 */
export const getV1SupplierChannel = (
  params: GetV1SupplierChannelRequestParams
): AxiosCancelablePromise<ApiData<GetV1SupplierChannelResponse>> => {
  return service.get(`/v1/supplierChannel`, { params, baseURL: baseUrl.node })
}

export const getV1BusinessChannel = (
  params: GetV1BusinessChannelRequestParams
): AxiosCancelablePromise<ApiData<GetV1BusinessChannelResponse>> => {
  return service.get(`/v1/businessChannel`, { params, baseURL: baseUrl.node })
}

export const getV1BusinessChannelChannel = (
  params: GetV1BusinessChannelChannelRequestParams
): AxiosCancelablePromise<ApiData<GetV1BusinessChannelChannelResponse>> => {
  return service.get(`/v1/businessChannel/channel`, { params, baseURL: baseUrl.node })
}

export const getV1Pack = (
  params: GetV1PackRequestParams
): AxiosCancelablePromise<ApiData<GetV1PackResponse>> => {
  return service.get(`/v1/pack`, { params, baseURL: baseUrl.node })
}

export const postV1Pack = (
  params: PostV1PackRequestBody
): AxiosCancelablePromise<ApiData<PostV1PackResponse>> => {
  return service.post(`/v1/pack`, params, { baseURL: baseUrl.node })
}

/**
 * 上架Pack
 */
export const postV1PackPutawayById = (
  id: string,
  params: PostV1PackPutawayByIdRequestBody
): AxiosCancelablePromise<ApiData<PostV1PackPutawayByIdResponse>> => {
  return service.post(`/v1/pack/putaway/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 查询Pack价格
 */
export const getV1PackPriceAndStock = (
  params: GetV1PackPriceAndStockRequestParams
): AxiosCancelablePromise<ApiData<GetV1PackPriceAndStockResponse>> => {
  return service.get(`/v1/pack/priceAndStock`, { params, baseURL: baseUrl.node })
}

/**
 * 获取订单列表
 */
export const getV1Order = (
  params: GetV1OrderRequestParams
): AxiosCancelablePromise<ApiData<GetV1OrderResponse>> => {
  return service.get(`/v1/order`, { params, baseURL: baseUrl.node })
}

/**
 * 电子监管码页面检索订单
 */
export const getV1OrderDetail = (
  params: GetV1OrderDetailRequestParams
): AxiosCancelablePromise<ApiData<GetV1OrderDetailResponse>> => {
  return service.get(`/v1/order/detail`, { params, baseURL: baseUrl.node })
}

/**
 * 查询是否有新增订单
 */
export const getV1OrderNew = (
  params: GetV1OrderNewRequestParams
): AxiosCancelablePromise<ApiData<GetV1OrderNewResponse>> => {
  return service.get(`/v1/order/new`, { params, baseURL: baseUrl.node })
}

/**
 * 检索订单
 */
export const getV1OrderById = (
  id: string,
  params?: {}
): AxiosCancelablePromise<ApiData<GetV1OrderByIdResponse>> => {
  return service.get(`/v1/order/${id}`, { params, baseURL: baseUrl.node })
}

/**
 * 获取订单列表
 */
export const getV1OrderRelateById = (
  id: string,
  params?: {}
): AxiosCancelablePromise<ApiData<GetV1OrderRelateByIdResponse>> => {
  return service.get(`/v1/order/relate/${id}`, { params, baseURL: baseUrl.node })
}

/**
 * 上传订单发货
 */
export const postV1OrderUpload = (
  params: PostV1OrderUploadRequestBody
): AxiosCancelablePromise<ApiData<PostV1OrderUploadResponse>> => {
  return service.post(`/v1/order/upload`, params, { baseURL: baseUrl.node })
}

/**
 * 扭转订单状态，包含收货、收款等一系列操作
 */
export const putV1OrderStatusById = (
  id: string,
  params: PutV1OrderStatusByIdRequestBody
): AxiosCancelablePromise<ApiData<PutV1OrderStatusByIdResponse>> => {
  return service.put(`/v1/order/status/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 修改订单备注
 */
export const putV1OrderRemarkById = (
  id: string,
  params: PutV1OrderRemarkByIdRequestBody
): AxiosCancelablePromise<ApiData<PutV1OrderRemarkByIdResponse>> => {
  return service.put(`/v1/order/remark/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 修改订单的收货地址
 */
export const putV1OrderAddressById = (
  id: string,
  params: PutV1OrderAddressByIdRequestBody
): AxiosCancelablePromise<ApiData<PutV1OrderAddressByIdResponse>> => {
  return service.put(`/v1/order/address/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 后台确认收货
 */
export const postV1OrderConfirmLogistic = (
  params: PostV1OrderConfirmLogisticRequestBody
): AxiosCancelablePromise<ApiData<PostV1OrderConfirmLogisticResponse>> => {
  return service.post(`/v1/order/confirmLogistic`, params, { baseURL: baseUrl.node })
}

/**
 * 推送到ERP
 */
export const postV1OrderPushToErp = (
  params: PostV1OrderPushToErpRequestBody
): AxiosCancelablePromise<ApiData<PostV1OrderPushToErpResponse>> => {
  return service.post(`/v1/order/pushToErp`, params, { baseURL: baseUrl.node })
}

/**
 * 查询优惠信息
 */
export const getV1OrderPromotionList = (
  id: string,
  params?: {}
): AxiosCancelablePromise<ApiData<GetV1OrderPromotionListResponse>> => {
  return service.get(`/v1/order/promotionList`, { params, baseURL: baseUrl.node })
}

/**
 * 下载物流信息模板
 */
export const getV1OrderDownloadJdExpressTemplate = (params?: {}): AxiosCancelablePromise<ApiData<
  GetV1OrderDownloadJdExpressTemplateResponse
>> => {
  return service.get(`/v1/order/download/jdExpressTemplate`, { params, baseURL: baseUrl.node })
}

/**
 * 后台确认收货
 */
export const postV1OrderSaveESupervisionCode = (
  params: PostV1OrderSaveESupervisionCodeRequestBody
): AxiosCancelablePromise<ApiData<PostV1OrderSaveESupervisionCodeResponse>> => {
  return service.post(`/v1/order/saveESupervisionCode`, params, { baseURL: baseUrl.node })
}

/**
 * 查询单个sku平均价
 */
export const postV1OrderGetAvgPriceOfSku = (
  params: PostV1OrderGetAvgPriceOfSkuRequestBody
): AxiosCancelablePromise<ApiData<PostV1OrderGetAvgPriceOfSkuResponse>> => {
  return service.post(`/v1/order/getAvgPriceOfSku`, params, { baseURL: baseUrl.node })
}

/**
 * 京东同城批量发货
 */
export const postV1OrderCityDistruction = (
  params: PostV1OrderCityDistructionRequestBody
): AxiosCancelablePromise<ApiData<PostV1OrderCityDistructionResponse>> => {
  return service.post(`/v1/order/cityDistruction`, params, { baseURL: baseUrl.node })
}

/**
 * 获取处方列表v2
 */
export const getV1Prescription = (
  params: GetV1PrescriptionRequestParams
): AxiosCancelablePromise<ApiData<GetV1PrescriptionResponse>> => {
  return service.get(`/v1/prescription`, { params, baseURL: baseUrl.node })
}

/**
 * 获取电子处方列表
 */
export const getV1PrescriptionElect = (
  params: GetV1PrescriptionElectRequestParams
): AxiosCancelablePromise<ApiData<GetV1PrescriptionElectResponse>> => {
  return service.get(`/v1/prescription/elect`, { params, baseURL: baseUrl.node })
}

/**
 * 获取电子处方详情--新版信息流接口
 */
export const getV1PrescriptionElectPrescriptById = (
  id: number,
  params?: {}
): AxiosCancelablePromise<ApiData<GetV1PrescriptionElectPrescriptByIdResponse>> => {
  return service.get(`/v1/prescription/electPrescript/${id}`, { params, baseURL: baseUrl.node })
}

/**
 * 获取电子处方详情--补方用
 */
export const getV1PrescriptionElectById = (
  id: string,
  params?: {}
): AxiosCancelablePromise<ApiData<GetV1PrescriptionElectByIdResponse>> => {
  return service.get(`/v1/prescription/elect/${id}`, { params, baseURL: baseUrl.node })
}

/**
 * 查询是否有新增处方
 */
export const getV1PrescriptionNew = (
  params: GetV1PrescriptionNewRequestParams
): AxiosCancelablePromise<ApiData<GetV1PrescriptionNewResponse>> => {
  return service.get(`/v1/prescription/new`, { params, baseURL: baseUrl.node })
}

/**
 * 查询诊断列表
 */
export const getV1PrescriptionIllness = (params?: {}): AxiosCancelablePromise<ApiData<
  GetV1PrescriptionIllnessResponse
>> => {
  return service.get(`/v1/prescription/illness`, { params, baseURL: baseUrl.node })
}

/**
 * 重新获取处方图片
 */
export const getV1PrescriptionReloadPrDoc = (
  params: GetV1PrescriptionReloadPrDocRequestParams
): AxiosCancelablePromise<ApiData<GetV1PrescriptionReloadPrDocResponse>> => {
  return service.get(`/v1/prescription/reloadPrDoc`, { params, baseURL: baseUrl.node })
}

/**
 * 检索处方（包含电子处方和纸质处方）
 */
export const getV1PrescriptionById = (
  id: number,
  params: GetV1PrescriptionByIdRequestParams
): AxiosCancelablePromise<ApiData<GetV1PrescriptionByIdResponse>> => {
  return service.get(`/v1/prescription/${id}`, { params, baseURL: baseUrl.node })
}

/**
 * 检索纸质处方（比检索处方给的信息更加详细）
 */
export const getV1PrescriptionPaperById = (
  id: number,
  params?: {}
): AxiosCancelablePromise<ApiData<GetV1PrescriptionPaperByIdResponse>> => {
  return service.get(`/v1/prescription/paper/${id}`, { params, baseURL: baseUrl.node })
}

/**
 * 药师审核
 */
export const putV1PrescriptionAuditById = (
  id: number,
  params: PutV1PrescriptionAuditByIdRequestBody
): AxiosCancelablePromise<ApiData<PutV1PrescriptionAuditByIdResponse>> => {
  return service.put(`/v1/prescription/audit/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 补方
 */
export const putV1PrescriptionConvertById = (
  id: number,
  params: PutV1PrescriptionConvertByIdRequestBody
): AxiosCancelablePromise<ApiData<PutV1PrescriptionConvertByIdResponse>> => {
  return service.put(`/v1/prescription/convert/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 查询隐秘日志列表
 */
export const getV1SecretLog = (
  params: GetV1SecretLogRequestParams
): AxiosCancelablePromise<ApiData<GetV1SecretLogResponse>> => {
  return service.get(`/v1/secret-log`, { params, baseURL: baseUrl.node })
}

/**
 * 推送到ERP
 */
export const postV1OrderErpPush = (
  params: PostV1OrderErpPushRequestBody
): AxiosCancelablePromise<ApiData<PostV1OrderErpPushResponse>> => {
  return service.post(`/v1/order-erp/push`, params, { baseURL: baseUrl.node })
}

/**
 * 获取订单推送状态
 */
export const getV1OrderErp = (
  params: GetV1OrderErpRequestParams
): AxiosCancelablePromise<ApiData<GetV1OrderErpResponse>> => {
  return service.get(`/v1/order-erp`, { params, baseURL: baseUrl.node })
}

/**
 * 查询退款单列表
 */
export const getV1Refund = (
  params: GetV1RefundRequestParams
): AxiosCancelablePromise<ApiData<GetV1RefundResponse>> => {
  return service.get(`/v1/refund`, { params, baseURL: baseUrl.node })
}

/**
 * 创建退款单
 */
export const postV1Refund = (
  params: PostV1RefundRequestBody
): AxiosCancelablePromise<ApiData<PostV1RefundResponse>> => {
  return service.post(`/v1/refund`, params, { baseURL: baseUrl.node })
}

/**
 * 检索退款单（实际调用的是订单检索）
 */
export const getV1RefundById = (
  id: string,
  params?: {}
): AxiosCancelablePromise<ApiData<GetV1RefundByIdResponse>> => {
  return service.get(`/v1/refund/${id}`, { params, baseURL: baseUrl.node })
}

/**
 * 重新发起退款
 */
export const putV1RefundById = (
  id: number,
  params?: {}
): AxiosCancelablePromise<ApiData<PutV1RefundByIdResponse>> => {
  return service.put(`/v1/refund/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 获取云药房用户列表
 */
export const getV1User = (
  params: GetV1UserRequestParams
): AxiosCancelablePromise<ApiData<GetV1UserResponse>> => {
  return service.get(`/v1/user`, { params, baseURL: baseUrl.node })
}

/**
 * 新增云药房用户
 */
export const postV1User = (
  params: PostV1UserRequestBody
): AxiosCancelablePromise<ApiData<PostV1UserResponse>> => {
  return service.post(`/v1/user`, params, { baseURL: baseUrl.node })
}

/**
 * 获取云药房用户详情
 */
export const getV1UserMe = (params?: {}): AxiosCancelablePromise<ApiData<GetV1UserMeResponse>> => {
  return service.get(`/v1/user/me`, { params, baseURL: baseUrl.node })
}

/**
 * 获取密码有效期
 */
export const getV1UserCheckPasswdIdenticalPhone = (params?: {}): AxiosCancelablePromise<ApiData<
  GetV1UserCheckPasswdIdenticalPhoneResponse
>> => {
  return service.get(`/v1/user/checkPasswdIdenticalPhone`, { params, baseURL: baseUrl.node })
}

/**
 * 获取云药房用户信息
 */
export const getV1UserInfo = (
  params: GetV1UserInfoRequestParams
): AxiosCancelablePromise<ApiData<GetV1UserInfoResponse>> => {
  return service.get(`/v1/user/info`, { params, baseURL: baseUrl.node })
}

/**
 * 校验密码正确性
 */
export const getV1UserCheckPasswordRight = (
  params: GetV1UserCheckPasswordRightRequestParams
): AxiosCancelablePromise<ApiData<GetV1UserCheckPasswordRightResponse>> => {
  return service.get(`/v1/user/checkPasswordRight`, { params, baseURL: baseUrl.node })
}

/**
 * 获取云药房用户详情
 */
export const getV1UserById = (
  id: number,
  params?: {}
): AxiosCancelablePromise<ApiData<GetV1UserByIdResponse>> => {
  return service.get(`/v1/user/${id}`, { params, baseURL: baseUrl.node })
}

/**
 * 新增校验云药房用户密码
 */
export const postV1UserCheckPassword = (
  params: PostV1UserCheckPasswordRequestBody
): AxiosCancelablePromise<ApiData<PostV1UserCheckPasswordResponse>> => {
  return service.post(`/v1/user/checkPassword`, params, { baseURL: baseUrl.node })
}

/**
 * 修改云药房用户个人信息
 */
export const putV1UserCpUpdateProfileById = (
  id: number,
  params: PutV1UserCpUpdateProfileByIdRequestBody
): AxiosCancelablePromise<ApiData<PutV1UserCpUpdateProfileByIdResponse>> => {
  return service.put(`/v1/user/cpUpdateProfile/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 修改云药房用户信息
 */
export const putV1UserCpUpdateMemberInfoById = (
  id: number,
  params: PutV1UserCpUpdateMemberInfoByIdRequestBody
): AxiosCancelablePromise<ApiData<PutV1UserCpUpdateMemberInfoByIdResponse>> => {
  return service.put(`/v1/user/cpUpdateMemberInfo/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 修改云药房用户状态
 */
export const putV1UserCpForbiddenMemberById = (
  id: number,
  params: PutV1UserCpForbiddenMemberByIdRequestBody
): AxiosCancelablePromise<ApiData<PutV1UserCpForbiddenMemberByIdResponse>> => {
  return service.put(`/v1/user/cpForbiddenMember/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 修改云药房用户状态
 */
export const postCloudPharmacyYwxSync = (id: number): AxiosCancelablePromise<ApiData<{}>> => {
  return service.post(
    `/user-interface/cloudPharmacy/ywx_sync`,
    { id },
    { baseURL: baseUrl.passportAPI }
  )
}

/**
 * 修改云药房用户密码
 */
export const putV1UserChangePassword = (
  params: PutV1UserChangePasswordRequestBody
): AxiosCancelablePromise<ApiData<PutV1UserChangePasswordResponse>> => {
  return service.put(`/v1/user/changePassword`, params, { baseURL: baseUrl.node })
}

/**
 * 忘记云药房用户密码
 */
export const putV1UserForgetPassword = (
  params: PutV1UserForgetPasswordRequestBody
): AxiosCancelablePromise<ApiData<PutV1UserForgetPasswordResponse>> => {
  return service.put(`/v1/user/forgetPassword`, params, { baseURL: baseUrl.node })
}

/**
 * 重置云药房用户密码
 */
export const putV1UserResetPassword = (
  params: PutV1UserResetPasswordRequestBody
): AxiosCancelablePromise<ApiData<PutV1UserResetPasswordResponse>> => {
  return service.put(`/v1/user/resetPassword`, params, { baseURL: baseUrl.node })
}

/**
 * 清理Cookie
 */
export const putV1UserClearCookie = (params?: {}): AxiosCancelablePromise<ApiData<
  PutV1UserClearCookieResponse
>> => {
  return service.put(`/v1/user/clearCookie`, params, { baseURL: baseUrl.node })
}

/**
 * 获取七牛云上传token
 */
export const postV1UserToken = (
  params: PostV1UserTokenRequestBody
): AxiosCancelablePromise<ApiData<PostV1UserTokenResponse>> => {
  return service.post(`/v1/user/token`, params, { baseURL: baseUrl.node })
}

/**
 * 获取物流列表
 */
export const getV1HospitalHospital = (
  params: GetV1HospitalHospitalRequestParams
): AxiosCancelablePromise<ApiData<GetV1HospitalHospitalResponse>> => {
  return service.get(`/v1/hospital/hospital`, { params, baseURL: baseUrl.node })
}

/**
 * 获取科室信息
 */
export const getV1HospitalSection = (
  params: GetV1HospitalSectionRequestParams
): AxiosCancelablePromise<ApiData<GetV1HospitalSectionResponse>> => {
  return service.get(`/v1/hospital/section`, { params, baseURL: baseUrl.node })
}

/**
 * 获取物流列表
 */
export const getV1Logistics = (
  params: GetV1LogisticsRequestParams
): AxiosCancelablePromise<ApiData<GetV1LogisticsResponse>> => {
  return service.get(`/v1/logistics`, { params, baseURL: baseUrl.node })
}

/**
 * 获取物流公司列表
 */
export const getV1LogisticsCompanyList = (params?: {}): AxiosCancelablePromise<ApiData<
  GetV1LogisticsCompanyListResponse
>> => {
  return service.get(`/v1/logistics/company/list`, { params, baseURL: baseUrl.node })
}

/**
 * 修改订单的物流公司及物流单号
 */
export const putV1LogisticsOrder = (
  params: PutV1LogisticsOrderRequestBody
): AxiosCancelablePromise<ApiData<PutV1LogisticsOrderResponse>> => {
  return service.put(`/v1/logistics/order`, params, { baseURL: baseUrl.node })
}

/**
 * 顺丰发货单打印
 */
export const postV1LogisticsPrint = (
  params: PostV1LogisticsPrintRequestBody
): AxiosCancelablePromise<ApiData<PostV1LogisticsPrintResponse>> => {
  return service.post(`/v1/logistics/print`, params, { baseURL: baseUrl.node })
}

/**
 * 京东发货单打印
 */
export const postV1LogisticsJdprint = (
  params: PostV1LogisticsJdprintRequestBody
): AxiosCancelablePromise<ApiData<PostV1LogisticsJdprintResponse>> => {
  return service.post(`/v1/logistics/jdprint`, params, { baseURL: baseUrl.node })
}

/**
 * 批量导入发货单
 */
export const postV1LogisticsDeliveryImport = (
  params: PostV1LogisticsDeliveryImportRequestBody
): AxiosCancelablePromise<ApiData<PostV1LogisticsDeliveryImportResponse>> => {
  return service.post(`/v1/logistics/delivery/import`, params, { baseURL: baseUrl.node })
}

/**
 * 批量发货
 */
export const postV1LogisticsDeliverySf = (
  params: PostV1LogisticsDeliverySfRequestBody
): AxiosCancelablePromise<ApiData<PostV1LogisticsDeliverySfResponse>> => {
  return service.post(`/v1/logistics/delivery/sf`, params, { baseURL: baseUrl.node })
}

export const postV1BachUpdateLogistics = (
  params: PostV1BachUpdateLogisticsBody
): AxiosCancelablePromise<ApiData<PostV1BachUpdateLogisticsResponse>> => {
  return service.post(`/v1/logistics/bachUpdateLogistics`, params, { baseURL: baseUrl.node })
}

/**
 * 下载失败数据
 */
export const postV1LogisticsUploadFailData = (
  params: PostV1LogisticsUploadFailDataRequestBody
): AxiosCancelablePromise<ApiData<PostV1LogisticsUploadFailDataResponse>> => {
  return service.post(`/v1/logistics/upload/failData`, params, { baseURL: baseUrl.node })
}

/**
 * 修改订单物流信息
 */
export const putV1LogisticsOrderLogisticsById = (
  id: string,
  params: PutV1LogisticsOrderLogisticsByIdRequestBody
): AxiosCancelablePromise<ApiData<PutV1LogisticsOrderLogisticsByIdResponse>> => {
  return service.put(`/v1/logistics/orderLogistics/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 发货
 */
export const postV1LogisticsOrderDeliver = (
  params: PostV1LogisticsOrderDeliverRequestBody
): AxiosCancelablePromise<ApiData<PostV1LogisticsOrderDeliverResponse>> => {
  return service.post(`/v1/logistics/orderDeliver`, params, { baseURL: baseUrl.node })
}

/**
 * 药店确认收货
 */
export const postV1LogisticsStoreConfirmReceiveById = (
  id: string,
  params?: {}
): AxiosCancelablePromise<ApiData<PostV1LogisticsStoreConfirmReceiveByIdResponse>> => {
  return service.post(`/v1/logistics/storeConfirmReceive/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 运费模板列表
 */
export const getV1FreightTemplate = (
  params: GetV1FreightTemplateRequestParams
): AxiosCancelablePromise<ApiData<GetV1FreightTemplateResponse>> => {
  return service.get(`/v1/freight/template`, { params, baseURL: baseUrl.node })
}

/**
 * 创建运费模板
 */
export const postV1FreightTemplate = (
  params: PostV1FreightTemplateRequestBody
): AxiosCancelablePromise<ApiData<PostV1FreightTemplateResponse>> => {
  return service.post(`/v1/freight/template`, params, { baseURL: baseUrl.node })
}

/**
 * 运费模板详情
 */
export const getV1FreightTemplateById = (
  id: string,
  params?: {}
): AxiosCancelablePromise<ApiData<GetV1FreightTemplateByIdResponse>> => {
  return service.get(`/v1/freight/template/${id}`, { params, baseURL: baseUrl.node })
}

/**
 * 修改运费模板
 */
export const putV1FreightTemplateById = (
  id: string,
  params: PutV1FreightTemplateByIdRequestBody
): AxiosCancelablePromise<ApiData<PutV1FreightTemplateByIdResponse>> => {
  return service.put(`/v1/freight/template/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 删除运费模板
 */
export const deleteV1FreightTemplateById = (
  id: string,
  params?: {}
): AxiosCancelablePromise<ApiData<DeleteV1FreightTemplateByIdResponse>> => {
  return service.delete(`/v1/freight/template/${id}`, params, { baseURL: baseUrl.node })
}

/**
 * 关联sku
 */
export const postV1FreightRelateSku = (
  params: PostV1FreightRelateSkuRequestBody
): AxiosCancelablePromise<ApiData<PostV1FreightRelateSkuResponse>> => {
  return service.post(`/v1/freight/relateSku`, params, { baseURL: baseUrl.node })
}

/**
 * 取消关联sku
 */
export const deleteV1FreightRelateSku = (
  params: DeleteV1FreightRelateSkuRequestBody
): AxiosCancelablePromise<ApiData<DeleteV1FreightRelateSkuResponse>> => {
  return service.delete(`/v1/freight/relateSku`, params, { baseURL: baseUrl.node })
}

/**
 * 查询配送区域
 */
export const getV1FreightRetrieveDelivery = (
  params: GetV1FreightRetrieveDeliveryRequestParams
): AxiosCancelablePromise<ApiData<GetV1FreightRetrieveDeliveryResponse>> => {
  return service.get(`/v1/freight/retrieveDelivery`, { params, baseURL: baseUrl.node })
}

/**
 * 查询默认物流公司
 */
export const getV1FreightTpl = (
  params: GetV1FreightTplRequestParams
): AxiosCancelablePromise<ApiData<GetV1FreightTplResponse>> => {
  return service.get(`/v1/freight/tpl`, { params, baseURL: baseUrl.node })
}

/**
 * 创建配送区域
 */
export const postV1FreightCreateDelivery = (
  params: PostV1FreightCreateDeliveryRequestBody
): AxiosCancelablePromise<ApiData<PostV1FreightCreateDeliveryResponse>> => {
  return service.post(`/v1/freight/createDelivery`, params, { baseURL: baseUrl.node })
}

/**
 * 查询结算单列表
 */
export const getV1Settlement = (
  params: GetV1SettlementRequestParams
): AxiosCancelablePromise<ApiData<GetV1SettlementResponse>> => {
  return service.get(`/v1/settlement`, { params, baseURL: baseUrl.node })
}

/**
 * 创建补方
 */
export const postV1ReinforcingPres = (
  params: PostV1ReinforcingPresRequestBody
): AxiosCancelablePromise<ApiData<PostV1ReinforcingPresResponse>> => {
  return service.post(`/v1/reinforcingPres`, params, { baseURL: baseUrl.node })
}

/**
 * 获取补方二维码
 */
export const getV1ReinforcingPresQr = (
  params: GetV1ReinforcingPresQrRequestParams
): AxiosCancelablePromise<ApiData<GetV1ReinforcingPresQrResponse>> => {
  return service.get(`/v1/reinforcingPres/qr`, { params, baseURL: baseUrl.node })
}

/**
 * 查询 通知 列表
 */
export const getV1WarningNotice = (
  params: GetV1WarningNoticeRequestParams
): AxiosCancelablePromise<ApiData<GetV1WarningNoticeResponse>> => {
  return service.get(`/v1/warning/notice`, { params, baseURL: baseUrl.node })
}

/**
 * 按 Id 查询 通知
 */
export const getV1WarningNoticeById = (
  id: string,
  params?: {}
): AxiosCancelablePromise<ApiData<GetV1WarningNoticeByIdResponse>> => {
  return service.get(`/v1/warning/notice/${id}`, { params, baseURL: baseUrl.node })
}

/**
 * 查询 Sku 库存预警 列表
 */
export const getV1WarningSku = (
  params: GetV1WarningSkuRequestParams
): AxiosCancelablePromise<ApiData<GetV1WarningSkuResponse>> => {
  return service.get(`/v1/warning/sku`, { params, baseURL: baseUrl.node })
}

/**
 * 设置库存预警
 */
export const putV1WarningSku = (
  params: PutV1WarningSkuRequestBody
): AxiosCancelablePromise<ApiData<PutV1WarningSkuResponse>> => {
  return service.put(`/v1/warning/sku`, params, { baseURL: baseUrl.node })
}

/**
 * 导出结算单
 */
export const getV1WarningSkuExport = (
  params: GetV1WarningSkuExportRequestParams
): AxiosCancelablePromise<ApiData<GetV1WarningSkuExportResponse>> => {
  return service.get(`/v1/warning/sku/export`, { params, baseURL: baseUrl.node })
}

/**
 * 获取税率分级类目
 */
export const getV1TaxClassificationCategories = (
  params: GetV1TaxClassificationCategoriesRequestPramas
): AxiosCancelablePromise<ApiData<GetV1TaxClassificationCategoriesResponse>> => {
  return service.get(`/medication-interface/v1/tax-category/paginate`, {
    params,
    baseURL: baseUrl.cloudPharmacyInterface,
  })
}

/**
 * 订单筛选，渠道名称获取
 */
export const getV1ChannelName = (
  params: GetV1ChannelNameRequestPramas
): AxiosCancelablePromise<ApiData<GetV1ChannelNameResponse>> => {
  return service.get(`/medication-interface/v1/supplierChannel`, {
    params,
    baseURL: baseUrl.cloudPharmacyInterface,
  })
}

export interface BatchUpdateMachineReq {
  data: {
    id: number
    machineInfos: {
      /**
       * 发货数量
       */
      batchQuantity: number;

      /**
      * 生产批号
      */
      batchNo?: string;

      /**
        * 序列号
        */
      sequenceNo?: string;

      /**
        * 有效期
        */
      shelfTime: number;
    }[]
  }[]
}

/**
 * 批量更新医疗器械基础信息
 */
export const batchUpdateMachine = (
  params: BatchUpdateMachineReq
): AxiosCancelablePromise<ApiData<any>> => {
  return service.put(`/v1/order/batchUpdateMachine`, params, {
    baseURL: baseUrl.node,
  })
}
